import * as i0 from '@angular/core';
import { Directive, Input, InjectionToken, Injectable, Inject, ViewContainerRef, ElementRef, HostListener, Component, EventEmitter, Output, Optional, ViewEncapsulation, ChangeDetectionStrategy, ViewChild, inject, Pipe, ViewChildren, NgModule } from '@angular/core';
import { of, from, Subject, combineLatest, map as map$1, firstValueFrom, filter as filter$1, Observable, merge, switchMap as switchMap$1, take as take$1, BehaviorSubject, takeUntil as takeUntil$1 } from 'rxjs';
import * as i1$3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1$7 from '@engineering11/web-api-firebase';
import { SubcollectionRepository, FirestoreQueryBuilder, OrderByDirection, CollectionRepository, CacheRepository } from '@engineering11/web-api-firebase';
import * as i1$2 from 'ngx-markdown';
import { MarkdownModule } from 'ngx-markdown';
import { arrayEqualsIgnoreOrder, createIdUnordered, groupByOrderedLocalDate, getInitials, sort, omit, isNotNil, isEqualById, isDeepEqual, isTrue, groupBy, updateObject, reverse, uuid, pick, hasChangedAny, throwIfNil } from '@engineering11/utility';
import { map, filter, switchMap, distinctUntilChanged, take, mergeMap, finalize, tap, takeUntil } from 'rxjs/operators';
import * as i1 from '@engineering11/web-api-error';
import { toE11Error, LOGGER_TOKEN, isE11Error, E11Logger, ERROR_TRACKER_TOKEN, e11Error } from '@engineering11/web-api-error';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import * as _ from 'lodash';
import { mapValues, max, orderBy, unescape as unescape$1 } from 'lodash';
import { RestApiClient } from '@engineering11/web-api-rest';
import * as i6 from '@engineering11/files-web';
import { VideoUrlBuilder } from '@engineering11/files-web';
import { __decorate, __param } from 'tslib';
import * as i6$1 from '@engineering11/ui-lib/e11-notifications';
import * as i3$3 from '@ngrx/component';
import { LetDirective, PushPipe } from '@ngrx/component';
import * as i1$4 from '@engineering11/web-utilities';
import { filterByKeys, FileMimeTypeIconTypes, fileToDataURL, mimeTypeIconMap, WebUtilityModule, trackById } from '@engineering11/web-utilities';
import * as i3$2 from '@engineering11/ui-lib/e11-divider';
import { E11DividerModule } from '@engineering11/ui-lib/e11-divider';
import * as i4$2 from 'ngx-infinite-scroll';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import * as i3$1 from '@engineering11/ui-lib/e11-directives';
import { E11DirectivesModule } from '@engineering11/ui-lib/e11-directives';
import * as i6$2 from '@engineering11/ui-lib/e11-confirmation';
import { E11ConfirmationModule } from '@engineering11/ui-lib/e11-confirmation';
import { E11ExternalLinkDirective, E11ExternalLinkModule } from '@engineering11/ui-lib/e11-external-link';
import * as i2 from '@engineering11/ui-lib/e11-tooltip';
import { E11TooltipModule } from '@engineering11/ui-lib/e11-tooltip';
import * as i2$1 from '@engineering11/ui-lib/e11-avatar';
import { E11AvatarModule } from '@engineering11/ui-lib/e11-avatar';
import * as i4 from '@engineering11/ui-lib/e11-loader-dots';
import { E11LoaderDotsModule } from '@engineering11/ui-lib/e11-loader-dots';
import * as i8 from '@engineering11/multimedia-web';
import { PlayerSize, MultimediaModule } from '@engineering11/multimedia-web';
import * as i1$5 from '@angular/platform-browser';
import * as i3 from '@engineering11/ui-lib/e11-modal';
import { E11ModalModule } from '@engineering11/ui-lib/e11-modal';
import * as i7 from '@engineering11/ui-lib/e11-file-viewer';
import { E11FileViewerModule } from '@engineering11/ui-lib/e11-file-viewer';
import * as i4$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { createEntityAdapter } from '@ngrx/entity';
import * as i1$6 from '@engineering11/ui-lib/e11-profile-pic';
import { E11ProfilePicModule } from '@engineering11/ui-lib/e11-profile-pic';
import * as i3$4 from '@engineering11/ui-lib/e11-panel';
import { E11PanelModule } from '@engineering11/ui-lib/e11-panel';
import * as i3$5 from '@angular/forms';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { E11AutocompleteModule } from '@engineering11/ui-lib/e11-autocomplete';
import * as i2$3 from '@engineering11/ui-lib/e11-badge';
import { E11BadgeModule } from '@engineering11/ui-lib/e11-badge';
import * as i2$2 from '@engineering11/ui-lib/e11-button';
import { E11ButtonModule } from '@engineering11/ui-lib/e11-button';
import { E11EmptyStateModule } from '@engineering11/ui-lib/e11-empty-state';
import * as i3$7 from '@engineering11/ui-lib/e11-icon';
import { E11IconModule } from '@engineering11/ui-lib/e11-icon';
import { E11ImageModule } from '@engineering11/ui-lib/e11-image';
import { E11ImageViewerModule } from '@engineering11/ui-lib/e11-image-viewer';
import * as i3$6 from '@engineering11/ui-lib/e11-indicator';
import { E11IndicatorModule } from '@engineering11/ui-lib/e11-indicator';
import { E11InputModule } from '@engineering11/ui-lib/e11-input';
import { E11InputCheckboxModule } from '@engineering11/ui-lib/e11-input-checkbox';
import { E11InputErrorsModule } from '@engineering11/ui-lib/e11-input-errors';
import { E11LoaderLineModule } from '@engineering11/ui-lib/e11-loader-line';
import { E11MarkdownEditorModule } from '@engineering11/ui-lib/e11-markdown-editor';
import { E11MultiSelectModule } from '@engineering11/ui-lib/e11-multi-select';
import * as i6$3 from '@engineering11/ui-lib/e11-nav-expander';
import { E11NavExpanderModule } from '@engineering11/ui-lib/e11-nav-expander';
import { E11PopoverModule } from '@engineering11/ui-lib/e11-popover';
import { E11SelectModule } from '@engineering11/ui-lib/e11-select';
import * as i5 from '@engineering11/ui-lib/e11-side-over';
import { E11SideOverModule, OVERLAY_DEFAULT_CONFIG } from '@engineering11/ui-lib/e11-side-over';
import { E11SwitchModule } from '@engineering11/ui-lib/e11-switch';
import { E11TabsModule } from '@engineering11/ui-lib/e11-tabs';
import { E11TextareaModule } from '@engineering11/ui-lib/e11-textarea';
import { E11VideoPlayerComponent } from '@engineering11/ui-lib/e11-video-player';
import * as i4$3 from '@engineering11/ui-lib/e11-ui-utils';

const UNREAD_CONVERSATIONS_LIMIT = 9; // The limit to the count we display
const CONVERSATION_DROPDOWN_COUNT = 5;
const CONVERSATION_NAV_COUNT = 5;
const DEFAULT_MESSAGE_PAGE_SIZE = 20;
const SDK_NAME = 'messaging';
const COLLECTIONS = Object.freeze({
    CONVERSATION: `${SDK_NAME}_conversation/`,
    MESSAGE: `/message/`,
    MESSAGE_DRAFT: `${SDK_NAME}_draft/`,
});
const ERROR_TYPES = Object.freeze({
    // WEB
    CONVERSATION_CONFIG_MISSING: `${SDK_NAME}/conversation-config-missing`,
    CUSTOM_DATA: `${SDK_NAME}/custom-data`,
    CONVERSATION_DISPLAY: `${SDK_NAME}/conversation-display`,
    CONVERSATION_MISSING: `${SDK_NAME}/conversation-missing`,
});
const CONVERSATION_TYPES = Object.freeze({
    DIRECT_MESSAGE: 'direct-message',
});
const DEFAULT_CONVERSATION_TYPE = CONVERSATION_TYPES.DIRECT_MESSAGE;
const REACTION_HOVER_LIMIT = 3;
const REACTION_PAGE_SIZE = 20;
const PENDING_MESSAGE_ID = '';
const MESSAGING_NOTIFICATION_IDS = Object.freeze({
    messaging_user_mentioned: 'messaging_user_mentioned',
});
const DEFAULT_MESSAGE_CONFIG = {
    canDeleteOwnMessages: false,
    canDeleteAllMessages: false,
    canEditOwnMessages: false,
    canReactOnMessages: true,
    canViewOwnReadReceipts: false,
    canViewAllReadReceipts: false,
    canDeleteConversation: false,
};

/**
 * Idea: Make message avatar clicking agnostic and let the parent handle what happens
 * Problem: positioning when doing anything like popovers
 */
class MessageAvatarClickHandlerDirective {
    constructor() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageAvatarClickHandlerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.9", type: MessageAvatarClickHandlerDirective, selector: "[messageAvatarClickHandler]", inputs: { messageAvatarClickHandler: "messageAvatarClickHandler" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageAvatarClickHandlerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[messageAvatarClickHandler]',
                }]
        }], ctorParameters: () => [], propDecorators: { messageAvatarClickHandler: [{
                type: Input
            }] } });

const MESSAGING_CONFIG = new InjectionToken('MessagingMappingConfig');
const CONVERSATION_CUSTOM_DATA_HANDLER = new InjectionToken('ConversationCustomDataHandler');
class MessageConfiguration {
}
// TODO: On breaking change, rename to BaseMessagingConfigProvider
class MessagingConfigurationProvider {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingConfigurationProvider, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingConfigurationProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingConfigurationProvider, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class DefaultLibConfiguration extends MessagingConfigurationProvider {
    get config() {
        // return default config
        return {
            baseUrl: '',
            baseRoute: '/',
            token$: of(null),
            userId$: of(),
            onConversationDeleteRoute: '/',
            messagingEditorConfig: {
                attachmentMaxFileSize: 100, // In MB
            },
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DefaultLibConfiguration, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DefaultLibConfiguration, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DefaultLibConfiguration, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
const APP_CONVERSATION_CONFIG_PROVIDER_TOKEN = new InjectionToken('APP_CONVERSATION_CONFIG_PROVIDER_TOKEN');

var MessageStatus;
(function (MessageStatus) {
    MessageStatus["Sent"] = "Sent";
    MessageStatus["Sending"] = "Sending";
    MessageStatus["Failed"] = "Failed";
    MessageStatus["FailedRetry"] = "FailedRetry";
})(MessageStatus || (MessageStatus = {}));
var ContextPlacement;
(function (ContextPlacement) {
    ContextPlacement["View"] = "view";
    ContextPlacement["Sideover"] = "sideover";
})(ContextPlacement || (ContextPlacement = {}));
// TODO: Consider whether this can be replaced with ContextPlacement: e.g.  Embedded = 'embedded',
var ConversationHeaderType;
(function (ConversationHeaderType) {
    ConversationHeaderType["None"] = "None";
    ConversationHeaderType["SideOver"] = "SideOver";
    ConversationHeaderType["Full"] = "Full";
})(ConversationHeaderType || (ConversationHeaderType = {}));
var ContextCommunicationType;
(function (ContextCommunicationType) {
    ContextCommunicationType["Community"] = "community";
    ContextCommunicationType["Conversation"] = "conversation";
})(ContextCommunicationType || (ContextCommunicationType = {}));
var MessageType;
(function (MessageType) {
    MessageType["Text"] = "text";
})(MessageType || (MessageType = {}));
const DEFAULT_MESSAGE_TYPE = MessageType.Text;
const messageReactionOptions = [
    {
        icon: 'thumb_up',
        emojiUnicode: '👍',
        htmlDec: '&#128077;',
    },
    {
        icon: 'thumb_down',
        emojiUnicode: '👎',
        htmlDec: '&#128078;',
    },
    {
        icon: 'sentiment_satisfied',
        emojiUnicode: '😀',
        htmlDec: '&#128512;',
    },
    {
        icon: 'mood_bad',
        emojiUnicode: '🙁',
        htmlDec: '&#128577;',
    },
    {
        icon: 'favorite',
        emojiUnicode: '❤',
        htmlDec: '&#10084;&#65039;',
    },
    {
        icon: 'close',
        emojiUnicode: 'U+1F600',
        htmlDec: '&#10006;&#65039;',
    },
];

// Filters should be named according
const openConversationFilter = (conversation) => !conversation.closed;
const unreadConversationFilter = (conversation) => conversation.latestIsUnread;

function conversationMatchesKeys(conversation, matchKeys) {
    const { type, recipients, membershipType, conversationKeys } = matchKeys;
    return (conversation.type === type &&
        arrayEqualsIgnoreOrder(conversation.conversationKeys ?? [], conversationKeys ?? []) &&
        conversation.membershipType == membershipType &&
        arrayEqualsIgnoreOrder(recipients, conversation.otherParticipants.map((v) => v.userId)));
}
function conversationIsUnread(conversation, userId) {
    return conversation.lastRead[userId]?.messageId === (conversation.latestMessage?.id ?? null);
}
function conversationLatestMessageDate(conversation) {
    const latestMessage = conversation.latestMessage;
    return latestMessage?.__createdAt ?? conversation.__createdAt;
}

/**
 * !WARNING DO NOT CHANGE!
 * this has the potential to cause conversations to no longer be found or at worst, break a feature so please do not mess with unless you have asked
 * several other people.
 *
 * @param keys
 */
const generateConversationId = (keys) => createIdUnordered(...keys);
function getMentionsFromText(text) {
    const ids = [];
    unescape(text).replace(/<@([a-zA-Z0-9]+)>/g, (match, group1) => {
        ids.push(group1);
        return '';
    });
    return ids;
}

// PURPOSE - exported from package and reused in other messaging systems (e.g. communities)
/**
 * Universal to messages, agnostic of conversation
 * ! this must remain agnostic of conversation
 * @param message
 * @param senderInformation
 * @param participantInformation - information needed for mentions or displaying reactions - may be fetched lazily if necessary
 * @returns
 */
function buildMessageVM(message, senderInformation, participantInformation) {
    const mentions = mapMentions(message.mentions || {}, participantInformation || {});
    return {
        ...message, // MUST be done so extensions of IMessage retain their data
        senderInformation,
        status: MessageStatus.Sent,
        type: message.type ?? DEFAULT_MESSAGE_TYPE,
        reactorInfo: participantInformation,
        mentions,
    };
}
function mapMentions(mentions, participantInformation) {
    return Object.keys(mentions).reduce((accumilatedMentions, nextMention) => ({
        ...accumilatedMentions,
        [nextMention]: {
            ...mentions[nextMention],
            ...(participantInformation[nextMention] || {}),
        },
    }), {});
}

/** Useful for preventing runtime UI errors if a participant is not found */
function getUnknownParticipantFallback(userId) {
    return {
        displayName: 'Unknown User',
        userId,
        profilePicture: null,
    };
}
/**
 * TODO: Consider a standard system profilePicture
 * @param userId required to not violate interface
 * @returns
 */
function getSystemParticipantFallback(userId) {
    return { displayName: 'System', profilePicture: null, userId };
}

// ! Package-private - put utils you need to export in message-vm.util.ts
/**
 * The conversion between the data model and view model for messages
 * Must contain conversation-specific logic for the conversion. Conversation-agnostic logic must live in @buildMessageVM
 */
class ConversationMessageVMService {
    constructor(configProvider) {
        this.configProvider = configProvider;
    }
    buildConversationMessageVMs(messages, conversation) {
        return messages.map((message) => this.buildConversationMessageVM(message, conversation));
    }
    buildConversationMessageVM(message, conversation) {
        const senderInformation = this.getSenderInformation(message, conversation);
        const messageVM = buildMessageVM(message, senderInformation, conversation.participantInformation);
        return messageVM;
    }
    getSenderInformation(message, conversation) {
        if (message.isSystemMessage) {
            const systemUserInfo = this.configProvider.config.systemUsers?.[message.senderId];
            // System messages can be on the behalf of an individual or from a configured system user
            return systemUserInfo ?? conversation.participantInformation[message.senderId] ?? getSystemParticipantFallback(message.senderId);
        }
        const senderInformation = conversation.participantInformation[message.senderId] ?? getUnknownParticipantFallback(message.senderId);
        return senderInformation;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationMessageVMService, deps: [{ token: MessagingConfigurationProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationMessageVMService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationMessageVMService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MessagingConfigurationProvider }] });
function groupMessageVMsByDate(messages) {
    const format = 'EEEE MMMM d, yyyy'; // e.g. Friday January 7, 2022
    return groupByOrderedLocalDate(messages, '__createdAt', { format });
}
/**
 * Pure function used to establish conversation display data fallbacks for before the conversation is created
 * e.g. fall back on the conversation name initials for the image fallback
 * @param displayData
 * @returns
 */
function getConversationDisplayFallbacks(displayData) {
    const conversationImageData = { textFallback: getInitials(displayData.conversationName), ...displayData.conversationImageData };
    const shortName = displayData.shortName ?? displayData.conversationName;
    return { ...displayData, shortName, conversationImageData };
}

const pathFn = (conversationId, messageId = '') => `${COLLECTIONS.CONVERSATION}${conversationId}${COLLECTIONS.MESSAGE}${messageId}`;
class MessageRepository extends SubcollectionRepository {
    constructor(messageVMService) {
        super();
        this.messageVMService = messageVMService;
        this.buildPath = pathFn;
    }
    getLatest(conversationId, clearHead) {
        const queryBuilder = new FirestoreQueryBuilder().orderBy('__createdAt', OrderByDirection.Desc).limit(1);
        if (clearHead) {
            queryBuilder.endAt(clearHead);
        }
        return this.query(queryBuilder.build(), conversationId).pipe(map((item) => item[0]));
    }
    /**
     * Gets messages ordered Asc by created date.
     * Asc because when you display messages, you display the earliest first
     *
     * @param conversationId
     * @returns
     */
    getAllOrderedValueChanges(conversationId, clearHead) {
        const queryBuilder = new FirestoreQueryBuilder().orderBy('__createdAt', OrderByDirection.Asc);
        if (clearHead) {
            queryBuilder.startAfter(clearHead);
        }
        return this.queryValueChanges(queryBuilder.build(), conversationId);
    }
    getScroller(conversation, pageSize = DEFAULT_MESSAGE_PAGE_SIZE) {
        const query = new FirestoreQueryBuilder().orderBy('__createdAt', OrderByDirection.Desc).limit(pageSize);
        return this.getInfiniteScrollWithTransform(query.build(), '__createdAt', OrderByDirection.Asc, (item) => this.messageVMService.buildConversationMessageVM(item, conversation), conversation.id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageRepository, deps: [{ token: ConversationMessageVMService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageRepository, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageRepository, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ConversationMessageVMService }] });

class ConversationRepository extends CollectionRepository {
    constructor() {
        super(...arguments);
        this.COLLECTION = COLLECTIONS.CONVERSATION;
    }
    getAllForUserValueChanges(userId) {
        const queryBuilder = new FirestoreQueryBuilder().where('participants', 'array-contains', userId).build();
        return this.queryValueChanges(queryBuilder);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationRepository, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationRepository, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationRepository, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/**
 * Should be extended to override conversation display data
 */
class BaseConversationCustomDataProvider {
    conversationCustomData(conversation) {
        return {
            conversationName: this.conversationName(conversation),
            shortName: this.conversationShortName(conversation),
            conversationSubtitle: this.conversationSubtitle(conversation),
            conversationImageData: this.conversationImageData(conversation),
        };
    }
    conversationName(conversation) {
        const otherNames = conversation.otherParticipants.filter(({ inConversation }) => inConversation).map((participant) => participant.displayName);
        const names = sort(otherNames, localeCompareFn).join(', ');
        if (conversation.closed)
            return `${names} (closed)`;
        return names;
    }
    conversationShortName(conversation) {
        const otherNames = conversation.otherParticipants.filter(({ inConversation }) => inConversation).map((participant) => participant.displayName);
        const names = sort(otherNames, localeCompareFn).join(', ');
        if (conversation.closed)
            return `${names} (closed)`;
        return names;
    }
    conversationSubtitle(conversation) {
        return '';
    }
    /**
     * The data needed by the conversation image
     * TODO: for group conversations, consider displaying a 'group' icon
     * @param conversation
     * @returns
     */
    conversationImageData(conversation) {
        if (conversation.closed)
            return { textFallback: '' };
        const firstParticipant = conversation.otherParticipants.filter(({ inConversation }) => inConversation)[0];
        return this.imageDataFromParticipant(firstParticipant);
    }
    /**
     * By default, returns what it's given without changes
     * Allows a client to customise the displayName or other display data used for all conversation participants
     * @param participantInfo
     * @returns
     */
    amendParticipantInformation(participantInfo, conversationType) {
        return participantInfo;
    }
    /**
     * A util to standardise how we get a conversation image from a participant
     * Primarily useful when the consuming app has a specific participant they want to highlight in the conversation image
     * @param participantInfo
     * @returns
     */
    imageDataFromParticipant(participantInfo) {
        return {
            imageUrl: participantInfo?.profilePicture ?? undefined,
            textFallback: participantInfo ? getInitials(participantInfo.displayName) : undefined,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseConversationCustomDataProvider, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseConversationCustomDataProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseConversationCustomDataProvider, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
const localeCompareFn = (a, b) => a.localeCompare(b);

class ConversationViewModelService {
    constructor(customDataHandler, defaultConversationDataProvider, messageVMService, errorHandler) {
        this.customDataHandler = customDataHandler;
        this.defaultConversationDataProvider = defaultConversationDataProvider;
        this.messageVMService = messageVMService;
        this.errorHandler = errorHandler;
    }
    buildConversationVMs(userId, conversations) {
        // Always handle errors in loops - one failing should not mean all fail
        return this.errorHandler.errorSafeMap(conversations, (conversation) => this.buildConversationVM(userId, conversation), conversationDisplayErrorData(userId));
    }
    buildConversationVM(userId, conversation) {
        const amendedConversation = this.amendAllParticipantInformation(conversation);
        const viewModelBeforeCustomData = this.buildConversationVMNoCustom(userId, amendedConversation);
        let customData = this.defaultConversationDataProvider.conversationCustomData(viewModelBeforeCustomData);
        // This fallback measure is worthwhile since failure in conversationCustomData can brick the entire messaging component and it could be blown apart with bad data
        try {
            customData = this.customDataHandler.conversationCustomData(viewModelBeforeCustomData);
        }
        catch (error) {
            const e11Error = conversationDataError(error, conversation);
            this.errorHandler.handleError(e11Error);
        }
        return { ...viewModelBeforeCustomData, ...customData };
    }
    amendAllParticipantInformation(conversation) {
        const { participantInformation } = conversation;
        // ! Always wrap custom methods in a try catch so errors happen gracefully
        try {
            const newConversation = {
                ...conversation,
                participantInformation: mapValues(participantInformation, (value) => this.customDataHandler.amendParticipantInformation(value, conversation.type)),
            };
            return newConversation;
        }
        catch (error) {
            const e11Error = conversationDataError(error, conversation);
            this.errorHandler.handleError(e11Error);
            return conversation;
        }
    }
    buildConversationVMNoCustom(currentUserId, conversation) {
        const participantInformationVm = this.allParticipantsToVMs(conversation.participantInformation, conversation.participants);
        const otherParticipantsObj = omit(participantInformationVm, currentUserId);
        const otherParticipants = Object.values(otherParticipantsObj);
        const latestMessage = conversation.latestMessage
            ? this.messageVMService.buildConversationMessageVM(conversation.latestMessage, conversation)
            : null;
        // Make sure it's not sent by current user to prevent unread-flashing bug
        const latestIsUnread = conversation.lastRead[currentUserId]?.messageId !== (conversation.latestMessage?.id ?? null) && latestMessage?.senderId !== currentUserId;
        return {
            ...conversation,
            participantInformation: participantInformationVm,
            otherParticipants,
            latestMessage,
            latestIsUnread,
            currentUserId,
            membershipType: conversation.membershipType ?? 'fixed', // TODO: remove when data is migrated
            type: conversation.type ?? DEFAULT_CONVERSATION_TYPE, // TODO: remove when data is migrated
            userClearHead: conversation.clearHead?.[currentUserId],
        };
    }
    allParticipantsToVMs(allParticipantInformation, activeParticipants) {
        return mapValues(allParticipantInformation, (value) => this.participantInformationToVm(value, activeParticipants));
    }
    participantInformationToVm(participantInformation, activeParticipants) {
        return { ...participantInformation, inConversation: activeParticipants.includes(participantInformation.userId) };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationViewModelService, deps: [{ token: CONVERSATION_CUSTOM_DATA_HANDLER }, { token: BaseConversationCustomDataProvider }, { token: ConversationMessageVMService }, { token: i1.E11ErrorHandlerService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationViewModelService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationViewModelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CONVERSATION_CUSTOM_DATA_HANDLER]
                }] }, { type: BaseConversationCustomDataProvider }, { type: ConversationMessageVMService }, { type: i1.E11ErrorHandlerService }] });
const conversationDataError = (error, conversation) => toE11Error(error, {
    type: ERROR_TYPES.CUSTOM_DATA,
    title: 'Error getting conversation data',
    message: 'Error getting conversation data',
    additionalData: { conversation },
});
const conversationDisplayErrorData = (userId) => (conversation) => ({
    type: ERROR_TYPES.CONVERSATION_DISPLAY,
    title: 'Error displaying conversation',
    message: `Error displaying conversation for user: ${userId}`,
    additionalData: { conversation, userId },
});

class ConversationService {
    constructor(libConfig, messageRepository, conversationRepository, conversationVMService, messageVMService, filesService, logger) {
        this.libConfig = libConfig;
        this.messageRepository = messageRepository;
        this.conversationRepository = conversationRepository;
        this.conversationVMService = conversationVMService;
        this.messageVMService = messageVMService;
        this.filesService = filesService;
        this.logger = logger;
        this.api = new RestApiClient({ token: libConfig.config.token$.pipe(filter(isNotNil)), baseUrl: libConfig.config.baseUrl });
    }
    startConversation(message) {
        return this.uploadAttachments({ attachments: message.attachments }).pipe(switchMap((fileReceipts) => this.api.post('conversations', { ...omit(message, 'attachments'), attachments: fileReceipts }).pipe(map((item) => item.data))));
    }
    hideConversation(conversationId) {
        return this.api.delete(`conversations/${conversationId}`);
    }
    /**
     * Orders by unread and then by newest message sent
     *
     * @param userId
     * @returns
     */
    getAllConversationVMsValueChanges(userId) {
        return this.getAllConversationsValueChanges(userId).pipe(map((conversations) => this.conversationVMService.buildConversationVMs(userId, conversations)));
    }
    /**
     * Orders by unread and then by newest message sent
     *
     * @param userId
     * @returns
     */
    getAllConversationsValueChanges(userId) {
        return this.conversationRepository.getAllForUserValueChanges(userId).pipe(map((conversations) => conversations.filter((conversation) => {
            const clearHead = conversation.clearHead?.[userId];
            if (clearHead && conversation.latestMessage) {
                return conversation.latestMessage.id !== clearHead;
            }
            return true;
        })), map((conversations) => this.orderConversationsByLatestMessage(conversations)));
    }
    /**
     * Useful for displaying the count of unread conversations
     *
     * @param userId
     * @returns
     */
    getUnreadConversationCount(userId) {
        return this.getUnreadConversations(userId).pipe(map((unreadConversations) => unreadConversations.length));
    }
    sendMessage(messageRequest) {
        const { conversationId, text, confirmationId, attachments } = messageRequest;
        return this.uploadAttachments({ attachments, groupingId: conversationId }).pipe(switchMap((fileReceipts) => this.api
            .post(`conversations/${conversationId}/messages`, { text, confirmationId, attachments: fileReceipts })
            .pipe(map((item) => item.data))));
    }
    uploadAttachments(request) {
        const { attachments, groupingId } = request;
        if (!attachments?.length)
            return of([]);
        return from(this.filesService.uploadFiles({ files: attachments, groupingId, makePublic: true }));
    }
    /**
     * Delete a public file if you have a permission and then check if the message is attachment only.
     *
     * The backend will determine whether the message should be deleted or updated with the new list of attachments.
     * If the message has any text or there are any attachments remaining after the deletion,
     * the message is updated with the new list of attachments. Otherwise, the message is deleted.
     * @param request RemoveAttachmentRequest
     * @returns
     */
    deleteAttachment(request) {
        const { text, id: messageId, conversationId, attachments } = request.message;
        const { id: attachmentId } = request.attachment;
        const newAttachments = attachments.filter((file) => file.id !== attachmentId);
        return this.api.put(`conversations/${conversationId}/messages/${messageId}`, { text: text, attachments: newAttachments });
    }
    /**
     * Doesn't require you to specify a conversationId or start a conversation. Simply send a message to the given recipients.
     * Only applies to fixed membership conversations
     *
     */
    directMessageRecipients(request) {
        const { conversationKeys, conversationType, creationClientMetadata, recipientIds: recipients, message: text } = request;
        return this.api
            .post(`conversations/messages`, { text, recipients, conversationKeys, conversationType, creationClientMetadata })
            .pipe(map((response) => response.data));
    }
    editMessage(conversationId, messageId, newText) {
        return this.api.put(`conversations/${conversationId}/messages/${messageId}`, { text: newText });
    }
    deleteMessage(conversationId, messageId) {
        return this.api.delete(`conversations/${conversationId}/messages/${messageId}`);
    }
    reactToMessage(conversationId, messageId, reactionId) {
        return this.api.put(`conversations/${conversationId}/messages/${messageId}/reactions/${reactionId}`, {});
    }
    deleteReaction(conversationId, messageId, reactionId) {
        return this.api.delete(`conversations/${conversationId}/messages/${messageId}/reactions/${reactionId}`);
    }
    /**
     * TODO: Consider switching to "mark messageId as read for conversation"
     * TODO: Consider running a transaction
     * TODO: Examine whether this is cause of unread counter bug
     * @param conversationId
     * @param userId
     * @returns
     */
    async markLatestAsRead(conversationId, userId) {
        const conversation = await this.conversationRepository.get(conversationId).toPromise();
        if (!conversation) {
            throw new Error(`Conversation ${conversationId} not found`);
        }
        if (!conversation.latestMessage || conversation.latestMessage.id === conversation.lastRead[userId]?.messageId) {
            return;
        }
        return this.setLastReadForUser(userId, conversation.latestMessage);
    }
    /**
     *
     * @param userId
     * @param latestMessage must truly be the latest message the user has read
     * @returns
     */
    async setLastReadForUser(userId, latestMessage) {
        if (latestMessage.senderId === userId)
            return of(); // Backend marks messages you send as lastRead for you
        const conversationId = latestMessage.conversationId;
        const lastReadKey = `lastRead.${userId}`;
        // ? Consider storing object instead of the ID, incl senderId, readTimestamp, __createdAt - lastRead indicators with timestamps
        const unreadCountKey = `unreadCount.${userId}`;
        return this.conversationRepository.update({
            id: conversationId,
            [lastReadKey]: { messageId: latestMessage.id, timestamp: new Date() },
            [unreadCountKey]: 0,
        });
    }
    getAllMessageVMsValueChanges(conversation) {
        return this.getAllMessagesValueChanges(conversation.id).pipe(map((messages) => this.messageVMService.buildConversationMessageVMs(messages, conversation)));
    }
    /**
     *
     * @param conversationId
     * @returns
     */
    getAllMessagesValueChanges(conversationId) {
        return this.messageRepository.getAllOrderedValueChanges(conversationId);
    }
    /**
     *
     * ! Only applies to fixed membershipType
     * Fetches the conversation between the given participants and uses it to fetch the messages for that conversation.
     * Prefer @getAllMessagesValueChanges if you have the conversationId on hand as this must listen to the user's conversations under the covers.
     *
     * @param userId
     * @param conversationKeys
     * @returns
     */
    getMessageVMsForConversationKeysValueChanges(userId, ...conversationKeys) {
        return this.getConversationForConversationKeysValueChanges(userId, ...conversationKeys).pipe(distinctUntilChanged(isEqualById), // We don't want to re-emit & re-read just because conversation details have changed.
        switchMap((conversation) => (conversation?.id ? this.getAllMessageVMsValueChanges(conversation) : of([]))));
    }
    /**
     *
     * Fetches the conversation between the given participants and uses it to fetch the messages for that conversation.
     * Prefer @getAllMessagesValueChanges if you have the conversationId on hand as this must listen to the user's conversations under the covers.
     *
     * @param userId
     * @param conversationKeys - A list of participant ids and other string keys used
     * @returns
     * @deprecated use getMessageVMsForParticipantsValueChanges
     */
    getMessagesForConversationKeysValueChanges(userId, ...conversationKeys) {
        return this.getConversationForConversationKeysValueChanges(userId, ...conversationKeys).pipe(distinctUntilChanged(isEqualById), // We don't want to re-emit & re-read just because conversation details have changed.
        switchMap((conversation) => (conversation?.id ? this.getAllMessagesValueChanges(conversation?.id) : of([]))));
    }
    getMessageScrollerForConversation(conversation, pageSize = DEFAULT_MESSAGE_PAGE_SIZE) {
        return this.messageRepository.getScroller(conversation, pageSize);
    }
    /**
     * Gets the conversation where all participantIds provided are participants in the conversation
     * NOTE: Requires as many reads as the user has conversations
     *
     * @param userId the user making the request
     * @param conversationKeys the other participants in the conversation with the user
     * @returns
     */
    getConversationForConversationKeysValueChanges(userId, ...conversationKeys) {
        return this.conversationRepository.get(generateConversationId([userId, ...conversationKeys]));
    }
    /**
     * Does an in-memory filter of conversations to only return unread conversations
     * Can be made public if ever needed by a real use case
     *
     * @param userId
     * @returns
     */
    getUnreadConversations(userId) {
        return this.getAllConversationsValueChanges(userId).pipe(map((conversations) => conversations.filter((conversation) => conversation.lastRead[userId]?.messageId !== (conversation.latestMessage?.id ?? null))));
    }
    orderConversationsByLatestMessage(conversations) {
        return _.orderBy(conversations, (item) => conversationLatestMessageDate(item), ['desc']);
    }
    orderConversationsByUnreadThenNewestMessage(userId, conversations) {
        return _.orderBy(conversations, [(item) => conversationIsUnread(item, userId), (item) => conversationLatestMessageDate(item)], ['asc', 'desc']);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationService, deps: [{ token: MessagingConfigurationProvider }, { token: MessageRepository }, { token: ConversationRepository }, { token: ConversationViewModelService }, { token: ConversationMessageVMService }, { token: i6.FilesService }, { token: LOGGER_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MessagingConfigurationProvider }, { type: MessageRepository }, { type: ConversationRepository }, { type: ConversationViewModelService }, { type: ConversationMessageVMService }, { type: i6.FilesService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }] });

var CommunitySettingsPage;
(function (CommunitySettingsPage) {
    CommunitySettingsPage["Display"] = "display";
    CommunitySettingsPage["Members"] = "members";
    CommunitySettingsPage["Channels"] = "channels";
    CommunitySettingsPage["Roles"] = "roles";
})(CommunitySettingsPage || (CommunitySettingsPage = {}));
var CommunitiesMainPage;
(function (CommunitiesMainPage) {
    CommunitiesMainPage["Create"] = "create";
    CommunitiesMainPage["List"] = "list";
    CommunitiesMainPage["Search"] = "search";
})(CommunitiesMainPage || (CommunitiesMainPage = {}));
/**
 * Default navigation for messaging
 * ! This is for default low-level navigation within the messaging SDK - if your app configures its own navigation, use @MessagingOperationService.navigateToConversationFromId
 * TODO: remove community navigation
 */
class MessagingNavigationService {
    constructor(libConfig, router) {
        this.libConfig = libConfig;
        this.router = router;
    }
    conversation(conversationId) {
        this.router.navigate([this.libConfig.config.baseRoute, 'messaging', 'conversation', conversationId]);
    }
    newConversation() {
        this.router.navigate([this.libConfig.config.baseRoute, 'messaging', 'new-conversation']);
    }
    community(communityId, queryParams) {
        this.router.navigate([this.libConfig.config.baseRoute, 'messaging', 'community', communityId], { queryParams });
    }
    communities(queryParams) {
        this.router.navigate([this.libConfig.config.baseRoute, 'messaging', 'communities'], { queryParams });
    }
    navigateAfterConversationDelete() {
        this.router.navigate([this.libConfig.config.onConversationDeleteRoute]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingNavigationService, deps: [{ token: MessagingConfigurationProvider }, { token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingNavigationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingNavigationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MessagingConfigurationProvider }, { type: i1$1.Router }] });

const initialState$1 = {
    conversationsLoaded: false,
    error: null,
    conversations: null,
    conversationStarter: null,
    currentConversationId: null,
    startingConversation: false,
};
class ConversationStore extends ComponentStore {
    constructor(conversationService, libConfig, logger, errorHandler, messagingNavigationService) {
        super(initialState$1);
        this.conversationService = conversationService;
        this.libConfig = libConfig;
        this.logger = logger;
        this.errorHandler = errorHandler;
        this.messagingNavigationService = messagingNavigationService;
        this.userId$ = this.libConfig.config.userId$.pipe(filter(isNotNil));
        // SELECTORS
        this.getState = this.select((s) => s);
        this.getConversations = this.select((s) => s.conversations);
        this.getNewConversationStarter = this.select((s) => s.conversationStarter);
        this.currentConversationId$ = this.select((s) => s.currentConversationId);
        this.getConversation = (conversationId) => this.select((s) => s.conversations?.find((conversation) => conversation.id === conversationId));
        this.getCurrentUserInfoForConversation = (conversationId) => this.select(this.getConversation(conversationId), (conversation) => conversation?.participantInformation[conversation.currentUserId]);
        this.getConversationsLoaded = this.select((s) => s.conversationsLoaded);
        this.getStartingConversation = this.select((s) => s.startingConversation);
        this.getUnreadConversations = this.select(this.userId$, this.getConversations, (userId, conversations) => {
            if (!conversations || !userId)
                return null;
            return conversations.filter((conversation) => conversation.latestIsUnread);
        });
        this.getUnreadConversationCount = this.getUnreadConversations.pipe(map((conversations) => conversations?.length || 0), distinctUntilChanged());
        /**
         *
         * @deprecated use getUnreadConversationCountForQuery
         */
        this.getUnreadConversationCountForType = (type) => this.getUnreadConversations.pipe(map((conversations) => conversations?.filter((conversation) => conversation.type === type || !type)?.length || 0), distinctUntilChanged());
        this.getUnreadConversationCountForQuery = (query) => this.select(this.queryConversations(query), (conversations) => conversations?.filter(unreadConversationFilter)?.length ?? 0);
        this.getLatestConversations = (latestCount) => this.getConversations.pipe(map((conversations) => conversations?.slice(0, latestCount) ?? null), distinctUntilChanged(isDeepEqual));
        this.getConversationMatchingKeys = (matchData) => {
            const matchingConversation$ = this.select((s) => s.conversations?.find((conversation) => conversationMatchesKeys(conversation, matchData)));
            const conversationsLoaded$ = this.getConversationsLoaded; // Ensures we wait until conversations have loaded first
            return conversationsLoaded$.pipe(filter(isTrue), switchMap((_) => matchingConversation$), take(1) // Otherwise this re-emits on every state change. If re-emission is needed, add this line to every existing subscriber of getConversationMatchingRequest to prevent bugs
            );
        };
        /**
         * TODO: on next breaking, delete
         * @param latestCount
         * @param type filter to get only these conversations. If undefined, returns ALL conversations
         * @returns
         * @deprecated use queryConversations
         */
        this.getLatestConversationsOfType = (latestCount, type, conversationFilter) => {
            const customFilterFn = conversationFilter ?? ((_) => true);
            const typeFilterFn = (conversation) => conversation.type === type || !type;
            return this.getConversations.pipe(map((conversations) => conversations?.filter((conversation) => typeFilterFn(conversation) && customFilterFn(conversation))?.slice(0, latestCount) ?? null), distinctUntilChanged(isDeepEqual));
        };
        /**
         * TODO: on next breaking, delete
         * @param latestCount
         * @param type filter to get only these conversations. If undefined, returns ALL conversations
         * @returns
         * @deprecated use queryConversations
         */
        this.getLatestConversationsOfTypes = (latestCount, types, conversationFilter) => {
            const customFilterFn = conversationFilter ?? ((_) => true);
            const typeFilterFn = (conversation) => !types || types.includes(conversation.type ?? DEFAULT_CONVERSATION_TYPE);
            return this.getConversations.pipe(map((conversations) => conversations?.filter((conversation) => typeFilterFn(conversation) && customFilterFn(conversation))?.slice(0, latestCount) ?? null), distinctUntilChanged(isDeepEqual));
        };
        this.queryConversations = (query) => this.select(this.getConversations, (conversations) => {
            const { customFilter: conversationFilter, types, limit } = query;
            const customFilterFn = conversationFilter ?? ((_) => true);
            const typeFilterFn = (conversation) => !types || types.includes(conversation.type ?? DEFAULT_CONVERSATION_TYPE);
            return conversations?.filter((conversation) => typeFilterFn(conversation) && customFilterFn(conversation))?.slice(0, limit) ?? null;
        });
        /**
         * @deprecated use queryConversationsGrouped
         */
        this.getConversationsGrouped = (groupFn, types, customFilter) => this.select(this.queryConversations({ types, customFilter }), (conversations) => {
            if (!conversations)
                return null;
            const groupedObj = groupBy(conversations, this.errorSafeGroupFn(groupFn));
            const entries = Object.entries(groupedObj);
            const getLatestMessageDate = (conversations) => max(conversations.map(conversationLatestMessageDate));
            const sortedEntries = orderBy(entries, (entry) => getLatestMessageDate(entry[1]), 'desc');
            return sortedEntries;
        });
        this.queryConversationsGrouped = (query) => this.select(this.queryConversations(query), (conversations) => {
            const { groupFn, groupNameFn, groupSubtitleFn } = query;
            if (!conversations)
                return null;
            const groupedObj = groupBy(conversations, this.errorSafeGroupFn(groupFn));
            const groupItems = Object.entries(groupedObj).map((entry) => ({
                id: entry[0],
                groupName: groupNameFn ? groupNameFn(entry[1][0]) : entry[0],
                groupSubtitle: groupSubtitleFn ? groupSubtitleFn(entry[1][0]) : '',
                conversations: entry[1],
            }));
            const getLatestMessageDate = (conversations) => max(conversations.map(conversationLatestMessageDate));
            const sortedItems = orderBy(groupItems, (item) => getLatestMessageDate(item.conversations), 'desc');
            return sortedItems;
        });
        // ! only applies to DMs
        this.getConversationByRecipientsAndKeys = (recipientIds, conversationKeys) => {
            const allConversationKeys$ = this.userId$.pipe(map((userId) => [userId, ...recipientIds, ...conversationKeys]), distinctUntilChanged());
            return allConversationKeys$.pipe(switchMap((allConversationKeys) => this.getConversationByConversationKeys(allConversationKeys)));
        };
        this.getConversationByConversationKeys = (conversationKeys) => this.select(this.getConversations, (conversations) => this.findConversationByConversationKeys(conversationKeys, conversations));
        this.hasNotification$ = this.select(this.getConversations, (conversations) => conversations?.some((conversation) => conversation.latestIsUnread) ?? false);
        // EFFECTS
        this.onListenAllConversations = this.effect((userId$) => userId$.pipe(switchMap((id) => this.conversationService.getAllConversationVMsValueChanges(id).pipe(tapResponse((conversations) => this.onConversationsChanged(conversations), (e) => this.errorHandler.handleError(e))))));
        this.onStartConversationAndRoute = this.effect((newConversationRequest$) => newConversationRequest$.pipe(mergeMap((conversationRequest) => {
            this.setStartingConversation(true);
            return this.conversationService.startConversation(conversationRequest).pipe(tapResponse((response) => {
                this.logger.log('conversation created: ', response);
                this.clearNewConversationStarter();
                this.messagingNavigationService.conversation(response.id);
            }, (e) => this.errorHandler.handleError(e)), finalize(() => this.setStartingConversation(false)));
        })));
        this.onStartConversation = this.effect((newConversationRequest$) => newConversationRequest$.pipe(mergeMap((conversationRequest) => {
            this.setStartingConversation(true);
            return this.conversationService.startConversation(conversationRequest).pipe(tapResponse((response) => this.logger.log('conversation created: ', response), (e) => this.errorHandler.handleError(e, { alertUser: true })), finalize(() => this.setStartingConversation(false)));
        })));
        this.onStartConversationWithRoute = this.effect((newConversationRequest$) => newConversationRequest$.pipe(mergeMap((conversationRequest) => {
            this.setStartingConversation(true);
            return this.conversationService.startConversation(conversationRequest).pipe(tapResponse((conversation) => {
                this.setStartingConversation(false);
                this.logger.log('conversation created: ', conversation);
                this.messagingNavigationService.conversation(conversation.id);
            }, (e) => this.errorHandler.handleError(e, { alertUser: true })), finalize(() => this.setStartingConversation(false)));
        })));
        this.onDeleteConversation = this.effect((conversation$) => conversation$.pipe(tap((conversation) => this.logger.log('Deleting conversation: ', conversation.id)), mergeMap((conversation) => this.conversationService.hideConversation(conversation.id).pipe(tapResponse((response) => {
            this.messagingNavigationService.navigateAfterConversationDelete();
            this.logger.log('conversation cleared', response);
        }, (e) => this.errorHandler.handleError(e))))));
        // UPDATERS
        // Conversations
        this.setConversationStarter = this.updater((state, newConversationStarter) => ({
            ...state,
            conversationStarter: newConversationStarter,
        }));
        this.clearNewConversationStarter = this.updater((state) => ({ ...state, conversationStarter: null }));
        this.setCurrentConversationId = this.updater((state, currentConversationId) => ({
            ...state,
            currentConversationId,
        }));
        this.onConversationsChanged = this.updater((state, conversations) => ({
            ...state,
            conversations,
            conversationsLoaded: true,
        }));
        this.setStartingConversation = this.updater((state, startingConversation) => ({ ...state, startingConversation }));
        this.libConfig.config.userId$.pipe(filter(isNotNil)).subscribe((userId) => {
            this.onListenAllConversations(userId);
        });
    }
    // ! Only applies to DMs
    findConversationByConversationKeys(conversationKeys, conversations) {
        const id = generateConversationId(conversationKeys);
        return conversations?.find((conversation) => conversation.id === id);
    }
    errorSafeGroupFn(groupFn) {
        return (obj) => {
            try {
                return groupFn(obj);
            }
            catch (err) {
                this.errorHandler.handleError(err); // ? Could throw a great number of errors and clog up rollbar... Consider another way?
                return 'Ungrouped'; // Fallback in the event the given groupFn cannot return without erroring
            }
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationStore, deps: [{ token: ConversationService }, { token: MessagingConfigurationProvider }, { token: LOGGER_TOKEN }, { token: i1.E11ErrorHandlerService }, { token: MessagingNavigationService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ConversationService }, { type: MessagingConfigurationProvider }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }, { type: i1.E11ErrorHandlerService }, { type: MessagingNavigationService }] });

const messageFailedNotification = (errorData) => ({
    title: 'Message Could Not Send',
    message: errorData?.title ?? 'Our engineers have been notified and are looking into the issue.',
    type: 'danger',
    autoClose: false,
    ctaText: 'Close',
    dismissOnRouteChange: true,
});

let BaseMessageStore = class BaseMessageStore extends ComponentStore {
    constructor(logger) {
        super({
            channelMessagesMap: {},
            messagesLoading: false,
            moreMessagesLoading: false,
        });
        this.logger = logger;
        // SELECTORS
        this.getState = this.select((s) => s);
        this.messagesLoading$ = this.select((s) => s.messagesLoading);
        this.moreMessagesLoading$ = this.select((s) => s.moreMessagesLoading);
        this.getMessagesByChannelId = (channelId) => this.select(({ channelMessagesMap }) => getViewMessagesFromData(channelMessagesMap[channelId]));
        this.hasFetchedAllForChannelId = (channelId) => this.select(({ channelMessagesMap }) => channelMessagesMap[channelId]?.allMessagesFetched ?? false);
        // EFFECTS
        /**
         * Must be dispatched by class using this store
         * NEED: listenChannelMessages, sendMessage, markMessageRead
         */
        // UPDATERS
        this.setMessagesLoading = this.updater((state) => ({ ...state, messagesLoading: true }));
        this.setMoreMessagesLoading = this.updater((state) => ({ ...state, moreMessagesLoading: true }));
        this.onChannelMessagesChanged = this.updater((state, channelMessagesData) => {
            const currentMessageData = state.channelMessagesMap[channelMessagesData.channelId];
            // ? Could determine new messages here and use it to update pending messages?
            const pendingMessages = filterPendingMessages(currentMessageData?.pendingMessages ?? [], channelMessagesData.messages);
            return {
                ...state,
                messagesLoading: false,
                moreMessagesLoading: false,
                channelMessagesMap: {
                    ...state.channelMessagesMap,
                    [channelMessagesData.channelId]: { ...channelMessagesData, pendingMessages },
                },
            };
        });
        this.addPendingMessage = this.updater((state, pendingMessage) => {
            this.logger.debug('BaseMessageStore addPendingMessage', pendingMessage);
            const currentMessageData = state.channelMessagesMap[pendingMessage.conversationId];
            const currentPendingMessages = currentMessageData.pendingMessages ?? [];
            const pendingMessages = [...currentPendingMessages, pendingMessage];
            const channelMessagesData = { ...currentMessageData, pendingMessages };
            return {
                ...state,
                channelMessagesMap: { ...state.channelMessagesMap, [channelMessagesData.channelId]: channelMessagesData },
            };
        });
        this.markMessageFailed = this.updater((state, messageRequest) => {
            this.logger.log('MARKING MESSAGE FAILED', messageRequest);
            const currentMessageData = state.channelMessagesMap[messageRequest.conversationId];
            const currentPendingMessages = currentMessageData.pendingMessages ?? [];
            const pendingMessages = updateObject((message) => message.confirmationId === messageRequest.confirmationId, { status: messageRequest.failedStatus }, currentPendingMessages);
            this.logger.log('pendingMessages', pendingMessages);
            const channelMessagesData = { ...currentMessageData, pendingMessages };
            return {
                ...state,
                channelMessagesMap: { ...state.channelMessagesMap, [channelMessagesData.channelId]: channelMessagesData },
            };
        });
        this.removePendingMessage = this.updater((state, removeRequest) => {
            const currentMessageData = state.channelMessagesMap[removeRequest.conversationId];
            const currentPendingMessages = currentMessageData.pendingMessages ?? [];
            const pendingMessages = currentPendingMessages.filter((message) => message.confirmationId !== removeRequest.confirmationId);
            const channelMessagesData = { ...currentMessageData, pendingMessages };
            return {
                ...state,
                channelMessagesMap: { ...state.channelMessagesMap, [channelMessagesData.channelId]: channelMessagesData },
            };
        });
        this.updateMessage = this.updater((state, messageData) => {
            const currentMessageData = state.channelMessagesMap[messageData.conversationId];
            const currentMessages = currentMessageData.messages ?? [];
            const messages = updateObject((message) => message.id === messageData.id, messageData, currentMessages);
            const channelMessagesData = { ...currentMessageData, messages };
            return { ...state, channelMessagesMap: { ...state.channelMessagesMap, [channelMessagesData.channelId]: channelMessagesData } };
        });
    }
};
BaseMessageStore = __decorate([
    __param(0, Inject(LOGGER_TOKEN))
], BaseMessageStore);
// Utils
/**
 * TODO: unit test
 * @param pendingMessages
 * @param messages MUST be in chronological order
 * @returns
 */
function filterPendingMessages(pendingMessages, messages) {
    return pendingMessages?.filter((pendingMessage) => !shouldRemovePendingMessage(pendingMessage, messages)) ?? [];
}
function shouldRemovePendingMessage(pendingMessage, messages) {
    // return messages.some(message => message.confirmationId === pendingMessage.confirmationId) // Trivial but inefficient solution
    const reversedMessages = reverse(messages);
    const pendingMessageCreateTime = pendingMessage.__createdAt.getTime();
    const FILTER_BUFFER_MS = 5000;
    for (const message of reversedMessages) {
        if (message.confirmationId === pendingMessage.confirmationId)
            return true;
        if (message.__createdAt.getTime() < pendingMessageCreateTime - FILTER_BUFFER_MS)
            return false; // only search messages sent AFTER pendingMessage, with a small buffer to prevent false filters
    }
    return false;
}
/**
 * Convenience util to help selectors get messages to display for a channel
 * @param channelMessageData
 * @returns messages and pending messages to display to user
 */
function getViewMessagesFromData(channelMessageData) {
    if (!channelMessageData)
        return [];
    return channelMessageData.messages.concat(channelMessageData.pendingMessages ?? []);
}

/**
 * A concrete implementation of MessageStore for conversations - community and any future entities which use messages will need to write their own implementations
 */
class ConversationMessageStore extends BaseMessageStore {
    constructor(libConfig, logger, errorHandler, conversationService, conversationStore, // conversations are sometimes needed to get or build messages
    messagingNavigationService, notificationService) {
        super(logger);
        this.libConfig = libConfig;
        this.errorHandler = errorHandler;
        this.conversationService = conversationService;
        this.conversationStore = conversationStore;
        this.messagingNavigationService = messagingNavigationService;
        this.notificationService = notificationService;
        this.userId$ = this.libConfig.config.userId$.pipe(filter(isNotNil));
        this.messagesClosed$ = new Subject();
        this.recipientsDirectMessaged$ = new Subject();
        // SELECTORS - found in BaseMessageStore
        // EFFECTS
        this.onListenConversationMessages = this.effect((conversation$) => conversation$.pipe(switchMap((conversation) => {
            // ! Can only listen to one conversation's messages at once
            this.setMessagesLoading();
            this.conversationStore.setCurrentConversationId(conversation.id);
            this.messageInfiniteScroller = this.conversationService.getMessageScrollerForConversation(conversation);
            const userClearHead = conversation.userClearHead;
            return this.messageInfiniteScroller.items.pipe(takeUntil(this.messagesClosed$), // when you close messages, we don't want to mark them as read or listen to them
            // distinctUntilChanged<IMessageVM[]>(isDeepEqual),
            map((messages) => filterClearedMessages(messages, userClearHead)), tapResponse(({ messages, clearHeadReached }) => {
                const latestMessage = messages[messages.length - 1];
                if (latestMessage) {
                    this.onMarkMessageAsRead(latestMessage);
                }
                const allMessagesFetched = clearHeadReached || (this.messageInfiniteScroller?.done ?? false) || messages.length < DEFAULT_MESSAGE_PAGE_SIZE;
                this.logger.log('loaded messages', { messages, allMessagesFetched });
                return this.onChannelMessagesChanged({ channelId: conversation.id, messages, allMessagesFetched });
            }, (e) => this.errorHandler.handleError(e)));
        })));
        this.onGetMoreMessages = this.effect((_$) => _$.pipe(switchMap((_) => {
            this.logger.log('fetching more messages');
            this.setMoreMessagesLoading();
            this.messageInfiniteScroller?.more();
            return of(true);
        })));
        this.onCloseMessages = this.effect((_$) => _$.pipe(tap((_) => this.conversationStore.setCurrentConversationId(null)), map((_) => this.messagesClosed$.next(true))));
        /**
         * TODO: Consider fetching conversation and checking if message is already lastRead for user and skipping the update operation
         */
        this.onMarkMessageAsRead = this.effect((message$) => combineLatest([message$, this.userId$]).pipe(switchMap(([message, userId]) => from(this.conversationService.setLastReadForUser(userId, message)).pipe(tapResponse((response) => this.logger.log('message marked as read', message), (e) => this.errorHandler.handleError(e))))));
        this.onSendMessage = this.effect((messageRequest$) => messageRequest$.pipe(
        // mergeMap necessary to ensure all sent messages go through
        mergeMap((messageRequest) => {
            const messageRequestToSend = { confirmationId: uuid(), __createdAt: new Date(), ...messageRequest };
            this.setMessagePending(messageRequestToSend);
            // upload ... state based on status
            return this.conversationService.sendMessage(messageRequestToSend).pipe(tapResponse((response) => this.logger.log('message sent: ', response), (e) => {
                const failedStatus = isRetryableError(e) ? MessageStatus.FailedRetry : MessageStatus.Failed;
                this.markMessageFailed({ ...messageRequestToSend, failedStatus });
                this.handleFailedToSendError(e);
            }));
        })));
        this.onRetryMessage = this.effect((retryRequest) => retryRequest.pipe(tap((retryRequest) => {
            this.removePendingMessage(retryRequest);
            this.onSendMessage(retryRequest);
        })));
        this.setMessagePending = this.effect((messageRequest$) => messageRequest$.pipe(mergeMap((messageRequest) => this.conversationStore.getConversation(messageRequest.conversationId).pipe(filter(isNotNil), take(1), mergeMap((conversation) => this.conversationStore.getCurrentUserInfoForConversation(messageRequest.conversationId).pipe(filter(isNotNil), take(1), map((senderInformation) => {
            const participantIds = getMentionsFromText(messageRequest.text);
            messageRequest.mentions = participantIds.reduce((acc, nxt) => ({ ...acc, [nxt]: { userId: nxt } }), {});
            const messageVM = buildPendingMessage(messageRequest, senderInformation, conversation);
            return this.addPendingMessage(messageVM);
        })))))));
        /**
         * Only for DMs (fixed participant conversations)
         */
        this.onDirectMessageRecipients = this.effect((messageRequest$) => messageRequest$.pipe(mergeMap((messageRequest) => {
            const { conversationKeys, conversationType: type, recipientIds: recipients, message } = messageRequest;
            const participantIds = getMentionsFromText(message);
            const mentions = participantIds.reduce((acc, nxt) => ({ ...acc, [nxt]: { userId: nxt } }), {});
            const conversation$ = this.conversationStore
                .getConversationMatchingKeys({ recipients, conversationKeys, type, membershipType: 'fixed' })
                .pipe(take(1));
            return conversation$.pipe(tap((conversation) => {
                const newConversationRequest = {
                    type,
                    membershipType: 'fixed',
                    recipients,
                    conversationKeys,
                    initialMessage: message,
                    creationClientMetadata: messageRequest.creationClientMetadata,
                    attachments: messageRequest.attachments,
                };
                if (conversation)
                    this.onSendMessage({ text: messageRequest.message, conversationId: conversation.id, attachments: messageRequest.attachments, mentions });
                else
                    this.conversationStore.onStartConversation(newConversationRequest);
            }));
        })));
        this.onEditMessage = this.effect((editRequest$) => editRequest$.pipe(mergeMap((editRequest) => {
            return this.conversationService.editMessage(editRequest.conversationId, editRequest.messageId, editRequest.message).pipe(tapResponse((response) => this.logger.log('ConversationMessageStore - message edited: ', response), (e) => this.errorHandler.handleError(e, { alertUser: true })));
        })));
        this.onDeleteMessage = this.effect((deleteRequest$) => {
            return deleteRequest$.pipe(mergeMap((deleteRequest) => {
                const { confirmationId, conversationId, messageId } = deleteRequest;
                if (confirmationId)
                    this.removePendingMessage({ confirmationId, conversationId }); // May get run on regular delete, but should be fine
                if (messageId === PENDING_MESSAGE_ID)
                    return of(); // Do not call the endpoint for deleting a pending message
                return this.conversationService.deleteMessage(conversationId, messageId);
            }), tapResponse((response) => this.logger.log('ConversationMessageStore - message deleted: ', response), (e) => this.errorHandler.handleError(e, { alertUser: true })));
        });
        this.onDeleteAttachment = this.effect((deleteAttachmentRequest$) => {
            return deleteAttachmentRequest$.pipe(mergeMap((deleteAttachmentRequest) => this.conversationService.deleteAttachment(deleteAttachmentRequest).pipe(tapResponse((response) => this.logger.log('ConversationMessageStore - message deleted: ', response), (e) => this.errorHandler.handleError(e, { alertUser: true })))));
        });
        this.onReactToMessage = this.effect((reactRequest$) => reactRequest$.pipe(mergeMap((request) => this.conversationService.reactToMessage(request.conversationId, request.messageId, request.reaction))));
        this.onDeleteReaction = this.effect((reactRequest$) => reactRequest$.pipe(mergeMap((request) => this.conversationService.deleteReaction(request.conversationId, request.messageId, request.reaction))));
        // readonly onUploadAttachments = this.effect((messageRequest$: Observable<Omit<MessageRequest, 'confirmationId'>>) => {
        //   return messageRequest$.pipe(
        //     mergeMap((messageRequest) => {
        //       const messageRequestToSend = { ...messageRequest, confirmationId: uuidv4() }
        //       return this.conversationService.uploadAttachments(messageRequest.attachments as File[], messageRequest.conversationId, messageRequest.conversationId)
        //        .pipe(
        //         tapResponse(
        //           (attachments) => this.onSendMessage({
        //             ...messageRequest,
        //             attachments
        //           }),
        //           (e: Error) => {
        //             this.errorHandler.handleError(e)
        //             this.markMessageFailed(messageRequestToSend)
        //           }
        //           )
        //        )
        //     })
        //   )
        // })
        this.onGetOrStartConversationWithRoute = this.effect((conversationStarter$) => conversationStarter$.pipe(switchMap((conversationStarter) => {
            return this.conversationStore.getConversationMatchingKeys(conversationStarter).pipe(tapResponse((conversation) => {
                const { initialMessage } = conversationStarter;
                if (conversation) {
                    this.logger.log('MessagingStore: navigating to conversation from starter: ', { conversation, conversationStarter });
                    if (initialMessage)
                        this.onSendMessage({ conversationId: conversation.id, text: initialMessage, attachments: [], mentions: {} });
                    return this.messagingNavigationService.conversation(conversation.id);
                }
                else if (initialMessage) {
                    this.logger.log('MessagingStore: starting new conversation with initial message: ', conversationStarter);
                    return this.conversationStore.onStartConversationWithRoute(conversationStarter);
                }
                else {
                    this.logger.log('MessagingStore: opening new conversation: ', conversationStarter);
                    this.conversationStore.setConversationStarter(conversationStarter);
                    return this.messagingNavigationService.newConversation();
                }
            }, (e) => this.errorHandler.handleError(e)));
        })));
    }
    handleFailedToSendError(e) {
        this.errorHandler.handleError(e);
        // ? Do we want to force a notification on message failure?
        if (isE11Error(e))
            this.notificationService.popNotificationMessage(messageFailedNotification(e.errorData));
        else
            this.notificationService.popNotificationMessage(messageFailedNotification());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationMessageStore, deps: [{ token: MessagingConfigurationProvider }, { token: LOGGER_TOKEN }, { token: i1.E11ErrorHandlerService }, { token: ConversationService }, { token: ConversationStore }, { token: MessagingNavigationService }, { token: i6$1.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationMessageStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationMessageStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: MessagingConfigurationProvider }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }, { type: i1.E11ErrorHandlerService }, { type: ConversationService }, { type: ConversationStore }, { type: MessagingNavigationService }, { type: i6$1.E11NotificationsService }] });
function buildPendingMessage(messageRequest, senderInformation, conversation) {
    const mentions = mapMentions(messageRequest.mentions || {}, conversation.participantInformation || {});
    return {
        ...messageRequest,
        id: PENDING_MESSAGE_ID,
        status: MessageStatus.Sending,
        senderInformation,
        senderId: senderInformation.userId,
        __createdAt: messageRequest.__createdAt ?? new Date(), // Date should be set beforehand to prevent race condition where message is saved before pending message is built
        __updatedAt: messageRequest.__createdAt ?? new Date(),
        type: DEFAULT_MESSAGE_TYPE,
        edited: false,
        conversationType: conversation.type ?? DEFAULT_CONVERSATION_TYPE,
        mentions,
    };
}
function filterClearedMessages(messages, clearHead) {
    if (!clearHead)
        return { messages, clearHeadReached: false };
    const readHeadIndex = messages.findIndex((item) => item.id === clearHead);
    if (readHeadIndex === -1) {
        return { messages, clearHeadReached: false };
    }
    return { messages: messages.slice(readHeadIndex + 1), clearHeadReached: true };
}
/**
 * Errors that aren't known bad requests can be retried
 * @param e
 * @returns
 */
function isRetryableError(e) {
    if (!isE11Error(e))
        return true;
    if (e.errorData.statusCode !== 400)
        return true;
    return false;
}

function getAutocompleteFn(participantInformation = {}) {
    return (query) => new Promise((resolve, reject) => {
        setTimeout(() => {
            const autocompleteOptions = Object.values(participantInformation)
                .filter((val) => !val.isDisabled)
                .map((val) => ({
                name: val.displayName,
                id: val.userId,
                email: val.userId,
            }));
            const suggestions = filterByKeys(query, autocompleteOptions, ['name']);
            resolve(suggestions);
        }, 10);
    });
}

// Provides default behaviour that can be overridden by a concrete class
class BaseConversationConfigProvider {
    constructor(messagingNavigationService) {
        this.messagingNavigationService = messagingNavigationService;
    }
    getConfig() {
        return {
            canEditOwnMessages: true,
            canDeleteOwnMessages: true,
            canReactOnMessages: true,
            canDeleteConversation: true,
        };
    }
    onConversationClick(conversation) {
        this.messagingNavigationService.conversation(conversation.id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseConversationConfigProvider, deps: [{ token: MessagingNavigationService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseConversationConfigProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseConversationConfigProvider, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MessagingNavigationService }] });
class DefaultConversationConfigProvider extends BaseConversationConfigProvider {
    constructor() {
        super(...arguments);
        this.conversationType = DEFAULT_CONVERSATION_TYPE;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DefaultConversationConfigProvider, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DefaultConversationConfigProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DefaultConversationConfigProvider, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class ConversationConfigProviderFactory {
    constructor(providers, defaultProvider, errorHandlerService) {
        this.defaultProvider = defaultProvider;
        this.errorHandlerService = errorHandlerService;
        this.providerMap = new Map();
        providers.forEach((provider) => this.providerMap.set(provider.conversationType, provider));
    }
    getProviderForConversationConfig(conversationType) {
        const provider = this.providerMap.get(conversationType);
        if (!provider) {
            this.errorHandlerService.error(`No conversation config provider found for type ${conversationType}`);
            return this.defaultProvider; // Must provide a sensible default in case a data issue causes us to have an invalid conversationType
        }
        return provider;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationConfigProviderFactory, deps: [{ token: APP_CONVERSATION_CONFIG_PROVIDER_TOKEN }, { token: DefaultConversationConfigProvider }, { token: i1.E11ErrorHandlerService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationConfigProviderFactory, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationConfigProviderFactory, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APP_CONVERSATION_CONFIG_PROVIDER_TOKEN]
                }] }, { type: DefaultConversationConfigProvider }, { type: i1.E11ErrorHandlerService }] });

class ConversationConfigService {
    constructor(factory) {
        this.factory = factory;
    }
    getConfig(conversationType) {
        return this.factory.getProviderForConversationConfig(conversationType).getConfig();
    }
    onConversationClick(conversation) {
        const provider = this.factory.getProviderForConversationConfig(conversation.type ?? DEFAULT_CONVERSATION_TYPE);
        provider.onConversationClick(conversation);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationConfigService, deps: [{ token: ConversationConfigProviderFactory }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationConfigService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationConfigService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ConversationConfigProviderFactory }] });

/**
 * Utility class to get the last read information for messages
 */
class LastReadUtil {
    /**
     *
     * @param {IMessageReadReceiptsInfoArgs} param - The arguments to get the last read information
     * @returns {IMessagesReadReceipts | undefined} - The last read information for the messages
     */
    static getLastMessageReadInfo({ lastRead, messages, currentUserId, participantsInfo, readReceiptsConfig, }) {
        // Return undefined or the read receipt info for each message
        return messages.reduce((acc, message) => {
            const { id: messageId, senderId: senderUserId } = message;
            /**
             * Checks if the current user can view the read receipts for the message
             * - If the current user is the sender and the message config allows viewing own read receipts
             * - Or if the message config allows viewing all read receipts
             */
            if (!this.canViewReceipts(readReceiptsConfig, currentUserId, senderUserId))
                return acc;
            /**
             * Get the read information for the message
             * - Filter out the current user and the sender (We don't include them in the read receipts list)
             * - Get the user display name and the timestamp of the read
             */
            const readByInfo = this.getReadInfo({
                lastRead,
                messageId,
                participantsInfo,
                currentUserId,
                senderUserId,
            });
            const participantCount = Object.keys(participantsInfo).length;
            acc[messageId] = {
                readByInfo,
                /**
                 * We don't show the read receipts if there is no participant info other than the sender and the current user
                 * - This means either all the participants read the message
                 * - Or no one read the message (Other than the sender and the current user)
                 */
                show: readByInfo.length > 0,
                title: this.getReadByTitle(readByInfo),
                messageType: participantCount > 2 ? 'group' : 'direct',
            };
            return acc;
        }, {});
    }
    /**
     *
     * @param {IReadByInfo[]} readBy - The read information
     * @param {string} prefix - The prefix to add to the read information title
     * @param {number} limit - The limit to preview the participants who read the message
     * @returns
     */
    static getReadByTitle(readByInfo, limit = 2) {
        return readByInfo.length > limit
            ? `${this.constructUserNames(readByInfo.slice(0, limit))} + ${readByInfo.length - limit} more`
            : readByInfo.length > 0
                ? `${this.constructUserNames(readByInfo)}`
                : undefined;
    }
    static constructUserNames(readByInfo) {
        return readByInfo.map((r) => r.userDisplayName).join(', ');
    }
    /**
     *
     * @param {IReadReceiptsConfig | undefined} readReceiptsConfig - The read receipts configuration
     * @param {string} currentUserId - The current user id
     * @param {string} senderUserId - The sender user id
     * @returns
     */
    static canViewReceipts(readReceiptsConfig, currentUserId, senderUserId) {
        const { canViewOwnReadReceipts = false, canViewAllReadReceipts = false } = readReceiptsConfig ?? {};
        return currentUserId === senderUserId ? canViewOwnReadReceipts || canViewAllReadReceipts : canViewAllReadReceipts;
    }
    /**
     *
     * @param param0
     * @returns
     */
    static getReadInfo({ lastRead, messageId, participantsInfo, currentUserId, senderUserId, }) {
        return (Object.entries(lastRead)
            /**
             * Filter out the read history for the message
             */
            .filter(([_, readHistory]) => readHistory?.messageId === messageId)
            /**
             * Filter out the current user and the sender
             */
            .filter(([userId]) => userId !== currentUserId && userId !== senderUserId)
            .map(([userId, readHistory]) => ({
            userId,
            timestamp: readHistory?.timestamp,
            userDisplayName: participantsInfo?.[userId]?.displayName || 'Unknown',
        })));
    }
}

const style = (id, userId) => id == userId ? 'e11-bg-skin-primary e11-text-white e11-p-1 e11-rounded-md' : 'prosemirror-mention-node ';
const replaceMentionHelper = (id, userId, mentions) => {
    return `<span data-mention-id="${id}" data-mention-name="${mentions && mentions[id] ? mentions[id].displayName : ''}" data-mention-email="${id}" class="${style(id, userId)}" contenteditable="false">@${mentions && mentions[id] ? mentions[id].displayName : id}</span>`;
};
const linkHelper = (href, _title, text) => {
    return `<a href="${href}" title="${href}" target="_blank">${text}</a>`;
};

/**
 * Directive to handle click events on markdown elements
 */
class MarkdownClickDirective {
    constructor(appRef) {
        this.appRef = appRef;
    }
    onClick($event) {
        const target = $event.target;
        // Handle <a href> elements
        if (target instanceof HTMLAnchorElement) {
            $event.preventDefault();
            this.handleAnchorElement($event, target);
            return;
        }
        // handle more elements here
    }
    async handleAnchorElement(event, target) {
        const rootViewContainerRef = this.appRef.components[0].injector.get(ViewContainerRef);
        const directive = new E11ExternalLinkDirective(rootViewContainerRef, new ElementRef(target));
        directive.onClick(event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MarkdownClickDirective, deps: [{ token: i0.ApplicationRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.9", type: MarkdownClickDirective, selector: "[markdownClickHandler]", host: { listeners: { "click": "onClick($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MarkdownClickDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[markdownClickHandler]',
                }]
        }], ctorParameters: () => [{ type: i0.ApplicationRef }], propDecorators: { onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class UIMessageMarkdownComponent {
    constructor(markdownService) {
        this.markdownService = markdownService;
        this.parseMentions = (text) => {
            return `${unescape$1(text).replace(/<@([a-zA-Z0-9]+)>/g, (match, group1) => replaceMentionHelper(group1, this.userId, this.message.mentions))}`;
        };
    }
    ngOnChanges(changes) {
        // Make markdown links open in a new tab
        this.markdownService.renderer.link = linkHelper;
        this.markdownService.renderer.text = this.parseMentions;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIMessageMarkdownComponent, deps: [{ token: i1$2.MarkdownService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UIMessageMarkdownComponent, selector: "ui-message-markdown", inputs: { message: "message", userId: "userId" }, usesOnChanges: true, ngImport: i0, template: ` <markdown className="markdown-element" markdownClickHandler ngPreserveWhitespaces emoji [data]="message.text"></markdown>`, isInline: true, styles: [":host ::ng-deep pre{word-wrap:break-word;white-space:pre-wrap}:host ::ng-deep pre{background-color:inherit;border-radius:0;margin:0;max-height:unset;padding:0;width:auto}:host ::ng-deep ol li,:host ::ng-deep ul li{margin-bottom:unset!important}\n"], dependencies: [{ kind: "component", type: i1$2.MarkdownComponent, selector: "markdown, [markdown]", inputs: ["data", "src", "emoji", "katex", "katexOptions", "lineHighlight", "line", "lineOffset", "lineNumbers", "start"], outputs: ["error", "load", "ready"] }, { kind: "directive", type: MarkdownClickDirective, selector: "[markdownClickHandler]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIMessageMarkdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ui-message-markdown', template: ` <markdown className="markdown-element" markdownClickHandler ngPreserveWhitespaces emoji [data]="message.text"></markdown>`, styles: [":host ::ng-deep pre{word-wrap:break-word;white-space:pre-wrap}:host ::ng-deep pre{background-color:inherit;border-radius:0;margin:0;max-height:unset;padding:0;width:auto}:host ::ng-deep ol li,:host ::ng-deep ul li{margin-bottom:unset!important}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.MarkdownService }], propDecorators: { message: [{
                type: Input
            }], userId: [{
                type: Input
            }] } });

class UiMessageTimestampComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiMessageTimestampComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UiMessageTimestampComponent, selector: "sdk-messaging-ui-message-timestamp", inputs: { lastMessageReadInfo: "lastMessageReadInfo", messageId: "messageId", sentDate: "sentDate" }, ngImport: i0, template: `
    <ng-template #readByTooltipContent>
      <div>
        <ng-container *ngFor="let readBy of lastMessageReadInfo?.readByInfo">
          <p class="e11-text-xs">
            <span class="e11-font-bold"> {{ readBy.userDisplayName }}: </span>
            <span class="e11-italic">
              {{ readBy.timestamp ? (readBy.timestamp | date: 'MMM. d, y, h:mm a') : 'N/A' }}
            </span>
          </p>
        </ng-container>
      </div>
    </ng-template>
    <div class="e11-text-xs e11-text-skin-light e11-font-normal">
      <span *ngIf="sentDate"> Sent: {{ sentDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }} </span>
      <span *ngIf="lastMessageReadInfo">
        <span *ngIf="lastMessageReadInfo?.show">
          <!-- For Discussion Conversation (With more than one participants other than the sender) -->
          <ng-container *ngIf="lastMessageReadInfo.messageType == 'group'">
            <e11-tooltip color="dark" class="e11-inline-block" [tooltipContent]="readByTooltipContent">
              - Read by {{ lastMessageReadInfo.title }}
            </e11-tooltip>
          </ng-container>
          <!-- For Direct Conversation (With only one participant other than the sender) -->
          <ng-container *ngIf="lastMessageReadInfo.messageType == 'direct'">
            - Read: {{ (lastMessageReadInfo.readByInfo[0].timestamp | date: 'MMM. d, y, h:mm a') ?? 'N/A' }}
          </ng-container>
        </span>
      </span>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.E11TooltipComponent, selector: "e11-tooltip", inputs: ["tooltipText", "tooltipClassOverrides", "hideTooltip", "color", "tooltipContent", "position", "interactive", "maxWidth", "delay"], outputs: ["tooltipClick"] }, { kind: "pipe", type: i1$3.DatePipe, name: "date" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiMessageTimestampComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-messaging-ui-message-timestamp',
                    template: `
    <ng-template #readByTooltipContent>
      <div>
        <ng-container *ngFor="let readBy of lastMessageReadInfo?.readByInfo">
          <p class="e11-text-xs">
            <span class="e11-font-bold"> {{ readBy.userDisplayName }}: </span>
            <span class="e11-italic">
              {{ readBy.timestamp ? (readBy.timestamp | date: 'MMM. d, y, h:mm a') : 'N/A' }}
            </span>
          </p>
        </ng-container>
      </div>
    </ng-template>
    <div class="e11-text-xs e11-text-skin-light e11-font-normal">
      <span *ngIf="sentDate"> Sent: {{ sentDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }} </span>
      <span *ngIf="lastMessageReadInfo">
        <span *ngIf="lastMessageReadInfo?.show">
          <!-- For Discussion Conversation (With more than one participants other than the sender) -->
          <ng-container *ngIf="lastMessageReadInfo.messageType == 'group'">
            <e11-tooltip color="dark" class="e11-inline-block" [tooltipContent]="readByTooltipContent">
              - Read by {{ lastMessageReadInfo.title }}
            </e11-tooltip>
          </ng-container>
          <!-- For Direct Conversation (With only one participant other than the sender) -->
          <ng-container *ngIf="lastMessageReadInfo.messageType == 'direct'">
            - Read: {{ (lastMessageReadInfo.readByInfo[0].timestamp | date: 'MMM. d, y, h:mm a') ?? 'N/A' }}
          </ng-container>
        </span>
      </span>
    </div>
  `,
                }]
        }], propDecorators: { lastMessageReadInfo: [{
                type: Input
            }], messageId: [{
                type: Input
            }], sentDate: [{
                type: Input
            }] } });

class UiMessageToolsComponent {
    constructor() {
        this.canEditMessage = false;
        this.canDeleteMessage = false;
        this.showReaction = false;
        this.reactions = messageReactionOptions;
        this.MessageStatus = MessageStatus;
        this.onEdit = new EventEmitter();
        this.onReaction = new EventEmitter();
        this.onDelete = new EventEmitter();
        this.onConfirmDelete = new EventEmitter();
    }
    calculateCanEditMessage() {
        const isSentByCurrentUser = this.message.senderId === this.userId;
        const canEditOwnSentMessages = this.messageConfig.canEditOwnMessages && isSentByCurrentUser;
        const { numberOfEditOwnMessages, maxMinutesToEditOwnMessages } = this.messageConfig;
        // Check if the number of edits exceeds the allowed limit
        const editNumLimitReached = numberOfEditOwnMessages && this.message.editedMessages && this.message.editedMessages?.length >= numberOfEditOwnMessages;
        if (!canEditOwnSentMessages || editNumLimitReached)
            return false;
        if (isNotNil(maxMinutesToEditOwnMessages)) {
            // Handle time limit for editing
            const maxEditTimeMillis = maxMinutesToEditOwnMessages * 60 * 1000;
            const messageAgeMillis = Date.now() - new Date(this.message.__createdAt).getTime();
            const editTimeLimitReached = messageAgeMillis > maxEditTimeMillis;
            if (editTimeLimitReached)
                return false;
        }
        // No time limit config or time limit not reached
        return true;
    }
    calculateCanDeleteMessage() {
        const { canDeleteOwnMessages, canDeleteAllMessages } = this.messageConfig;
        const isOwnMessage = canDeleteOwnMessages && this.message.senderId === this.userId;
        const isFailedStatus = this.failedStatuses?.includes(this.message.status);
        return isFailedStatus || canDeleteAllMessages || isOwnMessage;
    }
    ngOnInit() {
        this.canEditMessage = this.calculateCanEditMessage();
        this.canDeleteMessage = this.calculateCanDeleteMessage();
    }
    deleteMessage() {
        if (!this.failedStatuses?.includes(this.message.status)) {
            this.onConfirmDelete.emit();
        }
        else {
            this.onDelete.emit();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiMessageToolsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UiMessageToolsComponent, selector: "sdk-messaging-ui-tools", inputs: { showReaction: "showReaction", userId: "userId", failedStatuses: "failedStatuses", message: "message", messageConfig: "messageConfig" }, outputs: { onEdit: "onEdit", onReaction: "onReaction", onDelete: "onDelete", onConfirmDelete: "onConfirmDelete" }, ngImport: i0, template: `
    <div
      class="e11-absolute e11--top-7 e11-right-2 e11-rounded-md e11-border e11-border-skin-grey e11-p-2 e11-bg-white e11-invisible group-hover/chat-message:e11-visible hover:e11-visible"
    >
      <div class="e11-flex" *ngIf="showReaction">
        <div class="e11-flex e11-items-center" *ngFor="let reaction of reactions" (click)="onReaction.emit(reaction)">
          <span
            class="material-icons md-18 e11-mx-2 e11-text-skin-light hover:e11-text-skin-base e11-cursor-pointer"
            [ngClass]="{
          'e11-text-gray-800':
            message.reactions?.[reaction.emojiUnicode]?.includes(userId) ?? false,
        }"
            >{{ reaction.icon }}
          </span>
        </div>
      </div>
      <div class="e11-flex" *ngIf="!showReaction">
        <div *ngIf="message.status === MessageStatus.Sent" class="e11-flex e11-items-center" (click)="showReaction = true">
          <span class="material-icons md-18 e11-mx-2 e11-text-skin-light hover:e11-text-skin-base e11-cursor-pointer"> add_reaction</span>
        </div>
        <div class="e11-flex e11-items-center">
          <span
            *ngIf="canEditMessage"
            class="material-icons md-18 e11-mx-2 e11-text-skin-light hover:e11-text-skin-base e11-cursor-pointer"
            (click)="onEdit.emit()"
            >edit
          </span>
        </div>
        <div class="e11-flex e11-items-center">
          <div
            *ngIf="canDeleteMessage"
            class="material-icons md-18 e11-mx-2 e11-text-skin-light hover:e11-text-skin-base e11-cursor-pointer"
            (click)="deleteMessage()"
          >
            delete_outline
          </div>
        </div>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiMessageToolsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-messaging-ui-tools',
                    template: `
    <div
      class="e11-absolute e11--top-7 e11-right-2 e11-rounded-md e11-border e11-border-skin-grey e11-p-2 e11-bg-white e11-invisible group-hover/chat-message:e11-visible hover:e11-visible"
    >
      <div class="e11-flex" *ngIf="showReaction">
        <div class="e11-flex e11-items-center" *ngFor="let reaction of reactions" (click)="onReaction.emit(reaction)">
          <span
            class="material-icons md-18 e11-mx-2 e11-text-skin-light hover:e11-text-skin-base e11-cursor-pointer"
            [ngClass]="{
          'e11-text-gray-800':
            message.reactions?.[reaction.emojiUnicode]?.includes(userId) ?? false,
        }"
            >{{ reaction.icon }}
          </span>
        </div>
      </div>
      <div class="e11-flex" *ngIf="!showReaction">
        <div *ngIf="message.status === MessageStatus.Sent" class="e11-flex e11-items-center" (click)="showReaction = true">
          <span class="material-icons md-18 e11-mx-2 e11-text-skin-light hover:e11-text-skin-base e11-cursor-pointer"> add_reaction</span>
        </div>
        <div class="e11-flex e11-items-center">
          <span
            *ngIf="canEditMessage"
            class="material-icons md-18 e11-mx-2 e11-text-skin-light hover:e11-text-skin-base e11-cursor-pointer"
            (click)="onEdit.emit()"
            >edit
          </span>
        </div>
        <div class="e11-flex e11-items-center">
          <div
            *ngIf="canDeleteMessage"
            class="material-icons md-18 e11-mx-2 e11-text-skin-light hover:e11-text-skin-base e11-cursor-pointer"
            (click)="deleteMessage()"
          >
            delete_outline
          </div>
        </div>
      </div>
    </div>
  `,
                }]
        }], propDecorators: { showReaction: [{
                type: Input
            }], userId: [{
                type: Input,
                args: [{ required: true }]
            }], failedStatuses: [{
                type: Input
            }], message: [{
                type: Input,
                args: [{ required: true }]
            }], messageConfig: [{
                type: Input,
                args: [{ required: true }]
            }], onEdit: [{
                type: Output
            }], onReaction: [{
                type: Output
            }], onDelete: [{
                type: Output
            }], onConfirmDelete: [{
                type: Output
            }] } });

class UIMessagingAvatarComponent {
    constructor() {
        this.size = 'sm';
        this.hasRing = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIMessagingAvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UIMessagingAvatarComponent, selector: "sdk-ui-messaging-avatar", inputs: { size: "size", hasRing: "hasRing", userInformation: "userInformation" }, ngImport: i0, template: `
    <e11-avatar
      *ngIf="!userInformation.isDisabled"
      [imageUrl]="userInformation.profilePicture"
      [initials]="userInformation.displayName | initials"
      [colorSeed]="userInformation.displayName"
      [size]="size"
      [hasRing]="hasRing"
    ></e11-avatar>
    <e11-avatar *ngIf="userInformation.isDisabled" [size]="size" [hasRing]="hasRing"></e11-avatar>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.E11AvatarComponent, selector: "e11-avatar", inputs: ["colorSeed", "initials", "size", "shape", "sizeOverride", "imageUrl", "imageTitleText", "imageFit", "editable", "regenerate", "hasBorder", "hasRing"], outputs: ["edit", "onEdit"] }, { kind: "pipe", type: i1$4.InitialsPipe, name: "initials" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIMessagingAvatarComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-ui-messaging-avatar',
                    template: `
    <e11-avatar
      *ngIf="!userInformation.isDisabled"
      [imageUrl]="userInformation.profilePicture"
      [initials]="userInformation.displayName | initials"
      [colorSeed]="userInformation.displayName"
      [size]="size"
      [hasRing]="hasRing"
    ></e11-avatar>
    <e11-avatar *ngIf="userInformation.isDisabled" [size]="size" [hasRing]="hasRing"></e11-avatar>
  `,
                }]
        }], propDecorators: { size: [{
                type: Input
            }], hasRing: [{
                type: Input
            }], userInformation: [{
                type: Input
            }] } });

class MessageAvatarComponent {
    set message(currentMessage) {
        this._message = currentMessage;
        this.avatarId = `_${currentMessage.id}`;
    }
    constructor(logger, avatarClickHandlerDirective) {
        this.logger = logger;
        this.avatarClickHandler = avatarClickHandlerDirective?.messageAvatarClickHandler;
    }
    ngOnInit() { }
    onAvatarClick() {
        this.avatarClickHandler?.onAvatarClick({ avatarElementId: this.avatarId, message: this._message });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageAvatarComponent, deps: [{ token: LOGGER_TOKEN }, { token: MessageAvatarClickHandlerDirective, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: MessageAvatarComponent, selector: "sdk-message-avatar", inputs: { message: "message" }, ngImport: i0, template: "<div id=\"{{ avatarId }}\" [ngClass]=\"{ 'e11-cursor-pointer': !!avatarClickHandler && !_message.senderInformation.isDisabled }\">\n  <sdk-ui-messaging-avatar\n    [userInformation]=\"_message.senderInformation\"\n    (click)=\"!_message.senderInformation.isDisabled && onAvatarClick()\"\n  ></sdk-ui-messaging-avatar>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: UIMessagingAvatarComponent, selector: "sdk-ui-messaging-avatar", inputs: ["size", "hasRing", "userInformation"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageAvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-message-avatar', template: "<div id=\"{{ avatarId }}\" [ngClass]=\"{ 'e11-cursor-pointer': !!avatarClickHandler && !_message.senderInformation.isDisabled }\">\n  <sdk-ui-messaging-avatar\n    [userInformation]=\"_message.senderInformation\"\n    (click)=\"!_message.senderInformation.isDisabled && onAvatarClick()\"\n  ></sdk-ui-messaging-avatar>\n</div>\n" }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }, { type: MessageAvatarClickHandlerDirective, decorators: [{
                    type: Optional
                }] }], propDecorators: { message: [{
                type: Input
            }] } });

class ReactionSummaryComponent {
    constructor(logger) {
        this.logger = logger;
        this.summaryClicked = new EventEmitter();
    }
    ngOnChanges(changes) {
        const { reactorInfo, reactorIds } = changes;
        this.logger.debug('ReactionSummaryComponent', changes);
        // this.logger.debug('Has changed:', reactorInfo?.currentValue && reactorIds?.currentValue && hasChangedAnyNg(changes, ['reactorInfo', 'reactorIds']))
        // TODO: remove compute from unchanged reactions. Debug: && hasChangedAnyNg(changes, ['reactorInfo', 'reactorIds'])
        if (reactorInfo?.currentValue && reactorIds?.currentValue) {
            this.reactionMessage = this.buildReactionMessage(reactorIds.currentValue, reactorInfo.currentValue);
        }
    }
    /**
     * TODO: Revisit
     * @param reactorIds
     * @param reactorInfo
     * @returns
     */
    buildReactionMessage(reactorIds, reactorInfo) {
        this.logger.debug('ReactionSummaryComponent - buildReactionMessage - ', { reactorIds, reactorInfo });
        const userNames = reactorIds.map((reactorId) => (reactorInfo[reactorId] ? reactorInfo[reactorId].displayName : undefined)).filter(isNotNil);
        if (reactorIds.length === 0)
            return '';
        else if (userNames.length === 0)
            return undefined;
        else if (reactorIds.length === 1)
            return userNames[0];
        else if (reactorIds.length <= REACTION_HOVER_LIMIT)
            return arrayToStringList(userNames, 'and');
        else
            return arrayToStringList([...userNames.slice(0, REACTION_HOVER_LIMIT), `${reactorIds.length - REACTION_HOVER_LIMIT} others`], 'and');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ReactionSummaryComponent, deps: [{ token: LOGGER_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ReactionSummaryComponent, selector: "reaction-summary", inputs: { reactorIds: "reactorIds", reactorInfo: "reactorInfo" }, outputs: { summaryClicked: "summaryClicked" }, usesOnChanges: true, ngImport: i0, template: `
    <e11-tooltip
      [tooltipContent]="tooltipContent"
      [interactive]="true"
      [color]="'dark'"
      [delay]="200"
      [tooltipClassOverrides]=""
      (tooltipClick)="summaryClicked.emit()"
    >
      <ng-content></ng-content>
    </e11-tooltip>
    <ng-template #tooltipContent>
      <div *ngIf="reactionMessage; else loadingReactions">
        <p>{{ reactionMessage }}</p>
      </div>
      <ng-template #loadingReactions>
        <e11-loader-dots [size]="'sm'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
      </ng-template>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i2.E11TooltipComponent, selector: "e11-tooltip", inputs: ["tooltipText", "tooltipClassOverrides", "hideTooltip", "color", "tooltipContent", "position", "interactive", "maxWidth", "delay"], outputs: ["tooltipClick"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ReactionSummaryComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'reaction-summary',
                    template: `
    <e11-tooltip
      [tooltipContent]="tooltipContent"
      [interactive]="true"
      [color]="'dark'"
      [delay]="200"
      [tooltipClassOverrides]=""
      (tooltipClick)="summaryClicked.emit()"
    >
      <ng-content></ng-content>
    </e11-tooltip>
    <ng-template #tooltipContent>
      <div *ngIf="reactionMessage; else loadingReactions">
        <p>{{ reactionMessage }}</p>
      </div>
      <ng-template #loadingReactions>
        <e11-loader-dots [size]="'sm'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
      </ng-template>
    </ng-template>
  `,
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }], propDecorators: { reactorIds: [{
                type: Input
            }], reactorInfo: [{
                type: Input
            }], summaryClicked: [{
                type: Output
            }] } });
/**
 * TODO: Test this
 * Inspired by https://stackoverflow.com/a/53879103/7977259
 */
function arrayToStringList(list, end) {
    if (list.length === 0)
        return '';
    else if (list.length === 1)
        return list[0];
    const lastIdx = list.length - 1;
    const firsts = list.slice(0, lastIdx);
    const last = list[lastIdx];
    return firsts.join(', ') + ` ${end} ${last}`;
}

class ReactionsComponent {
    constructor(logger) {
        this.logger = logger;
        this.reactions = messageReactionOptions;
        this.reactionClicked = new EventEmitter();
        this.fetchReactionInformation = new EventEmitter(); // emits reactionId: userIds[]
    }
    reactionSummaryClicked(emojiUnicode) {
        this.selectedReaction = emojiUnicode;
        // this.modalReactions.open()
    }
    /**
     *
     * @param emojiUnicode
     */
    reactionHover(emojiUnicode) {
        const userIds = this.message.reactions ? this.message.reactions[emojiUnicode] : [];
        const reactions = { [emojiUnicode]: userIds };
        this.logger.log('reactionHover', { emojiUnicode, message: this.message, reactions });
        this.fetchReactionInformation.emit({ message: this.message, reactions, limit: REACTION_HOVER_LIMIT });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ReactionsComponent, deps: [{ token: LOGGER_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ReactionsComponent, selector: "sdk-message-reactions", inputs: { message: "message", userId: "userId" }, outputs: { reactionClicked: "reactionClicked", fetchReactionInformation: "fetchReactionInformation" }, viewQueries: [{ propertyName: "modalReactions", first: true, predicate: ["modalReactions"], descendants: true }], ngImport: i0, template: `
    <div class="e11-flex e11-flex-row e11-items-center e11-gap-1">
      <ng-container *ngFor="let reaction of reactions">
        <ng-container *ngIf="message.reactions && message.reactions[reaction.emojiUnicode]">
          <reaction-summary
            [reactorInfo]="message.reactorInfo"
            [reactorIds]="message.reactions[reaction.emojiUnicode]"
            (summaryClicked)="reactionSummaryClicked(reaction.emojiUnicode)"
          >
            <div
              class="e11-cursor-pointer e11-p-1 e11-border e11-rounded-md"
              [ngClass]="{
                'e11-border-transparent': !message.reactions[reaction.emojiUnicode].includes(userId),
                ' e11-border-skin-primary-accent/40  ': message.reactions[reaction.emojiUnicode].includes(userId)
              }"
              (click)="reactionClicked.emit(reaction.emojiUnicode)"
              (mouseenter)="reactionHover(reaction.emojiUnicode)"
            >
              <span class="e11-text-sm" [innerHtml]="reaction.htmlDec"> </span>
              <span class="e11-text-xs"> {{ message.reactions[reaction.emojiUnicode].length }} </span>
            </div>
          </reaction-summary>
        </ng-container>
      </ng-container>
      <!-- <e11-modal #modalReactions [darkMode]="true" [showHeader]="false" [showFooter]="false" [hideCloseButton]="false" [width]="'sm'">
        <div modal-body>
          <sdk-reactions-detail [message]="message" [selectedReaction]="selectedReaction ?? ''"></sdk-reactions-detail>
        </div>
      </e11-modal> -->
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ReactionSummaryComponent, selector: "reaction-summary", inputs: ["reactorIds", "reactorInfo"], outputs: ["summaryClicked"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ReactionsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-message-reactions',
                    template: `
    <div class="e11-flex e11-flex-row e11-items-center e11-gap-1">
      <ng-container *ngFor="let reaction of reactions">
        <ng-container *ngIf="message.reactions && message.reactions[reaction.emojiUnicode]">
          <reaction-summary
            [reactorInfo]="message.reactorInfo"
            [reactorIds]="message.reactions[reaction.emojiUnicode]"
            (summaryClicked)="reactionSummaryClicked(reaction.emojiUnicode)"
          >
            <div
              class="e11-cursor-pointer e11-p-1 e11-border e11-rounded-md"
              [ngClass]="{
                'e11-border-transparent': !message.reactions[reaction.emojiUnicode].includes(userId),
                ' e11-border-skin-primary-accent/40  ': message.reactions[reaction.emojiUnicode].includes(userId)
              }"
              (click)="reactionClicked.emit(reaction.emojiUnicode)"
              (mouseenter)="reactionHover(reaction.emojiUnicode)"
            >
              <span class="e11-text-sm" [innerHtml]="reaction.htmlDec"> </span>
              <span class="e11-text-xs"> {{ message.reactions[reaction.emojiUnicode].length }} </span>
            </div>
          </reaction-summary>
        </ng-container>
      </ng-container>
      <!-- <e11-modal #modalReactions [darkMode]="true" [showHeader]="false" [showFooter]="false" [hideCloseButton]="false" [width]="'sm'">
        <div modal-body>
          <sdk-reactions-detail [message]="message" [selectedReaction]="selectedReaction ?? ''"></sdk-reactions-detail>
        </div>
      </e11-modal> -->
    </div>
  `,
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }], propDecorators: { message: [{
                type: Input
            }], userId: [{
                type: Input
            }], modalReactions: [{
                type: ViewChild,
                args: ['modalReactions']
            }], reactionClicked: [{
                type: Output
            }], fetchReactionInformation: [{
                type: Output
            }] } });

class UIMessageAttachmentsComponent {
    set message(value) {
        if (!isDeepEqual(value, this._message)) {
            this._message = value;
            if (value.attachments) {
                this.checkAttachments(value.attachments);
            }
        }
    }
    constructor(sanitizer, fileService, modalGlobal, cd, viewportService) {
        this.sanitizer = sanitizer;
        this.fileService = fileService;
        this.modalGlobal = modalGlobal;
        this.cd = cd;
        this.viewportService = viewportService;
        this.videoUrlBuilder = inject(VideoUrlBuilder);
        this.playerSizeEnum = PlayerSize;
        this.showFile = false;
        this.showItem = false;
        this.isMobile$ = this.viewportService.viewportSizeChanged$.pipe(map((data) => data == 'md' || data == 'sm' || data == 'xs'), filter(isNotNil));
        this.canDelete = false;
        this.fileMimeTypeIconTypesEnum = FileMimeTypeIconTypes;
        this.attachmentsDataUrls = [];
        this.onDelete = new EventEmitter();
        this.MessageStatus = MessageStatus;
        this.isArrayOfType = (obj, props) => {
            return obj.every((ele) => {
                return this.hasAllProperties(ele, props);
            });
        };
        this.hasAllProperties = (obj, props) => {
            return props.every((prop) => {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            });
        };
    }
    onClick(file) {
        this.fileDetail = {
            name: file.fileName || file.name,
            url: this.correctFileName(file),
        };
        this.showFile = true;
        setTimeout(() => {
            this.showItem = true;
            this.cd.detectChanges();
        }, 100);
    }
    async checkAttachments(attachments) {
        // check if its Files[] or IFileReceipt[]
        if (this.isArrayOfType(attachments, ['id', 'url'])) {
            // its defiantly IFileReceipt[]
            this.attachmentsDataUrls = await Promise.all(attachments
                .filter((attachment) => attachment.public)
                .map(async (attachment) => {
                return {
                    file: attachment,
                    type: this.findFileIcon(attachment.mimeType),
                    url: this.correctFileName(attachment),
                    fallbackUrl: await this.generateFallback(attachment, this.findFileIcon(attachment.mimeType)),
                };
            }));
            this.cd.detectChanges();
            return;
        }
        // this is a file, lets convert file to dataURL
        this.attachmentsDataUrls = await Promise.all(attachments.map(async (attachment) => ({
            file: await fileToDataURL(attachment),
            url: await fileToDataURL(attachment),
            type: this.findFileIcon(attachment.type),
        })));
    }
    async generateFallback(file, type) {
        if (type !== FileMimeTypeIconTypes.Video)
            return;
        return this.fileService.getVideoFallbackURL(file);
    }
    findFileIcon(mimeType) {
        let icon;
        Object.keys(mimeTypeIconMap).forEach((key) => {
            if (mimeType.includes(key)) {
                icon = mimeTypeIconMap[key];
            }
        });
        if (!icon) {
            return mimeTypeIconMap['unknown'];
        }
        if (icon === 'video_file') {
            return FileMimeTypeIconTypes.Video;
        }
        if (icon === 'image') {
            return FileMimeTypeIconTypes.Preview;
        }
        return icon;
    }
    correctFileName(attachment) {
        return this.videoUrlBuilder.build(attachment);
    }
    confirmDeletion(index) {
        this.attachmentToDelete = this._message.attachments[index];
    }
    deleteAttachmentConfirmationResult(result) {
        if (result) {
            this.onDelete.emit(this.attachmentToDelete);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIMessageAttachmentsComponent, deps: [{ token: i1$5.DomSanitizer }, { token: i6.FilesService }, { token: i3.E11ModalGlobalService }, { token: i0.ChangeDetectorRef }, { token: i1$4.ViewportService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UIMessageAttachmentsComponent, selector: "sdk-messaging-ui-message-attachments", inputs: { canDelete: "canDelete", message: "message" }, outputs: { onDelete: "onDelete" }, viewQueries: [{ propertyName: "fileDetailModal", first: true, predicate: ["fileDetailModal"], descendants: true }], ngImport: i0, template: "<div *ngIf=\"_message.status !== MessageStatus.Sending && attachmentsDataUrls.length\" class=\"e11-flex e11-gap-2 e11-items-center e11-flex-wrap\">\n  <ng-container *ngFor=\"let attachment of attachmentsDataUrls; let i = index\">\n    <div class=\"e11-relative e11-group\">\n      <ng-container [ngSwitch]=\"attachment.type\">\n        <div *ngSwitchCase=\"fileMimeTypeIconTypesEnum.Video\" class=\"e11-w-60 lg:e11-w-96\">\n          <video-player\n            [id]=\"attachment.file.id\"\n            [playerSize]=\"playerSizeEnum.Small\"\n            [videoPlayerResource]=\"{ video: attachment.url, fallbackVideoUrl: attachment.fallbackUrl }\"\n          ></video-player>\n        </div>\n        <img\n          (click)=\"onClick(attachment.file)\"\n          *ngSwitchCase=\"fileMimeTypeIconTypesEnum.Preview\"\n          [src]=\"attachment.url\"\n          alt=\"\"\n          class=\"e11-rounded-md e11-ring-1 e11-ring-gray-300 hover:e11-bg-gray-100 e11-cursor-pointer\"\n          width=\"250\"\n        />\n        <div *ngSwitchDefault>\n          <button\n            (click)=\"onClick(attachment.file)\"\n            class=\"e11-flex e11-pr-1 e11-py-1 e11-items-center e11-border-2 e11-text-gray-500 e11-rounded e11-cursor-pointer hover:e11-text-gray-900\"\n            type=\"button\"\n          >\n            <span class=\"material-icons e11-text-4xl\"> {{ attachment.type }}</span>\n            <span class=\"e11-sr-only\">{{ attachment.type }}</span>\n            <span class=\"e11-truncate e11-max-w-xs\"> {{ attachment.file.fileName || attachment.file.name }}</span>\n          </button>\n        </div>\n      </ng-container>\n      <span\n        (click)=\"confirmDeletion(i); deleteConfirmation.open()\"\n        *ngIf=\"canDelete\"\n        class=\"e11-absolute e11-cursor-pointer e11-hidden group-hover:e11-block e11-top-0 e11-right-1 e11-h-5 e11-w-5 e11--translate-y-1/2 e11-translate-x-1/2 e11-transform e11-rounded-full e11-bg-white\"\n      >\n        <span class=\"material-icons e11-text-gray-400 e11-text-[20px]\">cancel</span>\n      </span>\n    </div>\n  </ng-container>\n</div>\n\n<span *ngIf=\"_message.status === MessageStatus.Sending\"> {{ \"Uploading Files...\" | translate }}</span>\n\n<e11-file-viewer (close)=\"showFile = false\" *ngIf=\"showFile\" [name]=\"fileDetail.name\" [url]=\"fileDetail.url\"></e11-file-viewer>\n\n<ng-template #fileDetailModal>\n  <div class=\"e11-h-full e11-relative\"></div>\n</ng-template>\n\n<!-- Delete File Confirmations-->\n<e11-confirmation\n  #deleteConfirmation\n  (answer)=\"deleteAttachmentConfirmationResult($event)\"\n  [backdropStyle]=\"'dark'\"\n  [isMobile]=\"(isMobile$ | async) ?? false\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  confirmText=\"{{ 'Delete Attachment' | translate }}\"\n  confirmTitle=\"{{ 'Deleting this File' | translate }}\"\n>\n  <span class=\"e11-block e11-mt-2\"> {{ \"You are about to delete this attachment, Are you sure you want to do this?\" | translate }}</span>\n</e11-confirmation>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$3.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$3.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: i6$2.E11ConfirmationComponent, selector: "e11-confirmation", inputs: ["confirmTitle", "confirmText", "cancelText", "confirmClassOverrides", "cancelClassOverrides", "isMobile", "processing", "processingText", "closeOnEscape", "closeOnClickOutside", "hasBackdrop", "backdropStyle", "confirmValueWithInputBox", "valueToConfirm"], outputs: ["answer"] }, { kind: "component", type: i7.E11FileViewerComponent, selector: "e11-file-viewer", inputs: ["url", "name"], outputs: ["close"] }, { kind: "component", type: i8.VideoPlayerComponent, selector: "video-player", inputs: ["videoPlayerResource", "playerSize", "thumb", "videoPlayerConfig"], outputs: ["playerClose"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIMessageAttachmentsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-messaging-ui-message-attachments', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"_message.status !== MessageStatus.Sending && attachmentsDataUrls.length\" class=\"e11-flex e11-gap-2 e11-items-center e11-flex-wrap\">\n  <ng-container *ngFor=\"let attachment of attachmentsDataUrls; let i = index\">\n    <div class=\"e11-relative e11-group\">\n      <ng-container [ngSwitch]=\"attachment.type\">\n        <div *ngSwitchCase=\"fileMimeTypeIconTypesEnum.Video\" class=\"e11-w-60 lg:e11-w-96\">\n          <video-player\n            [id]=\"attachment.file.id\"\n            [playerSize]=\"playerSizeEnum.Small\"\n            [videoPlayerResource]=\"{ video: attachment.url, fallbackVideoUrl: attachment.fallbackUrl }\"\n          ></video-player>\n        </div>\n        <img\n          (click)=\"onClick(attachment.file)\"\n          *ngSwitchCase=\"fileMimeTypeIconTypesEnum.Preview\"\n          [src]=\"attachment.url\"\n          alt=\"\"\n          class=\"e11-rounded-md e11-ring-1 e11-ring-gray-300 hover:e11-bg-gray-100 e11-cursor-pointer\"\n          width=\"250\"\n        />\n        <div *ngSwitchDefault>\n          <button\n            (click)=\"onClick(attachment.file)\"\n            class=\"e11-flex e11-pr-1 e11-py-1 e11-items-center e11-border-2 e11-text-gray-500 e11-rounded e11-cursor-pointer hover:e11-text-gray-900\"\n            type=\"button\"\n          >\n            <span class=\"material-icons e11-text-4xl\"> {{ attachment.type }}</span>\n            <span class=\"e11-sr-only\">{{ attachment.type }}</span>\n            <span class=\"e11-truncate e11-max-w-xs\"> {{ attachment.file.fileName || attachment.file.name }}</span>\n          </button>\n        </div>\n      </ng-container>\n      <span\n        (click)=\"confirmDeletion(i); deleteConfirmation.open()\"\n        *ngIf=\"canDelete\"\n        class=\"e11-absolute e11-cursor-pointer e11-hidden group-hover:e11-block e11-top-0 e11-right-1 e11-h-5 e11-w-5 e11--translate-y-1/2 e11-translate-x-1/2 e11-transform e11-rounded-full e11-bg-white\"\n      >\n        <span class=\"material-icons e11-text-gray-400 e11-text-[20px]\">cancel</span>\n      </span>\n    </div>\n  </ng-container>\n</div>\n\n<span *ngIf=\"_message.status === MessageStatus.Sending\"> {{ \"Uploading Files...\" | translate }}</span>\n\n<e11-file-viewer (close)=\"showFile = false\" *ngIf=\"showFile\" [name]=\"fileDetail.name\" [url]=\"fileDetail.url\"></e11-file-viewer>\n\n<ng-template #fileDetailModal>\n  <div class=\"e11-h-full e11-relative\"></div>\n</ng-template>\n\n<!-- Delete File Confirmations-->\n<e11-confirmation\n  #deleteConfirmation\n  (answer)=\"deleteAttachmentConfirmationResult($event)\"\n  [backdropStyle]=\"'dark'\"\n  [isMobile]=\"(isMobile$ | async) ?? false\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  confirmText=\"{{ 'Delete Attachment' | translate }}\"\n  confirmTitle=\"{{ 'Deleting this File' | translate }}\"\n>\n  <span class=\"e11-block e11-mt-2\"> {{ \"You are about to delete this attachment, Are you sure you want to do this?\" | translate }}</span>\n</e11-confirmation>\n" }]
        }], ctorParameters: () => [{ type: i1$5.DomSanitizer }, { type: i6.FilesService }, { type: i3.E11ModalGlobalService }, { type: i0.ChangeDetectorRef }, { type: i1$4.ViewportService }], propDecorators: { fileDetailModal: [{
                type: ViewChild,
                args: ['fileDetailModal']
            }], canDelete: [{
                type: Input
            }], message: [{
                type: Input
            }], onDelete: [{
                type: Output
            }] } });

const defaultConversationTypeConfig = {
    canEditOwnMessages: true,
    canDeleteOwnMessages: false,
    canReactOnMessages: true,
    canDeleteConversation: false,
    canViewOwnReadReceipts: false,
    canViewAllReadReceipts: false,
};
const MESSAGING_EDITOR_CONFIG = {
    attachmentMaxFileSize: 100,
    maxNumberOfAttachments: 5,
};

class MessageDraftRepository extends CollectionRepository {
    constructor() {
        super(...arguments);
        this.COLLECTION = COLLECTIONS.MESSAGE_DRAFT;
    }
    getDrafts(userId) {
        return this.get(userId);
    }
    setDraft(userId, request) {
        const key = `drafts.${request.conversationId}`;
        return this.upsert({ id: userId, [key]: request });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageDraftRepository, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageDraftRepository, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageDraftRepository, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
/**
 * ! WIP: Needs to be finished before it can be used
 * TODO: This needs to function as a LRU with a fixed cap on how many conversation drafts it can store
 *
 */
class MessageDraftService {
    constructor(repository) {
        this.repository = repository;
    }
    getDrafts(userId) {
        return this.repository.getDrafts(userId);
    }
    setDraft(userId, request) {
        return this.repository.setDraft(userId, request);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageDraftService, deps: [{ token: MessageDraftRepository }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageDraftService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageDraftService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MessageDraftRepository }] });

const draftAdapter = createEntityAdapter({
    selectId: (draft) => draft.conversationId,
});
const draftSelectors = draftAdapter.getSelectors();
const initialState = draftAdapter.getInitialState({
    loaded: false,
});
class MessageDraftStore extends ComponentStore {
    constructor(logger, errorHandler, draftRepository) {
        super(initialState);
        this.logger = logger;
        this.errorHandler = errorHandler;
        this.draftRepository = draftRepository;
        // SELECTORS
        this.getState = this.select((s) => s);
        this.getDraftForConversation = (conversationId) => this.select((s) => draftSelectors.selectEntities(s)[conversationId]);
        this.loaded$ = this.select((s) => s.loaded);
        // EFFECTS
        this.setDraft = this.effect((request$) => request$.pipe(map$1((request) => {
            const draft = { ...request, timestamp: new Date() };
            this.onSetDraft(draft);
            return draft;
        })
        // switchMap((draft) => this.draftRepository.setDraft(draft.userId, omit(draft, 'userId')))
        ));
        // UPDATERS
        this.onSetDraft = this.updater((state, draft) => draftAdapter.setOne({ ...draft, timestamp: new Date() }, state));
        this.setLoaded = this.updater((state, loaded) => ({
            ...state,
            loaded,
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageDraftStore, deps: [{ token: i1.E11Logger }, { token: i1.E11ErrorHandlerService }, { token: MessageDraftRepository }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageDraftStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageDraftStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.E11Logger }, { type: i1.E11ErrorHandlerService }, { type: MessageDraftRepository }] });

/**
 * Break down:
 * 1. Simplest case (MD only): Just use e11-markdown-editor
 * 2. Need video: Multimedia
 * 3. Messaging-specific: messaging
 */
class MessageMarkdownEditorComponent {
    constructor() {
        this.#libConfig = inject(MessagingConfigurationProvider);
        this.#messageDraftStore = inject(MessageDraftStore);
        this.#logger = inject(E11Logger);
        this.disableChatInput = false;
        this.sendingMessage = false;
        this.message = '';
        this.isEditMode = false;
        this.newMessage = new EventEmitter();
        this.maxFileSize = this.#libConfig.config.messagingEditorConfig?.attachmentMaxFileSize || MESSAGING_EDITOR_CONFIG.attachmentMaxFileSize; // In MB
        this.maxNumberOfAttachments = this.#libConfig.config.messagingEditorConfig?.maxNumberOfAttachments || MESSAGING_EDITOR_CONFIG.maxNumberOfAttachments;
        this.fileInput = [];
    }
    #libConfig;
    #messageDraftStore;
    #logger;
    set conversationId(id) {
        if (this._conversationId && this._conversationId !== id)
            this.reset();
        this._conversationId = id;
        if (id)
            this.retrieveDraft(id);
    }
    ngOnChanges(changes) {
        this.configureMentions();
    }
    ngOnDestroy() {
        this.reset();
    }
    configureMentions() {
        if (!this.mentions) {
            this.mentionConfig = {
                autoComplete: this.autocomplete,
                mentionDetail: {},
            };
            return;
        }
        this.mentionConfig = {
            autoComplete: this.autocomplete,
            mentionDetail: Object.fromEntries(Object.values(this.mentions).map(({ userId, displayName }) => [userId, { id: userId, name: displayName, email: userId }])),
        };
    }
    setDraft(markdownEditorState) {
        const editorState = this.convertToEditorMessage(markdownEditorState);
        if (!this._conversationId)
            return;
        this.#messageDraftStore.setDraft({
            conversationId: this._conversationId,
            userId: this.userId,
            message: editorState.message,
            files: editorState.files,
        });
    }
    convertToEditorMessage(editorState) {
        return { message: editorState.message, files: editorState.files.map((file) => file.file) };
    }
    onSend(markdownEditorState) {
        const editorState = this.convertToEditorMessage(markdownEditorState);
        this.newMessage.emit(editorState);
        this.setDraft({ files: [], message: '' });
    }
    onUpload(editorState) {
        this.setDraftWithCurrentState(editorState);
    }
    reset() {
        this.fileInput = [];
        this.message = '';
        this.multiMediaMarkdownEditor?.reset();
    }
    async retrieveDraft(conversationId) {
        const draft = await firstValueFrom(this.#messageDraftStore.getDraftForConversation(conversationId));
        if (!draft || !this.multiMediaMarkdownEditor?.markdownEditor || this.multiMediaMarkdownEditor?.markdownEditor?.editorInstance)
            return;
        // TODO: pass message down into the editor via the template instead of reaching inside and forcing it here
        this.multiMediaMarkdownEditor.markdownEditor.editorInstance.content = draft.message;
        this.fileInput = draft.files;
        this.#logger.log('MessageMarkdownEditorComponent - Draft retrieved ', { draft });
    }
    setDraftWithCurrentState(editorState) {
        this.setDraft({ files: editorState.files, message: editorState.message });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageMarkdownEditorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: MessageMarkdownEditorComponent, selector: "sdk-messages-message-markdown-editor", inputs: { disableChatInput: "disableChatInput", sendingMessage: "sendingMessage", message: "message", userId: "userId", mentions: "mentions", autocomplete: "autocomplete", isEditMode: "isEditMode", conversationId: "conversationId" }, outputs: { newMessage: "newMessage" }, viewQueries: [{ propertyName: "multiMediaMarkdownEditor", first: true, predicate: ["multiMediaMarkdownEditor"], descendants: true }], usesOnChanges: true, ngImport: i0, template: ` <multimedia-markdown-editor
    #multiMediaMarkdownEditor
    [editorTextContent]="message"
    [mentionConfig]="mentionConfig"
    [isEditMode]="isEditMode"
    [disableEditorInput]="disableChatInput"
    [disableEditorInfoMessage]="'This conversation is closed so you cannot send messages'"
    [maxFileSize]="maxFileSize"
    [maxNumberOfAttachments]="maxNumberOfAttachments"
    (stateChanged)="setDraft($event)"
    (onSendAction)="onSend($event)"
    (onUploadAction)="onUpload($event)"
  ></multimedia-markdown-editor>`, isInline: true, dependencies: [{ kind: "component", type: i8.MultiMediaMarkdownEditorComponent, selector: "multimedia-markdown-editor", inputs: ["editorTextContent", "loading", "fieldClassList", "disableEditorInput", "disableEditorInfoMessage", "showErrorFileSize", "maxFileSize", "maxLength", "maxNumberOfAttachments", "isEditMode", "options", "mentionConfig"], outputs: ["stateChanged", "onSendAction", "onUploadAction", "onFileRemoveAction", "onFileSelection", "onEditorClickAction", "onRecordVideoAction"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageMarkdownEditorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-messages-message-markdown-editor',
                    template: ` <multimedia-markdown-editor
    #multiMediaMarkdownEditor
    [editorTextContent]="message"
    [mentionConfig]="mentionConfig"
    [isEditMode]="isEditMode"
    [disableEditorInput]="disableChatInput"
    [disableEditorInfoMessage]="'This conversation is closed so you cannot send messages'"
    [maxFileSize]="maxFileSize"
    [maxNumberOfAttachments]="maxNumberOfAttachments"
    (stateChanged)="setDraft($event)"
    (onSendAction)="onSend($event)"
    (onUploadAction)="onUpload($event)"
  ></multimedia-markdown-editor>`,
                    // changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { multiMediaMarkdownEditor: [{
                type: ViewChild,
                args: ['multiMediaMarkdownEditor']
            }], disableChatInput: [{
                type: Input
            }], sendingMessage: [{
                type: Input
            }], message: [{
                type: Input
            }], userId: [{
                type: Input
            }], mentions: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], isEditMode: [{
                type: Input
            }], conversationId: [{
                type: Input
            }], newMessage: [{
                type: Output
            }] } });

const FAILED_STATUSES = [MessageStatus.Failed, MessageStatus.FailedRetry];
class UiMessageComponent {
    set messageConfig(config) {
        this._messageConfig = { ...this._messageConfig, ...config };
    }
    constructor(viewportService) {
        this.viewportService = viewportService;
        this.conversationClosed = false;
        this._messageConfig = {
            ...DEFAULT_MESSAGE_CONFIG,
        };
        this.emitEditMessage = new EventEmitter();
        this.fetchReactionInformation = new EventEmitter(); // emits reactionId: userIds[]
        this.emitReactOnMessage = new EventEmitter();
        this.deleteMessage = new EventEmitter();
        this.retryMessage = new EventEmitter(); // TODO: Implement
        this.onDeleteAttachment = new EventEmitter();
        this.emitEditMode = new EventEmitter();
        this.editMessage = false;
        this.canShowTools = false;
        this.isMobile$ = this.viewportService.viewportSizeChanged$.pipe(map((data) => data == 'md' || data == 'sm' || data == 'xs'), filter(isNotNil));
        this.showReaction = false;
        this.showEditedMessages = false;
        this.MessageStatus = MessageStatus;
        this.failedStatuses = FAILED_STATUSES;
    }
    get messageStyle() {
        return {
            'e11-text-skin-base': this.message.status === MessageStatus.Sent,
            'e11-text-gray-500': this.message.status === MessageStatus.Sending,
            'e11-text-skin-error': this.failedStatuses.includes(this.message.status),
        };
    }
    onEdit() {
        this.editMessage = true;
        this.emitEditMode.emit(true);
    }
    onReaction(reaction) {
        switch (reaction.icon) {
            case 'close':
                this.showReaction = false;
                break;
            default:
                this.processReaction(reaction.emojiUnicode);
        }
    }
    processReaction(emojiUnicode) {
        if (this.message.reactions && this.message.reactions[emojiUnicode] && this.message.reactions[emojiUnicode].includes(this.userId)) {
            this.emitReactOnMessage.emit({
                reaction: emojiUnicode,
                type: 'onDeleteReaction',
            });
            return;
        }
        this.emitReactOnMessage.emit({
            reaction: emojiUnicode,
            type: 'onReactToMessage',
        });
    }
    onEditMessage(editedMessage) {
        this.emitEditMessage.emit(editedMessage);
        this.editMessage = false;
    }
    deleteMessageConfirmation(shouldDelete) {
        if (!shouldDelete) {
            return;
        }
        this.deleteMessage.emit();
    }
    onKeydownHandler(event) {
        if (event.key === 'Escape') {
            this.editMessage = false;
        }
    }
    calculateCanShowTools() {
        const isNotSending = this.message.status !== MessageStatus.Sending;
        const isSender = this.message.senderId === this.userId;
        // If conversation is closed or message is sending, don't show tools
        if (this.conversationClosed || !isNotSending)
            return false;
        const isFailedRetry = this.message.status === MessageStatus.FailedRetry;
        // If message is retrying or message config is not available, show tools
        if (isFailedRetry || !this.messageConfig)
            return true;
        const { canDeleteAllMessages, canReactOnMessages, canDeleteOwnMessages, canEditOwnMessages } = this._messageConfig;
        const hasGeneralPermissions = canDeleteAllMessages || canReactOnMessages;
        const hasOwnMessagePermissions = (canDeleteOwnMessages || canEditOwnMessages) && isSender;
        return hasGeneralPermissions || hasOwnMessagePermissions;
    }
    ngOnInit() {
        this.canShowTools = this.calculateCanShowTools();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiMessageComponent, deps: [{ token: i1$4.ViewportService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UiMessageComponent, selector: "sdk-messaging-ui-message", inputs: { message: "message", userId: "userId", conversationClosed: "conversationClosed", autocomplete: "autocomplete", lastMessageReadInfo: "lastMessageReadInfo", messageConfig: "messageConfig" }, outputs: { emitEditMessage: "emitEditMessage", fetchReactionInformation: "fetchReactionInformation", emitReactOnMessage: "emitReactOnMessage", deleteMessage: "deleteMessage", retryMessage: "retryMessage", onDeleteAttachment: "onDeleteAttachment", emitEditMode: "emitEditMode" }, host: { listeners: { "document:keydown": "onKeydownHandler($event)" } }, ngImport: i0, template: "<div class=\"e11-group/chat-message e11-relative e11-group e11-p-2 hover:e11-bg-skin-grey/10 e11-transition-colors e11-duration-200 e11-rounded-md\">\n  <sdk-messaging-ui-tools\n    *ngIf=\"canShowTools\"\n    [showReaction]=\"showReaction\"\n    [userId]=\"userId\"\n    [message]=\"message\"\n    [messageConfig]=\"_messageConfig\"\n    [failedStatuses]=\"failedStatuses\"\n    (onEdit)=\"onEdit()\"\n    (onReaction)=\"onReaction($event)\"\n    (onDelete)=\"deleteMessage.emit()\"\n    (onConfirmDelete)=\"deleteConfirmation.open()\"\n  >\n  </sdk-messaging-ui-tools>\n\n  <div class=\"e11-flex e11-gap-2\">\n    <sdk-message-avatar [message]=\"message\"></sdk-message-avatar>\n\n    <div *ngIf=\"!editMessage\" class=\"e11-flex e11-flex-col\">\n      <div class=\"single-message-header e11-flex e11-gap-3 e11-items-center\">\n        <p class=\"e11-m-0 e11-text-base e11-text-skin-base e11-font-black e11-font-skin-primary\">\n          {{ message.senderInformation.displayName }}\n        </p>\n        <p *ngIf=\"message.senderInformation.secondaryName && !message.senderInformation.isDisabled\" class=\"e11-m-0 e11-text-sm e11-text-skin-light\">\n          ({{ message.senderInformation.secondaryName }})\n        </p>\n        <p *ngIf=\"message.senderInformation.isDisabled\" class=\"e11-m-0 e11-text-sm e11-text-skin-light\">({{ \"disabled\" | translate }})</p>\n        <sdk-messaging-ui-message-timestamp\n          [messageId]=\"message.id\"\n          [lastMessageReadInfo]=\"lastMessageReadInfo\"\n          [sentDate]=\"message.__createdAt\"\n        ></sdk-messaging-ui-message-timestamp>\n\n        <span\n          *ngIf=\"message.edited\"\n          class=\"e11-text-sm e11-text-skin-primary e11-cursor-pointer e11-ml-1\"\n          (click)=\"showEditedMessages = !showEditedMessages\"\n          >({{ showEditedMessages ? \"Hide Edits\" : (\"Edited\" | translate) }})</span\n        >\n      </div>\n      <div class=\"message\">\n        <div class=\"e11-ui-message e11-text-sm\" [ngClass]=\"messageStyle\">\n          <div *ngIf=\"showEditedMessages\" class=\"e11-flex e11-flex-col e11-gap-2 e11-pb-2\">\n            <div *ngFor=\"let editedMessage of message.editedMessages\" class=\"!e11-bg-skin-grey/20 e11-rounded-md e11-p-4 e11-ml-4\">\n              <ui-message-markdown [message]=\"$any(editedMessage)\" [userId]=\"userId\"></ui-message-markdown>\n              <sdk-messaging-ui-message-timestamp\n                [messageId]=\"message.id\"\n                [lastMessageReadInfo]=\"lastMessageReadInfo\"\n                [sentDate]=\"editedMessage.sendAt\"\n              ></sdk-messaging-ui-message-timestamp>\n            </div>\n          </div>\n\n          <ui-message-markdown [message]=\"message\" [userId]=\"userId\"></ui-message-markdown>\n          <sdk-messaging-ui-message-attachments\n            *ngIf=\"message.attachments && message.attachments.length\"\n            [message]=\"message\"\n            [canDelete]=\"(_messageConfig.canDeleteOwnMessages && message.senderId === userId) || _messageConfig.canDeleteAllMessages\"\n            (onDelete)=\"onDeleteAttachment.emit($event)\"\n          ></sdk-messaging-ui-message-attachments>\n        </div>\n        <sdk-message-reactions\n          [message]=\"message\"\n          [userId]=\"userId\"\n          (reactionClicked)=\"processReaction($event)\"\n          (fetchReactionInformation)=\"fetchReactionInformation.emit($event)\"\n        ></sdk-message-reactions>\n      </div>\n    </div>\n\n    <!-- More button-->\n    <button\n      *ngIf=\"_messageConfig.canEditOwnMessages && !editMessage && message.senderId === userId\"\n      class=\"e11-group e11-ml-auto e11-invisible group-hover:e11-visible\"\n    >\n      <div\n        class=\"e11-hidden group-focus-within:e11-block e11-absolute e11-w-10 e11-bg-white e11-right-6 e11-top-0 e11--mt-4 e11-px-2 e11-py-1 e11-border e11-rounded-md e11-border-gray-200\"\n      >\n        <div class=\"e11-flex e11-flex-row e11-gap-2 e11-justify-between\">\n          <button\n            *ngIf=\"message.senderId === userId\"\n            (click)=\"onEdit()\"\n            class=\"e11-text-gray-500 e11-rounded e11-cursor-pointer hover:e11-text-gray-900\"\n          >\n            <span class=\"material-icons e11-text-lg\">edit</span>\n          </button>\n        </div>\n      </div>\n    </button>\n    <div\n      *ngIf=\"!editMessage && message.status === MessageStatus.FailedRetry\"\n      class=\"e11-flex e11-items-center e11-text-skin-error e11-text-xs sm:e11-text-sm e11-cursor-pointer\"\n      (click)=\"retryMessage.emit()\"\n    >\n      <div class=\"\">{{ ((isMobile$ | async) ? \"Retry\" : \"Send Failed. Retry\") | translate }}</div>\n      <span class=\"material-icons e11-text-[18px] e11-ml-1\">send</span>\n    </div>\n\n    <div *ngIf=\"editMessage\" class=\"e11-flex-grow\">\n      <!-- Edit message-->\n      <ng-container>\n        <sdk-messages-message-markdown-editor\n          [isEditMode]=\"true\"\n          [autocomplete]=\"autocomplete\"\n          [mentions]=\"message.mentions || {}\"\n          (newMessage)=\"onEditMessage($event)\"\n          [message]=\"message.text ?? ''\"\n        ></sdk-messages-message-markdown-editor>\n      </ng-container>\n    </div>\n  </div>\n</div>\n\n<e11-confirmation\n  #deleteConfirmation\n  e11AppendTo=\"body\"\n  confirmTitle=\"{{ 'Deleting this message' | translate }}\"\n  confirmText=\"{{ 'Delete message' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  [isMobile]=\"(isMobile$ | async) ?? false\"\n  (answer)=\"deleteMessageConfirmation($event)\"\n>\n  {{ \"Are you sure you want to delete this message?\" | translate }}\n</e11-confirmation>\n", styles: [".e11-ui-message{word-break:break-word}.e11-ui-message a{text-decoration:underline}.e11-ui-message ol,.e11-ui-message ul{margin:10px;padding:10px}.e11-ui-message ol{list-style:auto;list-style-type:decimal}.e11-ui-message ul{list-style:disc}.e11-ui-message em,.e11-ui-message em strong{font-style:italic}.e11-ui-message p{margin-bottom:0}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.E11AppendToDirective, selector: "[e11AppendTo]", inputs: ["e11AppendTo"] }, { kind: "component", type: i6$2.E11ConfirmationComponent, selector: "e11-confirmation", inputs: ["confirmTitle", "confirmText", "cancelText", "confirmClassOverrides", "cancelClassOverrides", "isMobile", "processing", "processingText", "closeOnEscape", "closeOnClickOutside", "hasBackdrop", "backdropStyle", "confirmValueWithInputBox", "valueToConfirm"], outputs: ["answer"] }, { kind: "component", type: UIMessageMarkdownComponent, selector: "ui-message-markdown", inputs: ["message", "userId"] }, { kind: "component", type: UiMessageTimestampComponent, selector: "sdk-messaging-ui-message-timestamp", inputs: ["lastMessageReadInfo", "messageId", "sentDate"] }, { kind: "component", type: UiMessageToolsComponent, selector: "sdk-messaging-ui-tools", inputs: ["showReaction", "userId", "failedStatuses", "message", "messageConfig"], outputs: ["onEdit", "onReaction", "onDelete", "onConfirmDelete"] }, { kind: "component", type: MessageAvatarComponent, selector: "sdk-message-avatar", inputs: ["message"] }, { kind: "component", type: ReactionsComponent, selector: "sdk-message-reactions", inputs: ["message", "userId"], outputs: ["reactionClicked", "fetchReactionInformation"] }, { kind: "component", type: UIMessageAttachmentsComponent, selector: "sdk-messaging-ui-message-attachments", inputs: ["canDelete", "message"], outputs: ["onDelete"] }, { kind: "component", type: MessageMarkdownEditorComponent, selector: "sdk-messages-message-markdown-editor", inputs: ["disableChatInput", "sendingMessage", "message", "userId", "mentions", "autocomplete", "isEditMode", "conversationId"], outputs: ["newMessage"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-messaging-ui-message', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"e11-group/chat-message e11-relative e11-group e11-p-2 hover:e11-bg-skin-grey/10 e11-transition-colors e11-duration-200 e11-rounded-md\">\n  <sdk-messaging-ui-tools\n    *ngIf=\"canShowTools\"\n    [showReaction]=\"showReaction\"\n    [userId]=\"userId\"\n    [message]=\"message\"\n    [messageConfig]=\"_messageConfig\"\n    [failedStatuses]=\"failedStatuses\"\n    (onEdit)=\"onEdit()\"\n    (onReaction)=\"onReaction($event)\"\n    (onDelete)=\"deleteMessage.emit()\"\n    (onConfirmDelete)=\"deleteConfirmation.open()\"\n  >\n  </sdk-messaging-ui-tools>\n\n  <div class=\"e11-flex e11-gap-2\">\n    <sdk-message-avatar [message]=\"message\"></sdk-message-avatar>\n\n    <div *ngIf=\"!editMessage\" class=\"e11-flex e11-flex-col\">\n      <div class=\"single-message-header e11-flex e11-gap-3 e11-items-center\">\n        <p class=\"e11-m-0 e11-text-base e11-text-skin-base e11-font-black e11-font-skin-primary\">\n          {{ message.senderInformation.displayName }}\n        </p>\n        <p *ngIf=\"message.senderInformation.secondaryName && !message.senderInformation.isDisabled\" class=\"e11-m-0 e11-text-sm e11-text-skin-light\">\n          ({{ message.senderInformation.secondaryName }})\n        </p>\n        <p *ngIf=\"message.senderInformation.isDisabled\" class=\"e11-m-0 e11-text-sm e11-text-skin-light\">({{ \"disabled\" | translate }})</p>\n        <sdk-messaging-ui-message-timestamp\n          [messageId]=\"message.id\"\n          [lastMessageReadInfo]=\"lastMessageReadInfo\"\n          [sentDate]=\"message.__createdAt\"\n        ></sdk-messaging-ui-message-timestamp>\n\n        <span\n          *ngIf=\"message.edited\"\n          class=\"e11-text-sm e11-text-skin-primary e11-cursor-pointer e11-ml-1\"\n          (click)=\"showEditedMessages = !showEditedMessages\"\n          >({{ showEditedMessages ? \"Hide Edits\" : (\"Edited\" | translate) }})</span\n        >\n      </div>\n      <div class=\"message\">\n        <div class=\"e11-ui-message e11-text-sm\" [ngClass]=\"messageStyle\">\n          <div *ngIf=\"showEditedMessages\" class=\"e11-flex e11-flex-col e11-gap-2 e11-pb-2\">\n            <div *ngFor=\"let editedMessage of message.editedMessages\" class=\"!e11-bg-skin-grey/20 e11-rounded-md e11-p-4 e11-ml-4\">\n              <ui-message-markdown [message]=\"$any(editedMessage)\" [userId]=\"userId\"></ui-message-markdown>\n              <sdk-messaging-ui-message-timestamp\n                [messageId]=\"message.id\"\n                [lastMessageReadInfo]=\"lastMessageReadInfo\"\n                [sentDate]=\"editedMessage.sendAt\"\n              ></sdk-messaging-ui-message-timestamp>\n            </div>\n          </div>\n\n          <ui-message-markdown [message]=\"message\" [userId]=\"userId\"></ui-message-markdown>\n          <sdk-messaging-ui-message-attachments\n            *ngIf=\"message.attachments && message.attachments.length\"\n            [message]=\"message\"\n            [canDelete]=\"(_messageConfig.canDeleteOwnMessages && message.senderId === userId) || _messageConfig.canDeleteAllMessages\"\n            (onDelete)=\"onDeleteAttachment.emit($event)\"\n          ></sdk-messaging-ui-message-attachments>\n        </div>\n        <sdk-message-reactions\n          [message]=\"message\"\n          [userId]=\"userId\"\n          (reactionClicked)=\"processReaction($event)\"\n          (fetchReactionInformation)=\"fetchReactionInformation.emit($event)\"\n        ></sdk-message-reactions>\n      </div>\n    </div>\n\n    <!-- More button-->\n    <button\n      *ngIf=\"_messageConfig.canEditOwnMessages && !editMessage && message.senderId === userId\"\n      class=\"e11-group e11-ml-auto e11-invisible group-hover:e11-visible\"\n    >\n      <div\n        class=\"e11-hidden group-focus-within:e11-block e11-absolute e11-w-10 e11-bg-white e11-right-6 e11-top-0 e11--mt-4 e11-px-2 e11-py-1 e11-border e11-rounded-md e11-border-gray-200\"\n      >\n        <div class=\"e11-flex e11-flex-row e11-gap-2 e11-justify-between\">\n          <button\n            *ngIf=\"message.senderId === userId\"\n            (click)=\"onEdit()\"\n            class=\"e11-text-gray-500 e11-rounded e11-cursor-pointer hover:e11-text-gray-900\"\n          >\n            <span class=\"material-icons e11-text-lg\">edit</span>\n          </button>\n        </div>\n      </div>\n    </button>\n    <div\n      *ngIf=\"!editMessage && message.status === MessageStatus.FailedRetry\"\n      class=\"e11-flex e11-items-center e11-text-skin-error e11-text-xs sm:e11-text-sm e11-cursor-pointer\"\n      (click)=\"retryMessage.emit()\"\n    >\n      <div class=\"\">{{ ((isMobile$ | async) ? \"Retry\" : \"Send Failed. Retry\") | translate }}</div>\n      <span class=\"material-icons e11-text-[18px] e11-ml-1\">send</span>\n    </div>\n\n    <div *ngIf=\"editMessage\" class=\"e11-flex-grow\">\n      <!-- Edit message-->\n      <ng-container>\n        <sdk-messages-message-markdown-editor\n          [isEditMode]=\"true\"\n          [autocomplete]=\"autocomplete\"\n          [mentions]=\"message.mentions || {}\"\n          (newMessage)=\"onEditMessage($event)\"\n          [message]=\"message.text ?? ''\"\n        ></sdk-messages-message-markdown-editor>\n      </ng-container>\n    </div>\n  </div>\n</div>\n\n<e11-confirmation\n  #deleteConfirmation\n  e11AppendTo=\"body\"\n  confirmTitle=\"{{ 'Deleting this message' | translate }}\"\n  confirmText=\"{{ 'Delete message' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  [isMobile]=\"(isMobile$ | async) ?? false\"\n  (answer)=\"deleteMessageConfirmation($event)\"\n>\n  {{ \"Are you sure you want to delete this message?\" | translate }}\n</e11-confirmation>\n", styles: [".e11-ui-message{word-break:break-word}.e11-ui-message a{text-decoration:underline}.e11-ui-message ol,.e11-ui-message ul{margin:10px;padding:10px}.e11-ui-message ol{list-style:auto;list-style-type:decimal}.e11-ui-message ul{list-style:disc}.e11-ui-message em,.e11-ui-message em strong{font-style:italic}.e11-ui-message p{margin-bottom:0}\n"] }]
        }], ctorParameters: () => [{ type: i1$4.ViewportService }], propDecorators: { message: [{
                type: Input
            }], userId: [{
                type: Input
            }], conversationClosed: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], lastMessageReadInfo: [{
                type: Input
            }], messageConfig: [{
                type: Input
            }], emitEditMessage: [{
                type: Output
            }], fetchReactionInformation: [{
                type: Output
            }], emitReactOnMessage: [{
                type: Output
            }], deleteMessage: [{
                type: Output
            }], retryMessage: [{
                type: Output
            }], onDeleteAttachment: [{
                type: Output
            }], emitEditMode: [{
                type: Output
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

class UISkeletonMessageComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UISkeletonMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UISkeletonMessageComponent, selector: "ui-skeleton-message", inputs: { index: "index" }, ngImport: i0, template: `
    <div class="e11-mt-4">
      <div class="e11-animate-pulse e11-flex e11-space-x-4 e11-mt-4">
        <div class="e11-rounded-full e11-bg-slate-200 e11-h-10 e11-w-10 e11-mt-auto e11-mr-2"></div>
        <div class="e11-flex-1 e11-space-y-6 e11-py-1">
          <div class="e11-h-2 e11-bg-slate-200 e11-rounded"></div>
          <div class="e11-space-y-3">
            <div class="e11-h-2 e11-bg-slate-200 e11-rounded"></div>
            <div class="e11-grid e11-grid-cols-3 e11-gap-4 e11-space-x-reverse">
              <div class="e11-h-2 e11-rounded 'e11-col-span-1 e11-bg-slate-200"></div>
              <div class="e11-h-2 e11-bg-slate-200 e11-rounded e11-col-span-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `, isInline: true, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UISkeletonMessageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ui-skeleton-message',
                    template: `
    <div class="e11-mt-4">
      <div class="e11-animate-pulse e11-flex e11-space-x-4 e11-mt-4">
        <div class="e11-rounded-full e11-bg-slate-200 e11-h-10 e11-w-10 e11-mt-auto e11-mr-2"></div>
        <div class="e11-flex-1 e11-space-y-6 e11-py-1">
          <div class="e11-h-2 e11-bg-slate-200 e11-rounded"></div>
          <div class="e11-space-y-3">
            <div class="e11-h-2 e11-bg-slate-200 e11-rounded"></div>
            <div class="e11-grid e11-grid-cols-3 e11-gap-4 e11-space-x-reverse">
              <div class="e11-h-2 e11-rounded 'e11-col-span-1 e11-bg-slate-200"></div>
              <div class="e11-h-2 e11-bg-slate-200 e11-rounded e11-col-span-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], propDecorators: { index: [{
                type: Input
            }] } });

class ConversationImageComponent {
    constructor() {
        this.size = 'lg';
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationImageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationImageComponent, selector: "sdk-messaging-conversation-image", inputs: { conversationImageData: "conversationImageData", size: "size" }, ngImport: i0, template: "<e11-profile-pic\n  [size]=\"size\"\n  [type]=\"'circular'\"\n  [imageUrl]=\"conversationImageData?.imageUrl\"\n  [textValue]=\"conversationImageData?.textFallback\"\n  [icon]=\"conversationImageData?.icon\"\n>\n</e11-profile-pic>\n", styles: [""], dependencies: [{ kind: "component", type: i1$6.E11ProfilePicComponent, selector: "e11-profile-pic", inputs: ["value", "style", "imageUrl", "imageFit", "size", "edit", "disabled", "type", "hasBorder", "hasRing", "icon", "iconPositionY", "iconPositionX", "textValue", "imageClass", "textClass", "iconClass", "loadingImageUrl"], outputs: ["editProfilePic"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationImageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-messaging-conversation-image', template: "<e11-profile-pic\n  [size]=\"size\"\n  [type]=\"'circular'\"\n  [imageUrl]=\"conversationImageData?.imageUrl\"\n  [textValue]=\"conversationImageData?.textFallback\"\n  [icon]=\"conversationImageData?.icon\"\n>\n</e11-profile-pic>\n" }]
        }], ctorParameters: () => [], propDecorators: { conversationImageData: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class SideOverHeaderComponent {
    constructor() {
        this.emitClose = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SideOverHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: SideOverHeaderComponent, selector: "conversation-side-over-header", inputs: { conversationDisplayData: "conversationDisplayData" }, outputs: { emitClose: "emitClose" }, ngImport: i0, template: "<div class=\"e11-mx-4 e11-border-b-[1px] sm:e11-mx-6 e11-pt-6 e11-pb-3\">\n  <div class=\"e11-flex e11-items-start e11-justify-between\">\n    <div class=\"e11-flex e11-items-center e11-space-x-4\">\n      <sdk-messaging-conversation-image [conversationImageData]=\"conversationDisplayData.conversationImageData\"></sdk-messaging-conversation-image>\n      <div class=\"e11-flex e11-flex-col e11-leading-tight\">\n        <div class=\"e11-text-sm md:e11-text-2xl e11-mt-1 e11-flex e11-items-center\">\n          <span class=\"e11-text-skin-primary e11-mr-3 e11-font-semibold\">{{ conversationDisplayData.conversationName }}</span>\n        </div>\n        <span class=\"e11-text-xs md:e11-text-sm e11-text-gray-500\"> {{ conversationDisplayData.conversationSubtitle }}</span>\n      </div>\n    </div>\n    <div class=\"e11-ml-3 e11-h-7 e11-flex e11-items-center\">\n      <button\n        (click)=\"emitClose.emit()\"\n        type=\"button\"\n        class=\"e11-bg-white e11-rounded-md e11-text-gray-400 hover:e11-text-gray-500 focus:e11-outline-none focus:e11-ring-2 focus:e11-ring-indigo-500\"\n      >\n        <span class=\"e11-sr-only\">{{ \"Close Messaging panel\" | translate }}</span>\n        <svg class=\"e11-h-6 e11-w-6\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" aria-hidden=\"true\">\n          <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M6 18L18 6M6 6l12 12\" />\n        </svg>\n      </button>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "component", type: ConversationImageComponent, selector: "sdk-messaging-conversation-image", inputs: ["conversationImageData", "size"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SideOverHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'conversation-side-over-header', template: "<div class=\"e11-mx-4 e11-border-b-[1px] sm:e11-mx-6 e11-pt-6 e11-pb-3\">\n  <div class=\"e11-flex e11-items-start e11-justify-between\">\n    <div class=\"e11-flex e11-items-center e11-space-x-4\">\n      <sdk-messaging-conversation-image [conversationImageData]=\"conversationDisplayData.conversationImageData\"></sdk-messaging-conversation-image>\n      <div class=\"e11-flex e11-flex-col e11-leading-tight\">\n        <div class=\"e11-text-sm md:e11-text-2xl e11-mt-1 e11-flex e11-items-center\">\n          <span class=\"e11-text-skin-primary e11-mr-3 e11-font-semibold\">{{ conversationDisplayData.conversationName }}</span>\n        </div>\n        <span class=\"e11-text-xs md:e11-text-sm e11-text-gray-500\"> {{ conversationDisplayData.conversationSubtitle }}</span>\n      </div>\n    </div>\n    <div class=\"e11-ml-3 e11-h-7 e11-flex e11-items-center\">\n      <button\n        (click)=\"emitClose.emit()\"\n        type=\"button\"\n        class=\"e11-bg-white e11-rounded-md e11-text-gray-400 hover:e11-text-gray-500 focus:e11-outline-none focus:e11-ring-2 focus:e11-ring-indigo-500\"\n      >\n        <span class=\"e11-sr-only\">{{ \"Close Messaging panel\" | translate }}</span>\n        <svg class=\"e11-h-6 e11-w-6\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" aria-hidden=\"true\">\n          <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M6 18L18 6M6 6l12 12\" />\n        </svg>\n      </button>\n    </div>\n  </div>\n</div>\n" }]
        }], propDecorators: { conversationDisplayData: [{
                type: Input
            }], emitClose: [{
                type: Output
            }] } });

class FullPageHeaderComponent {
    constructor(viewportService) {
        this.viewportService = viewportService;
        this.deleteConversation = new EventEmitter();
        this.isMobile$ = this.viewportService.viewportSizeChanged$.pipe(map((data) => data == 'md' || data == 'sm' || data == 'xs'), filter(isNotNil));
    }
    deleteMessageConfirmation(shouldDelete) {
        if (!shouldDelete) {
            return;
        }
        this.deleteConversation.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FullPageHeaderComponent, deps: [{ token: i1$4.ViewportService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: FullPageHeaderComponent, selector: "conversation-full-page-header", inputs: { conversationDisplayData: "conversationDisplayData", messageConfig: "messageConfig" }, outputs: { deleteConversation: "deleteConversation" }, ngImport: i0, template: "<div class=\"e11-border-b\">\n  <div class=\"e11-pb-2\">\n    <div class=\"e11-flex e11-justify-between\">\n      <div class=\"e11-flex e11-items-center e11-gap-2\">\n        <span class=\"e11-font-light e11-text-base\" *ngIf=\"!((isMobile$ | async) ?? false)\"> {{ \"A conversation with \" | translate }} </span>\n        <sdk-messaging-conversation-image\n          [size]=\"'sm'\"\n          [conversationImageData]=\"conversationDisplayData.conversationImageData\"\n        ></sdk-messaging-conversation-image>\n        <span class=\"e11-text-gray e11-text-sm e11-font-light\">{{ conversationDisplayData.conversationName }}</span>\n      </div>\n      <div *ngIf=\"messageConfig?.canDeleteConversation\">\n        <p class=\"e11-flex e11-items-center e11-text-sm e11-text-skin-secondary e11-cursor-pointer\" (click)=\"deleteConfirmation.open()\">\n          {{ \"Delete\" | translate }}\n          <span class=\"material-icons-outlined e11-text-skin-secondary e11-ml-1 md-18\">delete_outline</span>\n        </p>\n      </div>\n    </div>\n\n    <span class=\"e11-text-xs md:e11-text-sm e11-text-gray-400\">{{ conversationDisplayData.conversationSubtitle }}</span>\n  </div>\n</div>\n\n<e11-confirmation\n  #deleteConfirmation\n  confirmTitle=\"{{ 'Delete Conversation' | translate }}\"\n  confirmText=\"{{ 'Delete conversation' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  [isMobile]=\"(isMobile$ | async) ?? false\"\n  (answer)=\"deleteMessageConfirmation($event)\"\n>\n  <p>{{ \"You are about to delete this entire conversation with this user.\" | translate }}</p>\n  <p class=\"e11-block e11-mt-2\">{{ \"Are you sure you want to do this?\" | translate }}</p>\n</e11-confirmation>\n", dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6$2.E11ConfirmationComponent, selector: "e11-confirmation", inputs: ["confirmTitle", "confirmText", "cancelText", "confirmClassOverrides", "cancelClassOverrides", "isMobile", "processing", "processingText", "closeOnEscape", "closeOnClickOutside", "hasBackdrop", "backdropStyle", "confirmValueWithInputBox", "valueToConfirm"], outputs: ["answer"] }, { kind: "component", type: ConversationImageComponent, selector: "sdk-messaging-conversation-image", inputs: ["conversationImageData", "size"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FullPageHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'conversation-full-page-header', template: "<div class=\"e11-border-b\">\n  <div class=\"e11-pb-2\">\n    <div class=\"e11-flex e11-justify-between\">\n      <div class=\"e11-flex e11-items-center e11-gap-2\">\n        <span class=\"e11-font-light e11-text-base\" *ngIf=\"!((isMobile$ | async) ?? false)\"> {{ \"A conversation with \" | translate }} </span>\n        <sdk-messaging-conversation-image\n          [size]=\"'sm'\"\n          [conversationImageData]=\"conversationDisplayData.conversationImageData\"\n        ></sdk-messaging-conversation-image>\n        <span class=\"e11-text-gray e11-text-sm e11-font-light\">{{ conversationDisplayData.conversationName }}</span>\n      </div>\n      <div *ngIf=\"messageConfig?.canDeleteConversation\">\n        <p class=\"e11-flex e11-items-center e11-text-sm e11-text-skin-secondary e11-cursor-pointer\" (click)=\"deleteConfirmation.open()\">\n          {{ \"Delete\" | translate }}\n          <span class=\"material-icons-outlined e11-text-skin-secondary e11-ml-1 md-18\">delete_outline</span>\n        </p>\n      </div>\n    </div>\n\n    <span class=\"e11-text-xs md:e11-text-sm e11-text-gray-400\">{{ conversationDisplayData.conversationSubtitle }}</span>\n  </div>\n</div>\n\n<e11-confirmation\n  #deleteConfirmation\n  confirmTitle=\"{{ 'Delete Conversation' | translate }}\"\n  confirmText=\"{{ 'Delete conversation' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  [isMobile]=\"(isMobile$ | async) ?? false\"\n  (answer)=\"deleteMessageConfirmation($event)\"\n>\n  <p>{{ \"You are about to delete this entire conversation with this user.\" | translate }}</p>\n  <p class=\"e11-block e11-mt-2\">{{ \"Are you sure you want to do this?\" | translate }}</p>\n</e11-confirmation>\n" }]
        }], ctorParameters: () => [{ type: i1$4.ViewportService }], propDecorators: { conversationDisplayData: [{
                type: Input
            }], messageConfig: [{
                type: Input
            }], deleteConversation: [{
                type: Output
            }] } });

class ConversationHeaderComponent {
    constructor() {
        this.headerType = ConversationHeaderType.Full;
        this.emitClose = new EventEmitter();
        this.emitDeleteConversation = new EventEmitter();
        this.headerTypeEnum = ConversationHeaderType;
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationHeaderComponent, selector: "sdk-conversation-header", inputs: { conversationDisplayData: "conversationDisplayData", headerType: "headerType", messageConfig: "messageConfig" }, outputs: { emitClose: "emitClose", emitDeleteConversation: "emitDeleteConversation" }, ngImport: i0, template: "<!-- Side-over header-->\n<conversation-side-over-header\n  *ngIf=\"headerType === headerTypeEnum.SideOver\"\n  [conversationDisplayData]=\"conversationDisplayData\"\n  (emitClose)=\"emitClose.emit()\"\n>\n</conversation-side-over-header>\n<!-- Full page header-->\n<conversation-full-page-header\n  *ngIf=\"headerType === headerTypeEnum.Full\"\n  [conversationDisplayData]=\"conversationDisplayData\"\n  (deleteConversation)=\"emitDeleteConversation.emit()\"\n  [messageConfig]=\"messageConfig\"\n>\n</conversation-full-page-header>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SideOverHeaderComponent, selector: "conversation-side-over-header", inputs: ["conversationDisplayData"], outputs: ["emitClose"] }, { kind: "component", type: FullPageHeaderComponent, selector: "conversation-full-page-header", inputs: ["conversationDisplayData", "messageConfig"], outputs: ["deleteConversation"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-conversation-header', template: "<!-- Side-over header-->\n<conversation-side-over-header\n  *ngIf=\"headerType === headerTypeEnum.SideOver\"\n  [conversationDisplayData]=\"conversationDisplayData\"\n  (emitClose)=\"emitClose.emit()\"\n>\n</conversation-side-over-header>\n<!-- Full page header-->\n<conversation-full-page-header\n  *ngIf=\"headerType === headerTypeEnum.Full\"\n  [conversationDisplayData]=\"conversationDisplayData\"\n  (deleteConversation)=\"emitDeleteConversation.emit()\"\n  [messageConfig]=\"messageConfig\"\n>\n</conversation-full-page-header>\n" }]
        }], ctorParameters: () => [], propDecorators: { conversationDisplayData: [{
                type: Input
            }], headerType: [{
                type: Input
            }], messageConfig: [{
                type: Input
            }], emitClose: [{
                type: Output
            }], emitDeleteConversation: [{
                type: Output
            }] } });

class ParticipantNamesPipe {
    transform(participants, args) {
        return Object.values(participants || {})
            .map((v) => v.displayName)
            .join(', ');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ParticipantNamesPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: ParticipantNamesPipe, name: "participantNames" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ParticipantNamesPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'participantNames',
                }]
        }] });

class UiMessagesStarterComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiMessagesStarterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UiMessagesStarterComponent, selector: "ui-message-starter", inputs: { participantInformation: "participantInformation" }, ngImport: i0, template: `
    <div class="e11-w-full e11-flex e11-items-center">
      <div class="e11-bg-skin-primary-accent e11-flex e11-items-center e11-w-fit e11-p-2 e11-rounded-full">
        <span class="material-icons-outlined e11-text-5xl e11-text-white"> group </span>
      </div>
      <div class="e11-grow e11-ml-2">
        <div class="e11-font-bold">{{ participantInformation | participantNames }}</div>
        <span class="e11-text-sm e11-text-skin-light"> {{ "This is the start of this chat's history" | translate }}</span>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }, { kind: "pipe", type: ParticipantNamesPipe, name: "participantNames" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiMessagesStarterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ui-message-starter',
                    template: `
    <div class="e11-w-full e11-flex e11-items-center">
      <div class="e11-bg-skin-primary-accent e11-flex e11-items-center e11-w-fit e11-p-2 e11-rounded-full">
        <span class="material-icons-outlined e11-text-5xl e11-text-white"> group </span>
      </div>
      <div class="e11-grow e11-ml-2">
        <div class="e11-font-bold">{{ participantInformation | participantNames }}</div>
        <span class="e11-text-sm e11-text-skin-light"> {{ "This is the start of this chat's history" | translate }}</span>
      </div>
    </div>
  `,
                }]
        }], propDecorators: { participantInformation: [{
                type: Input
            }] } });

class ActiveParticipantsPipe {
    transform(participantInformation) {
        if (!participantInformation)
            return participantInformation;
        const inactiveParticipantIds = Object.keys(participantInformation).filter((userId) => participantInformation[userId].inConversation === false);
        return omit(participantInformation, ...inactiveParticipantIds);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ActiveParticipantsPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: ActiveParticipantsPipe, name: "toActiveParticipantInformation" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ActiveParticipantsPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'toActiveParticipantInformation' }]
        }] });

class UIMessagesComponent {
    set messages(messages) {
        const messageCount = this._messages.length; // Set before this._messages so we know if we're on the initial load of the component
        this._messages = messages || [];
        if (messages) {
            this.groupedMessages = groupMessageVMsByDate(messages);
        }
        this.scrollIfShould(messageCount === 0);
    }
    constructor(logger, errorHandler) {
        this.logger = logger;
        this.errorHandler = errorHandler;
        this.headerType = ConversationHeaderType.Full;
        this.loading = true;
        this.moreMessagesLoading = false;
        this.fetchedAllMessages = false;
        this.disableChatInput = false; // TODO: Change to conversationClosed on next breaking change
        this.scrollOnChange = true;
        this.emitClose = new EventEmitter();
        this.emitNewMessage = new EventEmitter();
        this.emitReachedTop = new EventEmitter();
        this.emitEditMessage = new EventEmitter();
        this.emitReactOnMessage = new EventEmitter();
        this.emitDeleteMessage = new EventEmitter();
        this.emitDeleteConversation = new EventEmitter();
        this.fetchReactionInformation = new EventEmitter();
        this.emitRetryMessage = new EventEmitter(); // TODO: Determine whether we should make a retry request type
        this._messages = [];
        this.contextPlacement = ContextPlacement;
        this.contextCommunicationType = ContextCommunicationType;
        this.onDeleteAttachment = new EventEmitter();
    }
    ngAfterViewInit() {
        this.scrollOnChange && this.scrollToBottom();
    }
    ngOnChanges(changes) {
        const propertiesToCheck = ['messages', 'lastRead', 'latestMessage'];
        const hasChanges = propertiesToCheck.some((prop) => changes[prop] && changes[prop].previousValue !== changes[prop].currentValue);
        if (hasChanges) {
            this.updateLastMessageReadInfo();
        }
    }
    updateLastMessageReadInfo() {
        if (!this.lastRead || !this.latestMessage || !this.participantInformation || !this.userId) {
            return;
        }
        const { canViewOwnReadReceipts = false, canViewAllReadReceipts = false } = this.messageConfig || {};
        this.lastMessageReadInfo = LastReadUtil.getLastMessageReadInfo({
            lastRead: this.lastRead,
            messages: this._messages,
            participantsInfo: this.participantInformation,
            currentUserId: this.userId,
            readReceiptsConfig: { canViewOwnReadReceipts, canViewAllReadReceipts },
        });
    }
    trackById(_index, item) {
        return item.id;
    }
    trackByDate(_index, item) {
        return item[0];
    }
    onClose() {
        this.emitClose.emit();
    }
    onNewMessage(message) {
        this.emitNewMessage.emit(message);
        setTimeout(() => this.scrollToBottom(), 250);
    }
    onScrollUp() {
        if (!this.fetchedAllMessages) {
            this.logger.log('reached top, fetching more messages');
            this.emitReachedTop.emit();
        }
    }
    scrollIfLastMessageBeingEdited(message) {
        if (this._messages.length === 0)
            return;
        const latestMessage = this._messages[this._messages.length - 1];
        if (latestMessage?.id === message.id) {
            setTimeout(() => this.scrollToBottom(), 100);
        }
    }
    onEditMessage(message, messageId) {
        this.emitEditMessage.emit({ messageId, message });
    }
    onReactToMessage(reaction, messageId) {
        this.emitReactOnMessage.emit({ messageId, reaction });
    }
    onDeleteMessage(message) {
        this.emitDeleteMessage.emit({ messageId: message.id, confirmationId: message.confirmationId, conversationId: message.conversationId });
    }
    onRetryMessage(message) {
        this.emitRetryMessage.emit(message);
    }
    async scrollIfShould(firstLoad = false) {
        const domWaitTime = 10; // Needed to let the components initialize in the DOM
        if (firstLoad) {
            setTimeout(() => this.scrollToBottom(), domWaitTime);
        }
        else if (!this.hasScrolledPastLastMessage()) {
            setTimeout(() => this.scrollToBottom(), domWaitTime);
        }
    }
    hasScrolledPastLastMessage() {
        const lastMessageTop = this.messageElements.last?.nativeElement?.getBoundingClientRect()?.top;
        const messageContainerBottom = this.messageContainer.nativeElement?.getBoundingClientRect()?.bottom;
        if (!lastMessageTop || !messageContainerBottom) {
            this.errorHandler.warn('Could not get last message top or container bottom', { lastMessageTop, messageContainerBottom });
            return false;
        }
        return lastMessageTop > messageContainerBottom;
    }
    scrollToBottom() {
        try {
            this.messageContainer.nativeElement.scrollTop = this.messageContainer.nativeElement.scrollHeight;
        }
        catch (err) {
            this.logger.error(err);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIMessagesComponent, deps: [{ token: LOGGER_TOKEN }, { token: i1.E11ErrorHandlerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UIMessagesComponent, selector: "ui-messages", inputs: { conversationDisplayData: "conversationDisplayData", context: "context", contextType: "contextType", headerType: "headerType", loading: "loading", moreMessagesLoading: "moreMessagesLoading", fetchedAllMessages: "fetchedAllMessages", disableChatInput: "disableChatInput", scrollOnChange: "scrollOnChange", messageConfig: "messageConfig", participantInformation: "participantInformation", autocomplete: "autocomplete", conversationId: "conversationId", userId: "userId", lastRead: "lastRead", latestMessage: "latestMessage", messages: "messages" }, outputs: { emitClose: "emitClose", emitNewMessage: "emitNewMessage", emitReachedTop: "emitReachedTop", emitEditMessage: "emitEditMessage", emitReactOnMessage: "emitReactOnMessage", emitDeleteMessage: "emitDeleteMessage", emitDeleteConversation: "emitDeleteConversation", fetchReactionInformation: "fetchReactionInformation", emitRetryMessage: "emitRetryMessage", onDeleteAttachment: "onDeleteAttachment" }, viewQueries: [{ propertyName: "messageContainer", first: true, predicate: ["messageContainer"], descendants: true }, { propertyName: "messageElements", predicate: ["message"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"e11-flex e11-flex-col e11-h-full e11-bg-white\">\n  <div class=\"e11-bg-white e11-flex-shrink-0 e11-mb-2\">\n    <ng-content></ng-content>\n\n    <sdk-conversation-header\n      [conversationDisplayData]=\"conversationDisplayData ?? {}\"\n      [messageConfig]=\"messageConfig\"\n      [headerType]=\"headerType\"\n      (emitClose)=\"emitClose.emit()\"\n      (emitDeleteConversation)=\"emitDeleteConversation.emit()\"\n    ></sdk-conversation-header>\n  </div>\n  <ng-template #MessagesLoading>\n    <ng-container *ngFor=\"let item of [0, 1, 2, 3, 4, 5, 6]\">\n      <ui-skeleton-message [index]=\"item\"></ui-skeleton-message>\n    </ng-container>\n  </ng-template>\n  <div\n    #messageContainer\n    class=\"messages-results e11-overscroll-contain e11-scroll-mt-10 e11-flex e11-flex-col\"\n    infiniteScroll\n    [infiniteScrollDistance]=\"2\"\n    [infiniteScrollThrottle]=\"50\"\n    [immediateCheck]=\"true\"\n    [alwaysCallback]=\"true\"\n    (scrolledUp)=\"onScrollUp()\"\n    [scrollWindow]=\"false\"\n    [ngClass]=\"{\n      'messages-results-height-sideover e11-scroll-container-padded': context === contextPlacement.Sideover,\n      'messages-results-height-view': context === contextPlacement.View,\n      'messages-results-height-view-conversations': contextType === contextCommunicationType.Conversation\n    }\"\n  >\n    <ng-container *ngIf=\"!loading && userId; else MessagesLoading\">\n      <div class=\"e11-mt-auto\" *ngIf=\"fetchedAllMessages || !_messages?.length\">\n        <ui-message-starter [participantInformation]=\"participantInformation | toActiveParticipantInformation\"></ui-message-starter>\n      </div>\n      <ng-container *ngIf=\"_messages && _messages.length > 0\">\n        <div *ngIf=\"!fetchedAllMessages && moreMessagesLoading\" class=\"e11-py-1\">\n          <ng-container *ngFor=\"let item of [0, 1, 2, 3, 4, 5, 6]\">\n            <ui-skeleton-message [index]=\"item\"></ui-skeleton-message>\n          </ng-container>\n        </div>\n        <div [ngClass]=\"{ 'e11-scroll-container': context === contextPlacement.View }\">\n          <div class=\"e11-my-0\" *ngFor=\"let datedMessages of groupedMessages; trackBy: trackByDate\">\n            <e11-divider [margin]=\"0.5\" [textStyle]=\"'pill'\" [text]=\"datedMessages[0]\"></e11-divider>\n            <div #message *ngFor=\"let message of datedMessages[1]; let i = index; trackBy: trackById\">\n              <sdk-messaging-ui-message\n                [id]=\"message.id\"\n                [message]=\"message\"\n                [lastMessageReadInfo]=\"lastMessageReadInfo?.[message.id]\"\n                [userId]=\"userId\"\n                [messageConfig]=\"messageConfig\"\n                [autocomplete]=\"autocomplete\"\n                [conversationClosed]=\"disableChatInput\"\n                (emitEditMessage)=\"onEditMessage($event, message.id)\"\n                (emitReactOnMessage)=\"onReactToMessage($event, message.id)\"\n                (fetchReactionInformation)=\"fetchReactionInformation.emit($event)\"\n                (deleteMessage)=\"onDeleteMessage(message)\"\n                (retryMessage)=\"onRetryMessage(message)\"\n                (onDeleteAttachment)=\"onDeleteAttachment.emit({ attachment: $event, message: this.message })\"\n                (emitEditMode)=\"scrollIfLastMessageBeingEdited(message)\"\n              ></sdk-messaging-ui-message>\n            </div>\n          </div>\n        </div>\n      </ng-container>\n    </ng-container>\n  </div>\n  <div *ngIf=\"!disableChatInput\" class=\"e11-pt-2 e11-flex-shrink-0\" [ngClass]=\"{ 'e11-px-6': context === contextPlacement.Sideover }\">\n    <sdk-messages-message-markdown-editor\n      [autocomplete]=\"autocomplete\"\n      [conversationId]=\"conversationId\"\n      [mentions]=\"{}\"\n      [userId]=\"userId\"\n      (newMessage)=\"onNewMessage($event)\"\n    ></sdk-messages-message-markdown-editor>\n  </div>\n  <div class=\"e11-pt-2 e11-flex-shrink-0\" [ngClass]=\"{ 'e11-px-6': context === contextPlacement.Sideover }\" *ngIf=\"disableChatInput\">\n    <p class=\"e11-italic\">{{ \"Conversation has been closed\" | translate }}</p>\n  </div>\n</div>\n", styles: [".messages-results{overflow:auto}.messages-results.messages-results-height-sideover{height:100%}.messages-results.messages-results-height-view{height:42vh}.messages-results.messages-results-height-view.messages-results-height-view-conversations{height:55vh}.messages-results.e11-scroll-container-padded{padding:0 1.5rem}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$2.E11DividerComponent, selector: "e11-divider", inputs: ["text", "style", "textStyle", "textBg", "color", "height", "width", "bgcolor", "panel", "margin", "iconSize", "icon", "iconColor", "hasCircle"] }, { kind: "directive", type: i4$2.InfiniteScrollDirective, selector: "[infiniteScroll], [infinite-scroll], [data-infinite-scroll]", inputs: ["infiniteScrollDistance", "infiniteScrollUpDistance", "infiniteScrollThrottle", "infiniteScrollDisabled", "infiniteScrollContainer", "scrollWindow", "immediateCheck", "horizontal", "alwaysCallback", "fromRoot"], outputs: ["scrolled", "scrolledUp"] }, { kind: "component", type: UiMessageComponent, selector: "sdk-messaging-ui-message", inputs: ["message", "userId", "conversationClosed", "autocomplete", "lastMessageReadInfo", "messageConfig"], outputs: ["emitEditMessage", "fetchReactionInformation", "emitReactOnMessage", "deleteMessage", "retryMessage", "onDeleteAttachment", "emitEditMode"] }, { kind: "component", type: UISkeletonMessageComponent, selector: "ui-skeleton-message", inputs: ["index"] }, { kind: "component", type: ConversationHeaderComponent, selector: "sdk-conversation-header", inputs: ["conversationDisplayData", "headerType", "messageConfig"], outputs: ["emitClose", "emitDeleteConversation"] }, { kind: "component", type: UiMessagesStarterComponent, selector: "ui-message-starter", inputs: ["participantInformation"] }, { kind: "component", type: MessageMarkdownEditorComponent, selector: "sdk-messages-message-markdown-editor", inputs: ["disableChatInput", "sendingMessage", "message", "userId", "mentions", "autocomplete", "isEditMode", "conversationId"], outputs: ["newMessage"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }, { kind: "pipe", type: ActiveParticipantsPipe, name: "toActiveParticipantInformation" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIMessagesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ui-messages', encapsulation: ViewEncapsulation.None, template: "<div class=\"e11-flex e11-flex-col e11-h-full e11-bg-white\">\n  <div class=\"e11-bg-white e11-flex-shrink-0 e11-mb-2\">\n    <ng-content></ng-content>\n\n    <sdk-conversation-header\n      [conversationDisplayData]=\"conversationDisplayData ?? {}\"\n      [messageConfig]=\"messageConfig\"\n      [headerType]=\"headerType\"\n      (emitClose)=\"emitClose.emit()\"\n      (emitDeleteConversation)=\"emitDeleteConversation.emit()\"\n    ></sdk-conversation-header>\n  </div>\n  <ng-template #MessagesLoading>\n    <ng-container *ngFor=\"let item of [0, 1, 2, 3, 4, 5, 6]\">\n      <ui-skeleton-message [index]=\"item\"></ui-skeleton-message>\n    </ng-container>\n  </ng-template>\n  <div\n    #messageContainer\n    class=\"messages-results e11-overscroll-contain e11-scroll-mt-10 e11-flex e11-flex-col\"\n    infiniteScroll\n    [infiniteScrollDistance]=\"2\"\n    [infiniteScrollThrottle]=\"50\"\n    [immediateCheck]=\"true\"\n    [alwaysCallback]=\"true\"\n    (scrolledUp)=\"onScrollUp()\"\n    [scrollWindow]=\"false\"\n    [ngClass]=\"{\n      'messages-results-height-sideover e11-scroll-container-padded': context === contextPlacement.Sideover,\n      'messages-results-height-view': context === contextPlacement.View,\n      'messages-results-height-view-conversations': contextType === contextCommunicationType.Conversation\n    }\"\n  >\n    <ng-container *ngIf=\"!loading && userId; else MessagesLoading\">\n      <div class=\"e11-mt-auto\" *ngIf=\"fetchedAllMessages || !_messages?.length\">\n        <ui-message-starter [participantInformation]=\"participantInformation | toActiveParticipantInformation\"></ui-message-starter>\n      </div>\n      <ng-container *ngIf=\"_messages && _messages.length > 0\">\n        <div *ngIf=\"!fetchedAllMessages && moreMessagesLoading\" class=\"e11-py-1\">\n          <ng-container *ngFor=\"let item of [0, 1, 2, 3, 4, 5, 6]\">\n            <ui-skeleton-message [index]=\"item\"></ui-skeleton-message>\n          </ng-container>\n        </div>\n        <div [ngClass]=\"{ 'e11-scroll-container': context === contextPlacement.View }\">\n          <div class=\"e11-my-0\" *ngFor=\"let datedMessages of groupedMessages; trackBy: trackByDate\">\n            <e11-divider [margin]=\"0.5\" [textStyle]=\"'pill'\" [text]=\"datedMessages[0]\"></e11-divider>\n            <div #message *ngFor=\"let message of datedMessages[1]; let i = index; trackBy: trackById\">\n              <sdk-messaging-ui-message\n                [id]=\"message.id\"\n                [message]=\"message\"\n                [lastMessageReadInfo]=\"lastMessageReadInfo?.[message.id]\"\n                [userId]=\"userId\"\n                [messageConfig]=\"messageConfig\"\n                [autocomplete]=\"autocomplete\"\n                [conversationClosed]=\"disableChatInput\"\n                (emitEditMessage)=\"onEditMessage($event, message.id)\"\n                (emitReactOnMessage)=\"onReactToMessage($event, message.id)\"\n                (fetchReactionInformation)=\"fetchReactionInformation.emit($event)\"\n                (deleteMessage)=\"onDeleteMessage(message)\"\n                (retryMessage)=\"onRetryMessage(message)\"\n                (onDeleteAttachment)=\"onDeleteAttachment.emit({ attachment: $event, message: this.message })\"\n                (emitEditMode)=\"scrollIfLastMessageBeingEdited(message)\"\n              ></sdk-messaging-ui-message>\n            </div>\n          </div>\n        </div>\n      </ng-container>\n    </ng-container>\n  </div>\n  <div *ngIf=\"!disableChatInput\" class=\"e11-pt-2 e11-flex-shrink-0\" [ngClass]=\"{ 'e11-px-6': context === contextPlacement.Sideover }\">\n    <sdk-messages-message-markdown-editor\n      [autocomplete]=\"autocomplete\"\n      [conversationId]=\"conversationId\"\n      [mentions]=\"{}\"\n      [userId]=\"userId\"\n      (newMessage)=\"onNewMessage($event)\"\n    ></sdk-messages-message-markdown-editor>\n  </div>\n  <div class=\"e11-pt-2 e11-flex-shrink-0\" [ngClass]=\"{ 'e11-px-6': context === contextPlacement.Sideover }\" *ngIf=\"disableChatInput\">\n    <p class=\"e11-italic\">{{ \"Conversation has been closed\" | translate }}</p>\n  </div>\n</div>\n", styles: [".messages-results{overflow:auto}.messages-results.messages-results-height-sideover{height:100%}.messages-results.messages-results-height-view{height:42vh}.messages-results.messages-results-height-view.messages-results-height-view-conversations{height:55vh}.messages-results.e11-scroll-container-padded{padding:0 1.5rem}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }, { type: i1.E11ErrorHandlerService }], propDecorators: { conversationDisplayData: [{
                type: Input
            }], context: [{
                type: Input
            }], contextType: [{
                type: Input
            }], headerType: [{
                type: Input
            }], loading: [{
                type: Input
            }], moreMessagesLoading: [{
                type: Input
            }], fetchedAllMessages: [{
                type: Input
            }], disableChatInput: [{
                type: Input
            }], scrollOnChange: [{
                type: Input
            }], messageConfig: [{
                type: Input
            }], participantInformation: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], conversationId: [{
                type: Input
            }], userId: [{
                type: Input
            }], lastRead: [{
                type: Input
            }], latestMessage: [{
                type: Input
            }], emitClose: [{
                type: Output
            }], emitNewMessage: [{
                type: Output
            }], emitReachedTop: [{
                type: Output
            }], emitEditMessage: [{
                type: Output
            }], emitReactOnMessage: [{
                type: Output
            }], emitDeleteMessage: [{
                type: Output
            }], emitDeleteConversation: [{
                type: Output
            }], fetchReactionInformation: [{
                type: Output
            }], emitRetryMessage: [{
                type: Output
            }], messageContainer: [{
                type: ViewChild,
                args: ['messageContainer']
            }], messageElements: [{
                type: ViewChildren,
                args: ['message']
            }], onDeleteAttachment: [{
                type: Output
            }], messages: [{
                type: Input
            }] } });

class AutocompleteFnPipe {
    transform(participantInformation) {
        return getAutocompleteFn(participantInformation);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AutocompleteFnPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: AutocompleteFnPipe, name: "toAutocompleteFn" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AutocompleteFnPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'toAutocompleteFn' }]
        }] });

/**
 * Universal conversation component.
 */
class ConversationComponent {
    set conversationDisplayData(displayData) {
        if (!displayData)
            return;
        this._conversationDisplayData = { ...displayData, ...this._conversationDisplayData }; // Existing data takes precedence as it could come from the conversation
    }
    set conversation(conversation) {
        this.initConversation(conversation);
    }
    constructor(libConfig, messagingStore, conversationMessageStore, conversationConfigService) {
        this.libConfig = libConfig;
        this.messagingStore = messagingStore;
        this.conversationMessageStore = conversationMessageStore;
        this.conversationConfigService = conversationConfigService;
        this.currentConversation = null;
        this.loadingConversation = false;
        this.disabledChatInput = false;
        this.headerType = ConversationHeaderType.Full;
        this.emitNewMessage = new EventEmitter();
        this.emitClose = new EventEmitter();
        this.userId$ = this.libConfig.config.userId$.pipe(filter$1(isNotNil));
        // setting both values to false for now until actual 'delete' feature is implemented here
        this.messageConfig = {
            ...DEFAULT_MESSAGE_CONFIG,
        };
        this.loadingMessages$ = this.conversationMessageStore.messagesLoading$;
        this.loadingMoreMessages$ = this.conversationMessageStore.moreMessagesLoading$;
        this.getAutocompleteFn = getAutocompleteFn;
    }
    ngOnDestroy() {
        this.conversationMessageStore.onCloseMessages(); // needed here in addition to on close since conversations can happen in full page and in sideover
    }
    /**
     * If the conversation doesn't exist, there are various mechanisms for creating it.
     * The parent decides which kind of conversation it is and how to create it.
     *
     * @param message
     */
    sendMessage(message) {
        this.emitNewMessage.emit(message);
    }
    editMessage({ messageId, message }) {
        if (!message.files.length && this.currentConversation) {
            this.conversationMessageStore.onEditMessage({ message: message.message, messageId, conversationId: this.currentConversation.id });
        }
    }
    retryMessage(message) {
        const { conversationId, confirmationId, text, mentions } = message;
        // TODO: figure out how to guarantee confirmationId - does VM need to be updated?
        this.conversationMessageStore.onRetryMessage({ conversationId, confirmationId: confirmationId, text, mentions: mentions ?? {} });
    }
    reactOnMessage({ messageId, reaction }) {
        if (!this.currentConversation)
            return;
        this.conversationMessageStore[reaction.type]({ messageId, conversationId: this.currentConversation.id, reaction: reaction.reaction });
    }
    deleteMessage(deleteRequest) {
        this.conversationMessageStore.onDeleteMessage(deleteRequest);
    }
    deleteAttachment(attachmentRequest) {
        this.conversationMessageStore.onDeleteAttachment(attachmentRequest);
    }
    deleteConversation() {
        if (!this.currentConversation)
            return;
        this.messagingStore.onDeleteConversation(this.currentConversation);
    }
    closeConversation() {
        this.emitClose.emit();
        this.conversationMessageStore.onCloseMessages(); // prevents us from listening to messages after conversation is closed
        this.currentConversation = null;
        this.conversationDisplayData = undefined;
    }
    moreMessages() {
        this.conversationMessageStore.onGetMoreMessages();
    }
    setConversationMetadata(metadata) {
        this.currentConversationMetadata = metadata;
    }
    initConversation(conversation) {
        // must not fetch messages again if conversation hasn't changed  - may be able to do this in parent
        if (!conversation || this.currentConversation?.id === conversation?.id) {
            this.setConversationMetadata({
                lastRead: conversation?.lastRead,
                latestMessage: conversation?.latestMessage,
            });
            return;
        }
        this.currentConversation = conversation;
        this.setConversationMetadata({
            lastRead: conversation?.lastRead,
            latestMessage: conversation?.latestMessage,
        });
        const conversationConfig = this.conversationConfigService.getConfig(conversation.type || CONVERSATION_TYPES.DIRECT_MESSAGE);
        this.messageConfig = { ...this.messageConfig, ...conversationConfig };
        this.loadMessages(conversation);
        // Default to data from the conversation itself NOT the passed in init data
        this._conversationDisplayData = getConversationDisplayFallbacks({
            ...this._conversationDisplayData,
            ...pick(conversation, 'conversationName', 'conversationImageData', 'shortName', 'conversationSubtitle'),
        });
    }
    loadMessages(conversation) {
        this.conversationMessageStore.onListenConversationMessages(conversation);
        this.currentMessages$ = this.conversationMessageStore.getMessagesByChannelId(conversation.id);
        this.fetchedAllMessages$ = this.conversationMessageStore.hasFetchedAllForChannelId(conversation.id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationComponent, deps: [{ token: MessagingConfigurationProvider }, { token: ConversationStore }, { token: ConversationMessageStore }, { token: ConversationConfigService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationComponent, selector: "sdk-messaging-conversation", inputs: { conversationDisplayData: "conversationDisplayData", conversation: "conversation", loadingConversation: "loadingConversation", disabledChatInput: "disabledChatInput", context: "context", contextType: "contextType", headerType: "headerType" }, outputs: { emitNewMessage: "emitNewMessage", emitClose: "emitClose" }, ngImport: i0, template: `
    <ng-container *ngrxLet="loadingMessages$ as loadingMessages">
      <ng-container *ngrxLet="currentMessages$ as currentMessages">
        <ng-container *ngrxLet="loadingMoreMessages$ as loadingMore">
          <ng-container *ngrxLet="fetchedAllMessages$ as fetchedAllMessages">
            <ng-container *ngrxLet="userId$ as userId">
              <ui-messages
                [conversationDisplayData]="_conversationDisplayData"
                [participantInformation]="currentConversation?.participantInformation"
                [autocomplete]="currentConversation?.participantInformation | toAutocompleteFn"
                [messages]="currentMessages"
                [conversationId]="currentConversation?.id"
                [lastRead]="currentConversationMetadata?.lastRead"
                [latestMessage]="currentConversationMetadata?.latestMessage ?? undefined"
                [userId]="userId"
                [context]="context"
                [contextType]="contextType"
                [disableChatInput]="disabledChatInput || (currentConversation?.closed ?? false)"
                [loading]="loadingMessages || loadingConversation"
                [moreMessagesLoading]="loadingMore"
                [fetchedAllMessages]="fetchedAllMessages ?? false"
                [messageConfig]="messageConfig"
                [headerType]="headerType"
                (emitClose)="closeConversation()"
                (emitNewMessage)="sendMessage($event)"
                (emitReactOnMessage)="reactOnMessage($event)"
                (emitReachedTop)="moreMessages()"
                (emitEditMessage)="editMessage($event)"
                (emitRetryMessage)="retryMessage($event)"
                (emitDeleteMessage)="deleteMessage($event)"
                (emitDeleteConversation)="deleteConversation()"
                (onDeleteAttachment)="deleteAttachment($event)"
              ></ui-messages>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i3$3.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: UIMessagesComponent, selector: "ui-messages", inputs: ["conversationDisplayData", "context", "contextType", "headerType", "loading", "moreMessagesLoading", "fetchedAllMessages", "disableChatInput", "scrollOnChange", "messageConfig", "participantInformation", "autocomplete", "conversationId", "userId", "lastRead", "latestMessage", "messages"], outputs: ["emitClose", "emitNewMessage", "emitReachedTop", "emitEditMessage", "emitReactOnMessage", "emitDeleteMessage", "emitDeleteConversation", "fetchReactionInformation", "emitRetryMessage", "onDeleteAttachment"] }, { kind: "pipe", type: AutocompleteFnPipe, name: "toAutocompleteFn" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-messaging-conversation',
                    template: `
    <ng-container *ngrxLet="loadingMessages$ as loadingMessages">
      <ng-container *ngrxLet="currentMessages$ as currentMessages">
        <ng-container *ngrxLet="loadingMoreMessages$ as loadingMore">
          <ng-container *ngrxLet="fetchedAllMessages$ as fetchedAllMessages">
            <ng-container *ngrxLet="userId$ as userId">
              <ui-messages
                [conversationDisplayData]="_conversationDisplayData"
                [participantInformation]="currentConversation?.participantInformation"
                [autocomplete]="currentConversation?.participantInformation | toAutocompleteFn"
                [messages]="currentMessages"
                [conversationId]="currentConversation?.id"
                [lastRead]="currentConversationMetadata?.lastRead"
                [latestMessage]="currentConversationMetadata?.latestMessage ?? undefined"
                [userId]="userId"
                [context]="context"
                [contextType]="contextType"
                [disableChatInput]="disabledChatInput || (currentConversation?.closed ?? false)"
                [loading]="loadingMessages || loadingConversation"
                [moreMessagesLoading]="loadingMore"
                [fetchedAllMessages]="fetchedAllMessages ?? false"
                [messageConfig]="messageConfig"
                [headerType]="headerType"
                (emitClose)="closeConversation()"
                (emitNewMessage)="sendMessage($event)"
                (emitReactOnMessage)="reactOnMessage($event)"
                (emitReachedTop)="moreMessages()"
                (emitEditMessage)="editMessage($event)"
                (emitRetryMessage)="retryMessage($event)"
                (emitDeleteMessage)="deleteMessage($event)"
                (emitDeleteConversation)="deleteConversation()"
                (onDeleteAttachment)="deleteAttachment($event)"
              ></ui-messages>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: MessagingConfigurationProvider }, { type: ConversationStore }, { type: ConversationMessageStore }, { type: ConversationConfigService }], propDecorators: { conversationDisplayData: [{
                type: Input
            }], conversation: [{
                type: Input
            }], loadingConversation: [{
                type: Input
            }], disabledChatInput: [{
                type: Input
            }], context: [{
                type: Input
            }], contextType: [{
                type: Input
            }], headerType: [{
                type: Input
            }], emitNewMessage: [{
                type: Output
            }], emitClose: [{
                type: Output
            }] } });

/**
 * Convenience component which fetches the conversation given the ID
 * This is useful in the event you have a conversationId stored on another collection and you need to open that conversation
 */
class ConversationFetchComponent {
    constructor(messagingStore, conversationMessageStore) {
        this.messagingStore = messagingStore;
        this.conversationMessageStore = conversationMessageStore;
        this.headerType = ConversationHeaderType.Full;
        this.emitClose = new EventEmitter();
        this.contextPlacement = ContextPlacement;
        this.contextCommunicationType = ContextCommunicationType;
    }
    set conversationId(value) {
        this._conversationId = value;
        this.conversation$ = this.messagingStore.getConversation(this._conversationId);
    }
    sendMessage(message) {
        this.conversationMessageStore.onSendMessage({
            conversationId: this._conversationId,
            text: message.message,
            attachments: message.files,
            mentions: {},
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationFetchComponent, deps: [{ token: ConversationStore }, { token: ConversationMessageStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationFetchComponent, selector: "sdk-messaging-conversation-fetch", inputs: { headerType: "headerType", conversationId: "conversationId" }, outputs: { emitClose: "emitClose" }, ngImport: i0, template: `
    <ng-container *ngrxLet="conversation$ as conversation">
      <sdk-messaging-conversation
        [conversation]="conversation ?? null"
        [context]="contextPlacement.View"
        [contextType]="contextCommunicationType.Conversation"
        [headerType]="headerType"
        [loadingConversation]="!conversation"
        (emitClose)="emitClose.emit()"
        (emitNewMessage)="sendMessage($event)"
      ></sdk-messaging-conversation>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i3$3.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: ConversationComponent, selector: "sdk-messaging-conversation", inputs: ["conversationDisplayData", "conversation", "loadingConversation", "disabledChatInput", "context", "contextType", "headerType"], outputs: ["emitNewMessage", "emitClose"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationFetchComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-messaging-conversation-fetch',
                    template: `
    <ng-container *ngrxLet="conversation$ as conversation">
      <sdk-messaging-conversation
        [conversation]="conversation ?? null"
        [context]="contextPlacement.View"
        [contextType]="contextCommunicationType.Conversation"
        [headerType]="headerType"
        [loadingConversation]="!conversation"
        (emitClose)="emitClose.emit()"
        (emitNewMessage)="sendMessage($event)"
      ></sdk-messaging-conversation>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: ConversationStore }, { type: ConversationMessageStore }], propDecorators: { headerType: [{
                type: Input
            }], emitClose: [{
                type: Output
            }], conversationId: [{
                type: Input
            }] } });

class ConversationContainerComponent {
    constructor(route, logger) {
        this.route = route;
        this.logger = logger;
        this.conversationId$ = this.route.paramMap.pipe(map((params) => params.get('id')), tap((id) => this.logger.info('CONTAINER: routing to conversationId: ', id)), filter(isNotNil));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationContainerComponent, deps: [{ token: i1$1.ActivatedRoute }, { token: LOGGER_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationContainerComponent, selector: "ng-component", ngImport: i0, template: `
    <div
      *ngIf="conversationId$ | async as id"
      class="e11-bg-white e11-w-full e11-p-4 e11-rounded-lg e11-border e11-border-skin-grey e11-conversation-container-height"
    >
      <sdk-messaging-conversation-fetch [conversationId]="id"> </sdk-messaging-conversation-fetch>
    </div>
  `, isInline: true, styles: [".e11-conversation-container-height{height:calc(100vh - 140px)}\n"], dependencies: [{ kind: "component", type: ConversationFetchComponent, selector: "sdk-messaging-conversation-fetch", inputs: ["headerType", "conversationId"], outputs: ["emitClose"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationContainerComponent, decorators: [{
            type: Component,
            args: [{ template: `
    <div
      *ngIf="conversationId$ | async as id"
      class="e11-bg-white e11-w-full e11-p-4 e11-rounded-lg e11-border e11-border-skin-grey e11-conversation-container-height"
    >
      <sdk-messaging-conversation-fetch [conversationId]="id"> </sdk-messaging-conversation-fetch>
    </div>
  `, styles: [".e11-conversation-container-height{height:calc(100vh - 140px)}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.ActivatedRoute }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }] });

/**
 * Either the conversation already exists AND can be found (as with getOrStart) or it doesn't
 * Need to display loader when loading conversations AND if it exists, when loading messages.
 * Send messages directly using the conversation IF it exists, OR start a conversation with an initial message - @onStartConversation
 *
 */
/**
 * Use ONLY for fixed-membership conversations such as DMs
 */
class DirectMessagesComponent {
    constructor(libConfig, messagingStore, conversationMessageStore, logger, errorTracker) {
        this.libConfig = libConfig;
        this.messagingStore = messagingStore;
        this.conversationMessageStore = conversationMessageStore;
        this.logger = logger;
        this.errorTracker = errorTracker;
        this.conversationKeys = [];
        this.disabledChatInput = false;
        this.context = ContextPlacement.Sideover;
        this.headerType = ConversationHeaderType.Full;
        this.emitClose = new EventEmitter();
        this.conversationsLoaded$ = this.messagingStore.getConversationsLoaded;
        this.startingConversation$ = this.messagingStore.getStartingConversation;
    }
    ngOnChanges(messagesListChanges) {
        const recipientIdsChanges = messagesListChanges.recipientIds;
        if (recipientIdsChanges && recipientIdsChanges.currentValue !== recipientIdsChanges.previousValue) {
            this.logger.log('DirectMessagesComponent loading conversation:', { recipientIdsChanges });
            this.loadConversation(this.recipientIds, this.conversationKeys);
        }
    }
    loadConversation(recipientIds, conversationKeys) {
        this.currentConversation$ = this.messagingStore.getConversationByRecipientsAndKeys(recipientIds, conversationKeys);
        this.conversationDisplayData$ = this.currentConversation$.pipe(distinctUntilChanged((before, after) => hasChangedAny(['conversationName', 'conversationImageData', 'shortName', 'conversationSubtitle'], { before, after })), tap((conversation) => this.logger.log('DirectMessagesComponent loadConversation:', conversation)), map((conversation) => {
            if (conversation)
                return getConversationDisplayFallbacks({
                    ...this.conversationDisplayData,
                    ...pick(conversation, 'conversationName', 'conversationImageData', 'shortName', 'conversationSubtitle'),
                });
            else
                return undefined;
        }));
    }
    closeConversation() {
        this.emitClose.emit();
    }
    /**
     * TODO: Consider whether to pass up the currentConversation to make this simpler
     *
     * @param message
     */
    sendMessage({ message, files }) {
        const messageRequest = {
            message,
            recipientIds: this.recipientIds,
            conversationKeys: this.conversationKeys,
            conversationType: this.conversationType,
            creationClientMetadata: this.creationClientMetadata,
            attachments: files,
        };
        this.conversationMessageStore.onDirectMessageRecipients(messageRequest);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DirectMessagesComponent, deps: [{ token: MessagingConfigurationProvider }, { token: ConversationStore }, { token: ConversationMessageStore }, { token: LOGGER_TOKEN }, { token: ERROR_TRACKER_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: DirectMessagesComponent, selector: "sdk-messaging-direct-messages", inputs: { conversationDisplayData: "conversationDisplayData", recipientIds: "recipientIds", conversationKeys: "conversationKeys", conversationType: "conversationType", creationClientMetadata: "creationClientMetadata", disabledChatInput: "disabledChatInput", context: "context", headerType: "headerType" }, outputs: { emitClose: "emitClose" }, usesOnChanges: true, ngImport: i0, template: `
    <ng-container *ngrxLet="conversationDisplayData$ as displayData">
      <ng-container *ngrxLet="currentConversation$ as conversation">
        <ng-container *ngrxLet="conversationsLoaded$ as conversationsLoaded">
          <sdk-messaging-conversation
            [conversation]="conversation ?? null"
            [conversationDisplayData]="displayData ?? conversationDisplayData"
            [disabledChatInput]="disabledChatInput"
            [loadingConversation]="!conversationsLoaded || ((startingConversation$ | async) ?? false)"
            [context]="context"
            [headerType]="headerType"
            (emitNewMessage)="sendMessage($event)"
            (emitClose)="closeConversation()"
          ></sdk-messaging-conversation>
        </ng-container>
      </ng-container>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i3$3.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: ConversationComponent, selector: "sdk-messaging-conversation", inputs: ["conversationDisplayData", "conversation", "loadingConversation", "disabledChatInput", "context", "contextType", "headerType"], outputs: ["emitNewMessage", "emitClose"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DirectMessagesComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-messaging-direct-messages',
                    template: `
    <ng-container *ngrxLet="conversationDisplayData$ as displayData">
      <ng-container *ngrxLet="currentConversation$ as conversation">
        <ng-container *ngrxLet="conversationsLoaded$ as conversationsLoaded">
          <sdk-messaging-conversation
            [conversation]="conversation ?? null"
            [conversationDisplayData]="displayData ?? conversationDisplayData"
            [disabledChatInput]="disabledChatInput"
            [loadingConversation]="!conversationsLoaded || ((startingConversation$ | async) ?? false)"
            [context]="context"
            [headerType]="headerType"
            (emitNewMessage)="sendMessage($event)"
            (emitClose)="closeConversation()"
          ></sdk-messaging-conversation>
        </ng-container>
      </ng-container>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: MessagingConfigurationProvider }, { type: ConversationStore }, { type: ConversationMessageStore }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [ERROR_TRACKER_TOKEN]
                }] }], propDecorators: { conversationDisplayData: [{
                type: Input
            }], recipientIds: [{
                type: Input
            }], conversationKeys: [{
                type: Input
            }], conversationType: [{
                type: Input
            }], creationClientMetadata: [{
                type: Input
            }], disabledChatInput: [{
                type: Input
            }], context: [{
                type: Input
            }], headerType: [{
                type: Input
            }], emitClose: [{
                type: Output
            }] } });

class NewConversationContainerComponent {
    constructor(store) {
        this.store = store;
        this.newConversationStarter$ = this.store.getNewConversationStarter.pipe(filter(isNotNil));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: NewConversationContainerComponent, deps: [{ token: ConversationStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: NewConversationContainerComponent, selector: "ng-component", ngImport: i0, template: `
    <div *ngIf="newConversationStarter$ | async as conversationStarter" class="">
      <e11-panel>
        <sdk-messaging-direct-messages
          [conversationDisplayData]="conversationStarter"
          [recipientIds]="conversationStarter.recipients"
          [conversationType]="conversationStarter.type"
          [conversationKeys]="conversationStarter.conversationKeys ?? []"
          [creationClientMetadata]="conversationStarter.creationClientMetadata"
        >
        </sdk-messaging-direct-messages>
      </e11-panel>
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: DirectMessagesComponent, selector: "sdk-messaging-direct-messages", inputs: ["conversationDisplayData", "recipientIds", "conversationKeys", "conversationType", "creationClientMetadata", "disabledChatInput", "context", "headerType"], outputs: ["emitClose"] }, { kind: "component", type: i3$4.E11PanelComponent, selector: "e11-panel", inputs: ["size", "headerText", "headerSize", "headerBgColor", "headerFontColor", "headerStyle", "ctaIcon", "ctaIconType", "ctaIconSize", "ctaText", "ctaFontColor", "hasBorder", "hasShadow", "containerClassOverrides", "contentClassOverrides", "headerTemplate", "bgOpacity"], outputs: ["ctaClicked"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: NewConversationContainerComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
    <div *ngIf="newConversationStarter$ | async as conversationStarter" class="">
      <e11-panel>
        <sdk-messaging-direct-messages
          [conversationDisplayData]="conversationStarter"
          [recipientIds]="conversationStarter.recipients"
          [conversationType]="conversationStarter.type"
          [conversationKeys]="conversationStarter.conversationKeys ?? []"
          [creationClientMetadata]="conversationStarter.creationClientMetadata"
        >
        </sdk-messaging-direct-messages>
      </e11-panel>
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: ConversationStore }] });

class MessagingContainerComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: MessagingContainerComponent, selector: "messaging-container", ngImport: i0, template: "<!-- <div class=\"e11-w-full e11-h-full\"> -->\n<!-- Conditional class based on community vs conversation: height 42vh vs 55vh -->\n<div class=\"e11-w-full\">\n  <router-outlet></router-outlet>\n</div>\n", dependencies: [{ kind: "directive", type: i1$1.RouterOutlet, selector: "router-outlet", inputs: ["name"], outputs: ["activate", "deactivate", "attach", "detach"], exportAs: ["outlet"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'messaging-container', template: "<!-- <div class=\"e11-w-full e11-h-full\"> -->\n<!-- Conditional class based on community vs conversation: height 42vh vs 55vh -->\n<div class=\"e11-w-full\">\n  <router-outlet></router-outlet>\n</div>\n" }]
        }] });

const UP_ROUTES = [
    {
        path: 'messaging',
        component: MessagingContainerComponent,
        children: [
            {
                path: 'conversation/:id',
                component: ConversationContainerComponent,
            },
            {
                path: 'new-conversation',
                component: NewConversationContainerComponent,
            },
        ],
    },
];
class MessagingRoutingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingRoutingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: MessagingRoutingModule, imports: [i1$1.RouterModule], exports: [RouterModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingRoutingModule, imports: [RouterModule.forChild(UP_ROUTES), RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingRoutingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [RouterModule.forChild(UP_ROUTES)],
                    exports: [RouterModule],
                }]
        }] });

// import { E11TooltipModule as E11ToolTipModule } from '@engineering11/ui-lib/e11-tool-tip'
const ImportExportModules$2 = [
    E11AutocompleteModule,
    E11ImageViewerModule,
    E11SideOverModule,
    E11ProfilePicModule,
    E11DividerModule,
    E11BadgeModule,
    E11IconModule,
    E11LoaderDotsModule,
    E11ButtonModule,
    E11ImageModule,
    E11InputModule,
    E11InputErrorsModule,
    E11TextareaModule,
    E11SwitchModule,
    E11ModalModule,
    E11MarkdownEditorModule,
    E11PanelModule,
    E11TabsModule,
    E11ConfirmationModule,
    E11SelectModule,
    E11MultiSelectModule,
    E11InputCheckboxModule,
    E11EmptyStateModule,
    E11PopoverModule,
    E11LoaderLineModule,
    E11AvatarModule,
    E11IndicatorModule,
    E11TooltipModule,
    E11NavExpanderModule,
    E11FileViewerModule,
    E11ExternalLinkModule,
];
class UiComponentLibraryModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiComponentLibraryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: UiComponentLibraryModule, imports: [CommonModule, E11AutocompleteModule,
            E11ImageViewerModule,
            E11SideOverModule,
            E11ProfilePicModule,
            E11DividerModule,
            E11BadgeModule,
            E11IconModule,
            E11LoaderDotsModule,
            E11ButtonModule,
            E11ImageModule,
            E11InputModule,
            E11InputErrorsModule,
            E11TextareaModule,
            E11SwitchModule,
            E11ModalModule,
            E11MarkdownEditorModule,
            E11PanelModule,
            E11TabsModule,
            E11ConfirmationModule,
            E11SelectModule,
            E11MultiSelectModule,
            E11InputCheckboxModule,
            E11EmptyStateModule,
            E11PopoverModule,
            E11LoaderLineModule,
            E11AvatarModule,
            E11IndicatorModule,
            E11TooltipModule,
            E11NavExpanderModule,
            E11FileViewerModule,
            E11ExternalLinkModule], exports: [E11AutocompleteModule,
            E11ImageViewerModule,
            E11SideOverModule,
            E11ProfilePicModule,
            E11DividerModule,
            E11BadgeModule,
            E11IconModule,
            E11LoaderDotsModule,
            E11ButtonModule,
            E11ImageModule,
            E11InputModule,
            E11InputErrorsModule,
            E11TextareaModule,
            E11SwitchModule,
            E11ModalModule,
            E11MarkdownEditorModule,
            E11PanelModule,
            E11TabsModule,
            E11ConfirmationModule,
            E11SelectModule,
            E11MultiSelectModule,
            E11InputCheckboxModule,
            E11EmptyStateModule,
            E11PopoverModule,
            E11LoaderLineModule,
            E11AvatarModule,
            E11IndicatorModule,
            E11TooltipModule,
            E11NavExpanderModule,
            E11FileViewerModule,
            E11ExternalLinkModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiComponentLibraryModule, imports: [CommonModule, ImportExportModules$2, E11AutocompleteModule,
            E11ImageViewerModule,
            E11SideOverModule,
            E11ProfilePicModule,
            E11DividerModule,
            E11BadgeModule,
            E11IconModule,
            E11LoaderDotsModule,
            E11ButtonModule,
            E11ImageModule,
            E11InputModule,
            E11InputErrorsModule,
            E11TextareaModule,
            E11SwitchModule,
            E11ModalModule,
            E11MarkdownEditorModule,
            E11PanelModule,
            E11TabsModule,
            E11ConfirmationModule,
            E11SelectModule,
            E11MultiSelectModule,
            E11InputCheckboxModule,
            E11EmptyStateModule,
            E11PopoverModule,
            E11LoaderLineModule,
            E11AvatarModule,
            E11IndicatorModule,
            E11TooltipModule,
            E11NavExpanderModule,
            E11FileViewerModule,
            E11ExternalLinkModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiComponentLibraryModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule, ...ImportExportModules$2],
                    exports: [...ImportExportModules$2],
                }]
        }] });

const ImportExportModules$1 = [
    UiComponentLibraryModule,
    TranslateModule,
    LetDirective,
    PushPipe,
    WebUtilityModule,
    MultimediaModule,
    E11DirectivesModule,
    E11ConfirmationModule,
    E11VideoPlayerComponent,
];
class SharedModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: SharedModule, imports: [CommonModule, UiComponentLibraryModule,
            TranslateModule,
            LetDirective,
            PushPipe,
            WebUtilityModule,
            MultimediaModule,
            E11DirectivesModule,
            E11ConfirmationModule,
            E11VideoPlayerComponent], exports: [UiComponentLibraryModule,
            TranslateModule,
            LetDirective,
            PushPipe,
            WebUtilityModule,
            MultimediaModule,
            E11DirectivesModule,
            E11ConfirmationModule,
            E11VideoPlayerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SharedModule, imports: [CommonModule, UiComponentLibraryModule,
            TranslateModule,
            WebUtilityModule,
            MultimediaModule,
            E11DirectivesModule,
            E11ConfirmationModule,
            E11VideoPlayerComponent,
            UiComponentLibraryModule,
            TranslateModule,
            WebUtilityModule,
            MultimediaModule,
            E11DirectivesModule,
            E11ConfirmationModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SharedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule, ...ImportExportModules$1],
                    exports: [...ImportExportModules$1],
                }]
        }] });

var SpeechEvent;
(function (SpeechEvent) {
    SpeechEvent[SpeechEvent["Start"] = 0] = "Start";
    SpeechEvent[SpeechEvent["End"] = 1] = "End";
    SpeechEvent[SpeechEvent["FinalContent"] = 2] = "FinalContent";
    SpeechEvent[SpeechEvent["InterimContent"] = 3] = "InterimContent";
})(SpeechEvent || (SpeechEvent = {}));
var SpeechError;
(function (SpeechError) {
    SpeechError["NoSpeech"] = "no-speech";
    SpeechError["AudioCapture"] = "audio-capture";
    SpeechError["NotAllowed"] = "not-allowed";
    SpeechError["Unknown"] = "unknown";
})(SpeechError || (SpeechError = {}));

const { webkitSpeechRecognition } = window;
class VoiceToSpeechService {
    constructor(ngZone, logger) {
        this.ngZone = ngZone;
        this.logger = logger;
        this.isListening = false;
    }
    initialize(language) {
        if ('webkitSpeechRecognition' in window) {
            this.recognition = new webkitSpeechRecognition();
            this.recognition.continuous = true;
            this.recognition.interimResults = true;
            this.setLanguage(language);
            return true;
        }
        return false;
    }
    setLanguage(language) {
        this.language = language;
        this.recognition.lang = language;
    }
    start() {
        if (!this.recognition) {
            return;
        }
        this.recognition.start();
        this.isListening = true;
    }
    onStart() {
        if (!this.recognition) {
            this.initialize(this.language);
        }
        return new Observable((observer) => {
            this.recognition.onstart = () => {
                this.ngZone.run(() => {
                    observer.next({
                        event: SpeechEvent.Start,
                    });
                });
            };
        });
    }
    onEnd() {
        return new Observable((observer) => {
            this.recognition.onend = () => {
                this.ngZone.run(() => {
                    observer.next({
                        event: SpeechEvent.End,
                    });
                    this.isListening = false;
                });
            };
        });
    }
    onResult() {
        return new Observable((observer) => {
            // @ts-ignore
            this.recognition.onresult = (event) => {
                let interimContent = '';
                let finalContent = '';
                for (let i = event.resultIndex; i < event.results.length; ++i) {
                    if (event.results[i].isFinal) {
                        finalContent += event.results[i][0].transcript;
                        this.ngZone.run(() => {
                            observer.next({
                                event: SpeechEvent.FinalContent,
                                content: finalContent,
                            });
                        });
                    }
                    else {
                        interimContent += event.results[i][0].transcript;
                        this.ngZone.run(() => {
                            observer.next({
                                event: SpeechEvent.InterimContent,
                                content: interimContent,
                            });
                        });
                    }
                }
            };
        });
    }
    onError() {
        return new Observable((observer) => {
            this.recognition.onerror = (event) => {
                const eventError = event.error;
                this.logger.log('error', eventError);
                let error;
                switch (eventError) {
                    case 'no-speech':
                        error = SpeechError.NoSpeech;
                        break;
                    case 'audio-capture':
                        error = SpeechError.AudioCapture;
                        break;
                    case 'not-allowed':
                        error = SpeechError.NotAllowed;
                        break;
                    default:
                        error = SpeechError.Unknown;
                        break;
                }
                this.ngZone.run(() => {
                    observer.next({
                        error,
                    });
                });
            };
        });
    }
    stop() {
        this.recognition.stop();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: VoiceToSpeechService, deps: [{ token: i0.NgZone }, { token: LOGGER_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: VoiceToSpeechService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: VoiceToSpeechService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }] });

class MessageEditorComponent {
    constructor(voiceToSpeech) {
        this.voiceToSpeech = voiceToSpeech;
        this.disableChatInput = false;
        this.sendingMessage = false;
        this.newMessage = new EventEmitter();
        this.textMessageValue = '';
        this.emojiPickerReady = false;
        this.showEmojiToggle = false;
        this.isUserSpeaking = false;
        this.voiceSupported = true;
        this.defaultError$ = new Subject();
    }
    ngOnInit() {
        const webSpeechReady = this.voiceToSpeech.initialize('en-US');
        if (webSpeechReady) {
            this.initVoiceInput();
        }
        else {
            this.voiceSupported = false;
            console.log('Web Speech API not supported');
        }
        // load emoji delayed,
        // setTimeout(() => {
        //   this.emojiPickerReady = true
        // }, 1000)
    }
    initVoiceInput() {
        this.transcript$ = this.voiceToSpeech.onResult().pipe(tap((notification) => {
            this.processNotification(notification);
        }), map((notification) => notification.content || ''));
        this.transcript$.subscribe((text) => {
            this.textMessageValue = text;
        });
        this.listening$ = merge(this.voiceToSpeech.onStart(), this.voiceToSpeech.onEnd()).pipe(map((notification) => notification.event === SpeechEvent.Start));
        this.errorMessage$ = merge(this.voiceToSpeech.onError(), this.defaultError$).pipe(map((data) => {
            if (data === undefined) {
                return '';
            }
            if (typeof data === 'string') {
                return data;
            }
            let message;
            switch (data.error) {
                case SpeechError.NotAllowed:
                    message = `Your browser is not authorized to access your microphone.`;
                    break;
                case SpeechError.NoSpeech:
                    message = `No speech has been detected. Please try again.`;
                    break;
                case SpeechError.AudioCapture:
                    message = `Microphone is not available.`;
                    break;
                default:
                    message = '';
                    break;
            }
            return message;
        }));
    }
    startRecording() {
        this.isUserSpeaking = true;
        if (this.voiceToSpeech.isListening) {
            this.stopRecording();
            return;
        }
        this.voiceToSpeech.start();
    }
    stopRecording() {
        this.voiceToSpeech.stop();
        this.isUserSpeaking = false;
    }
    onSubmitFormMessage() {
        if (this.textMessageValue.trim() !== '') {
            const messageText = this.textMessageValue;
            this.newMessage.emit(messageText);
            this.textMessageValue = ''; // empty out textarea
        }
    }
    processNotification(notification) {
        if (notification.event === SpeechEvent.FinalContent) {
            const message = notification.content?.trim() || '';
            this.textMessageValue = this.textMessageValue ? `${this.textMessageValue}\n${message}` : notification.content || '';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageEditorComponent, deps: [{ token: VoiceToSpeechService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: MessageEditorComponent, selector: "sdk-messages-message-editor", inputs: { disableChatInput: "disableChatInput", sendingMessage: "sendingMessage" }, outputs: { newMessage: "newMessage" }, ngImport: i0, template: "<div class=\"e11-flex-shrink-0 e11-px-4 e11-py-4\">\n  <div class=\"e11-relative e11-flex\">\n    <span class=\"e11-absolute e11-inset-y-0 e11-flex e11-items-center\">\n      <button\n        *ngIf=\"voiceSupported\"\n        type=\"button\"\n        class=\"e11-inline-flex e11-items-center e11-justify-center e11-rounded-full e11-h-12 e11-w-12 e11-transition e11-duration-500 e11-ease-in-out e11-text-gray-500 hover:e11-bg-gray-300 focus:e11-outline-none\"\n      >\n        <svg\n          (click)=\"stopRecording()\"\n          *ngIf=\"listening$ | async; else mic\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          class=\"e11-h-6 e11-w-6 e11-animate-pulse e11-text-gray-400\"\n          fill=\"none\"\n          viewBox=\"0 0 24 24\"\n          stroke=\"currentColor\"\n        >\n          <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M21 12a9 9 0 11-18 0 9 9 0 0118 0z\" />\n          <path\n            stroke-linecap=\"round\"\n            stroke-linejoin=\"round\"\n            stroke-width=\"2\"\n            d=\"M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z\"\n          />\n        </svg>\n        <ng-template #mic>\n          <svg\n            (click)=\"startRecording()\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            fill=\"none\"\n            viewBox=\"0 0 24 24\"\n            stroke=\"currentColor\"\n            class=\"e11-h-6 e11-w-6 e11-text-gray-400\"\n          >\n            <path\n              stroke-linecap=\"round\"\n              stroke-linejoin=\"round\"\n              stroke-width=\"2\"\n              d=\"M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z\"\n            ></path>\n          </svg>\n        </ng-template>\n      </button>\n    </span>\n    <textarea\n      name=\"text\"\n      [disabled]=\"disableChatInput\"\n      [(ngModel)]=\"textMessageValue\"\n      placeholder=\"Write Something\"\n      autocomplete=\"off\"\n      [ngClass]=\"{ 'e11-opacity-70 e11-cursor-not-allowed': disableChatInput }\"\n      class=\"e11-w-11/12 e11-resize-none focus:e11-outline-none focus:e11-placeholder-gray-400 e11-text-gray-500 e11-placeholder-gray-400 e11-pl-12 e11-rounded-full e11-py-3 e11-border-gray-300 focus:e11-ring-skin-secondary focus:e11-border-skin-secondary\"\n    ></textarea>\n    <div class=\"e11-absolute e11-right-0 e11-items-center e11-inset-y-0 e11-flex\">\n      <div></div>\n      <button\n        [disabled]=\"isUserSpeaking || sendingMessage || disableChatInput\"\n        [ngClass]=\"{ 'e11-opacity-70 e11-cursor-not-allowed': disableChatInput }\"\n        (click)=\"onSubmitFormMessage()\"\n        type=\"button\"\n        class=\"e11-inline-flex e11-items-center e11-justify-center e11-rounded-full e11-h-12 e11-w-12 e11-transition e11-duration-500 e11-ease-in-out e11-text-white e11-bg-skin-secondary hover:e11-bg-skin-secondary-500 focus:e11-outline-none\"\n      >\n        <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"currentColor\" class=\"e11-h-6 e11-w-6 e11-transform e11-rotate-90\">\n          <path\n            d=\"M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z\"\n          ></path>\n        </svg>\n      </button>\n    </div>\n  </div>\n</div>\n", styles: ["textarea::-webkit-scrollbar{display:none}textarea{-ms-overflow-style:none;scrollbar-width:none}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageEditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-messages-message-editor', template: "<div class=\"e11-flex-shrink-0 e11-px-4 e11-py-4\">\n  <div class=\"e11-relative e11-flex\">\n    <span class=\"e11-absolute e11-inset-y-0 e11-flex e11-items-center\">\n      <button\n        *ngIf=\"voiceSupported\"\n        type=\"button\"\n        class=\"e11-inline-flex e11-items-center e11-justify-center e11-rounded-full e11-h-12 e11-w-12 e11-transition e11-duration-500 e11-ease-in-out e11-text-gray-500 hover:e11-bg-gray-300 focus:e11-outline-none\"\n      >\n        <svg\n          (click)=\"stopRecording()\"\n          *ngIf=\"listening$ | async; else mic\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          class=\"e11-h-6 e11-w-6 e11-animate-pulse e11-text-gray-400\"\n          fill=\"none\"\n          viewBox=\"0 0 24 24\"\n          stroke=\"currentColor\"\n        >\n          <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M21 12a9 9 0 11-18 0 9 9 0 0118 0z\" />\n          <path\n            stroke-linecap=\"round\"\n            stroke-linejoin=\"round\"\n            stroke-width=\"2\"\n            d=\"M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z\"\n          />\n        </svg>\n        <ng-template #mic>\n          <svg\n            (click)=\"startRecording()\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            fill=\"none\"\n            viewBox=\"0 0 24 24\"\n            stroke=\"currentColor\"\n            class=\"e11-h-6 e11-w-6 e11-text-gray-400\"\n          >\n            <path\n              stroke-linecap=\"round\"\n              stroke-linejoin=\"round\"\n              stroke-width=\"2\"\n              d=\"M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z\"\n            ></path>\n          </svg>\n        </ng-template>\n      </button>\n    </span>\n    <textarea\n      name=\"text\"\n      [disabled]=\"disableChatInput\"\n      [(ngModel)]=\"textMessageValue\"\n      placeholder=\"Write Something\"\n      autocomplete=\"off\"\n      [ngClass]=\"{ 'e11-opacity-70 e11-cursor-not-allowed': disableChatInput }\"\n      class=\"e11-w-11/12 e11-resize-none focus:e11-outline-none focus:e11-placeholder-gray-400 e11-text-gray-500 e11-placeholder-gray-400 e11-pl-12 e11-rounded-full e11-py-3 e11-border-gray-300 focus:e11-ring-skin-secondary focus:e11-border-skin-secondary\"\n    ></textarea>\n    <div class=\"e11-absolute e11-right-0 e11-items-center e11-inset-y-0 e11-flex\">\n      <div></div>\n      <button\n        [disabled]=\"isUserSpeaking || sendingMessage || disableChatInput\"\n        [ngClass]=\"{ 'e11-opacity-70 e11-cursor-not-allowed': disableChatInput }\"\n        (click)=\"onSubmitFormMessage()\"\n        type=\"button\"\n        class=\"e11-inline-flex e11-items-center e11-justify-center e11-rounded-full e11-h-12 e11-w-12 e11-transition e11-duration-500 e11-ease-in-out e11-text-white e11-bg-skin-secondary hover:e11-bg-skin-secondary-500 focus:e11-outline-none\"\n      >\n        <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"currentColor\" class=\"e11-h-6 e11-w-6 e11-transform e11-rotate-90\">\n          <path\n            d=\"M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z\"\n          ></path>\n        </svg>\n      </button>\n    </div>\n  </div>\n</div>\n", styles: ["textarea::-webkit-scrollbar{display:none}textarea{-ms-overflow-style:none;scrollbar-width:none}\n"] }]
        }], ctorParameters: () => [{ type: VoiceToSpeechService }], propDecorators: { disableChatInput: [{
                type: Input
            }], sendingMessage: [{
                type: Input
            }], newMessage: [{
                type: Output
            }] } });

/**
 * ! Warning: This component is currently a work in progress. This was only merged to prevent merge conflicts in worthwhile refactoring
 */
class ReactionsDetailComponent {
    constructor(logger) {
        this.logger = logger;
        this.reactionClicked = new EventEmitter();
        this.fetchReactionInformation = new EventEmitter(); // emits reactionId: userIds[]
        this.reactions = messageReactionOptions;
    }
    ngOnChanges(changes) {
        /**
         * If reaction changes, make paginated read starting at this.message.reactionVMs[emojiUnicode][len-1].userId - unless it's already been fetched?
         * If messageId changes, refetch first page unless we already have it?
         */
        const { message, selectedReaction } = changes;
        if (selectedReaction &&
            message &&
            (selectedReaction.currentValue !== selectedReaction.previousValue || message.currentValue.id !== message.previousValue.id)) {
        }
        // const { role } = changes
        // if (role && hasChanged<ICommunityRole>('id', { before: role.previousValue, after: role.currentValue })) {
        // }
    }
    // Make paginated fetch based on what we currently have on the message
    selectReaction(emojiUnicode) {
        const userIds = this.message.reactions ? this.message.reactions[emojiUnicode] : [];
        const reactions = { [emojiUnicode]: userIds };
        // const reactionVMs = this.message.reactionVMs ? this.message.reactionVMs[emojiUnicode] : []
        // this.logger.log('selectReaction', { emojiUnicode, message: this.message, reactions })
        // this.fetchReactionInformation.emit({ message: this.message, reactions, limit: REACTION_PAGE_SIZE })
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ReactionsDetailComponent, deps: [{ token: LOGGER_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ReactionsDetailComponent, selector: "sdk-reactions-detail", inputs: { selectedReaction: "selectedReaction", message: "message" }, outputs: { reactionClicked: "reactionClicked", fetchReactionInformation: "fetchReactionInformation" }, usesOnChanges: true, ngImport: i0, template: ``, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ReactionsDetailComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-reactions-detail',
                    template: ``,
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }], propDecorators: { selectedReaction: [{
                type: Input
            }], message: [{
                type: Input
            }], reactionClicked: [{
                type: Output
            }], fetchReactionInformation: [{
                type: Output
            }] } });

class UiMessagesRecentMessageDateComponent {
    set conversationId(id) {
        this.conversation$ = this.messagingStore.getConversation(id);
    }
    constructor(messagingStore) {
        this.messagingStore = messagingStore;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiMessagesRecentMessageDateComponent, deps: [{ token: ConversationStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UiMessagesRecentMessageDateComponent, selector: "sdk-ui-messages-recent-date", inputs: { conversationId: "conversationId" }, ngImport: i0, template: `
    <ng-container *ngrxLet="conversation$ as currentConversation">
      <span *ngIf="currentConversation && currentConversation.latestMessage; else loading" class="e11-text-xs">
        {{ 'Most Recent Message' | translate }} :
        {{ currentConversation.latestMessage.__createdAt.toLocaleString() }}
      </span>
      <ng-template #loading>
        <span class="e11-skeleton-empty"> </span>
      </ng-template>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$3.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiMessagesRecentMessageDateComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-ui-messages-recent-date',
                    template: `
    <ng-container *ngrxLet="conversation$ as currentConversation">
      <span *ngIf="currentConversation && currentConversation.latestMessage; else loading" class="e11-text-xs">
        {{ 'Most Recent Message' | translate }} :
        {{ currentConversation.latestMessage.__createdAt.toLocaleString() }}
      </span>
      <ng-template #loading>
        <span class="e11-skeleton-empty"> </span>
      </ng-template>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: ConversationStore }], propDecorators: { conversationId: [{
                type: Input
            }] } });

class UiMessagesParticipantsComponent {
    set conversationId(id) {
        this.conversation$ = this.messagingStore.getConversation(id);
    }
    constructor(messagingStore) {
        this.messagingStore = messagingStore;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiMessagesParticipantsComponent, deps: [{ token: ConversationStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UiMessagesParticipantsComponent, selector: "sdk-ui-messages-participants", inputs: { conversationId: "conversationId" }, ngImport: i0, template: `
    <ng-container *ngrxLet="conversation$ as currentConversation">
      <h4 *ngIf="currentConversation; else loading">{{ currentConversation?.participantInformation | participantNames }}</h4>
      <ng-template #loading>
        <h4 class="e11-skeleton-empty"></h4>
      </ng-template>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$3.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "pipe", type: ParticipantNamesPipe, name: "participantNames" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiMessagesParticipantsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-ui-messages-participants',
                    template: `
    <ng-container *ngrxLet="conversation$ as currentConversation">
      <h4 *ngIf="currentConversation; else loading">{{ currentConversation?.participantInformation | participantNames }}</h4>
      <ng-template #loading>
        <h4 class="e11-skeleton-empty"></h4>
      </ng-template>
    </ng-container>
  `,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: () => [{ type: ConversationStore }], propDecorators: { conversationId: [{
                type: Input
            }] } });

// ! Only add to declare exports if it's needed externally
const DeclareExportComponents$1 = [
    UIMessagesComponent,
    ConversationImageComponent,
    MessageAvatarClickHandlerDirective,
    UIMessagingAvatarComponent,
    UIMessageMarkdownComponent,
    UiMessagesRecentMessageDateComponent,
    UiMessagesParticipantsComponent,
];
class MessageModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: MessageModule, declarations: [UIMessagesComponent,
            ConversationImageComponent,
            MessageAvatarClickHandlerDirective,
            UIMessagingAvatarComponent,
            UIMessageMarkdownComponent,
            UiMessagesRecentMessageDateComponent,
            UiMessagesParticipantsComponent, UiMessageComponent,
            UiMessageTimestampComponent,
            UiMessageToolsComponent,
            UISkeletonMessageComponent,
            MessageEditorComponent,
            ConversationHeaderComponent,
            SideOverHeaderComponent,
            FullPageHeaderComponent,
            MessageAvatarComponent,
            ReactionSummaryComponent,
            ReactionsComponent,
            ReactionsDetailComponent,
            ParticipantNamesPipe,
            UIMessageAttachmentsComponent,
            UiMessagesStarterComponent,
            MessageMarkdownEditorComponent,
            ActiveParticipantsPipe,
            MarkdownClickDirective], imports: [CommonModule, SharedModule, ReactiveFormsModule, FormsModule, MarkdownModule, InfiniteScrollModule], exports: [UIMessagesComponent,
            ConversationImageComponent,
            MessageAvatarClickHandlerDirective,
            UIMessagingAvatarComponent,
            UIMessageMarkdownComponent,
            UiMessagesRecentMessageDateComponent,
            UiMessagesParticipantsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageModule, imports: [CommonModule, SharedModule, ReactiveFormsModule, FormsModule, MarkdownModule, InfiniteScrollModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessageModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ...DeclareExportComponents$1,
                        UiMessageComponent,
                        UiMessageTimestampComponent,
                        UiMessageToolsComponent,
                        UISkeletonMessageComponent,
                        MessageEditorComponent,
                        ConversationHeaderComponent,
                        SideOverHeaderComponent,
                        FullPageHeaderComponent,
                        MessageAvatarComponent,
                        ReactionSummaryComponent,
                        ReactionsComponent,
                        ReactionsDetailComponent,
                        ParticipantNamesPipe,
                        UIMessageAttachmentsComponent,
                        UiMessagesStarterComponent,
                        MessageMarkdownEditorComponent,
                        ActiveParticipantsPipe,
                        MarkdownClickDirective,
                    ],
                    imports: [CommonModule, SharedModule, ReactiveFormsModule, FormsModule, MarkdownModule, InfiniteScrollModule],
                    exports: [...DeclareExportComponents$1],
                }]
        }] });

class ConversationCreateComponent {
    constructor(messagingStore) {
        this.messagingStore = messagingStore;
        this.membershipType = 'flexible';
    }
    ngOnInit() { }
    createConversation() {
        this.messagingStore.onStartConversationAndRoute({
            recipients: this.recipientIds,
            conversationKeys: this.conversationKeys,
            membershipType: this.membershipType,
            creationClientMetadata: this.creationClientMetadata,
            type: this.type,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationCreateComponent, deps: [{ token: ConversationStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationCreateComponent, selector: "sdk-messaging-conversation-create", inputs: { membershipType: "membershipType", recipientIds: "recipientIds", conversationKeys: "conversationKeys", type: "type", creationClientMetadata: "creationClientMetadata" }, ngImport: i0, template: "<e11-button [value]=\"'Create' | translate\" (click)=\"createConversation()\"></e11-button>\n", styles: [""], dependencies: [{ kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationCreateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-messaging-conversation-create', template: "<e11-button [value]=\"'Create' | translate\" (click)=\"createConversation()\"></e11-button>\n" }]
        }], ctorParameters: () => [{ type: ConversationStore }], propDecorators: { membershipType: [{
                type: Input
            }], recipientIds: [{
                type: Input
            }], conversationKeys: [{
                type: Input
            }], type: [{
                type: Input
            }], creationClientMetadata: [{
                type: Input
            }] } });

class ConversationLineItemComponent {
    constructor() { }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationLineItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationLineItemComponent, selector: "sdk-messaging-conversation-line-item", inputs: { conversation: "conversation" }, ngImport: i0, template: "<li\n  class=\"e11-py-4 e11-px-4 e11-rounded-t-md e11-cursor-pointer hover:e11-bg-gray-100 e11-relative\"\n  [ngClass]=\"{ 'e11-bg-gray-200': conversation.closed }\"\n>\n  <span\n    *ngIf=\"conversation.latestIsUnread\"\n    class=\"e11-left-0 e11-ml-1.5 e11-mt-6 e11-absolute e11-flex-shrink-0 e11-flex e11-items-center e11-justify-center\"\n  >\n    <span class=\"e11-h-1.5 e11-w-1.5 e11-rounded-full e11-bg-skin-primary\" aria-hidden=\"true\"></span>\n  </span>\n  <div class=\"e11-flex e11-space-x-3\">\n    <sdk-messaging-conversation-image [conversationImageData]=\"conversation.conversationImageData\"> </sdk-messaging-conversation-image>\n    <div class=\"e11-flex-1 e11-space-y-1\">\n      <div class=\"e11-flex e11-items-center e11-justify-between\">\n        <h6 class=\"e11-font-medium e11-m-0\" [ngClass]=\"{ 'e11-font-semibold e11-text-skin-primary-accent': conversation.latestIsUnread }\">\n          {{ conversation.shortName }}\n        </h6>\n        <p class=\"e11-text-xs e11-text-gray-500 e11-m-0 e11-font-extralight\">\n          {{\n            conversation.latestIsUnread\n              ? \"NEW\"\n              : conversation.latestMessage?.__createdAt?.toLocaleDateString() ?? conversation.__createdAt.toLocaleDateString()\n          }}\n        </p>\n      </div>\n      <p class=\"e11-text-xs e11-text-gray-500 e11-line-clamp-2 e11-m-0\">\n        <ui-message-markdown\n          *ngIf=\"conversation.latestMessage; else emptyMessage\"\n          [message]=\"conversation.latestMessage\"\n          [userId]=\"conversation.currentUserId\"\n        ></ui-message-markdown>\n        <ng-template #emptyMessage>\n          {{ \"No Messages\" | translate }}\n        </ng-template>\n      </p>\n    </div>\n  </div>\n</li>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ConversationImageComponent, selector: "sdk-messaging-conversation-image", inputs: ["conversationImageData", "size"] }, { kind: "component", type: UIMessageMarkdownComponent, selector: "ui-message-markdown", inputs: ["message", "userId"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationLineItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-messaging-conversation-line-item', template: "<li\n  class=\"e11-py-4 e11-px-4 e11-rounded-t-md e11-cursor-pointer hover:e11-bg-gray-100 e11-relative\"\n  [ngClass]=\"{ 'e11-bg-gray-200': conversation.closed }\"\n>\n  <span\n    *ngIf=\"conversation.latestIsUnread\"\n    class=\"e11-left-0 e11-ml-1.5 e11-mt-6 e11-absolute e11-flex-shrink-0 e11-flex e11-items-center e11-justify-center\"\n  >\n    <span class=\"e11-h-1.5 e11-w-1.5 e11-rounded-full e11-bg-skin-primary\" aria-hidden=\"true\"></span>\n  </span>\n  <div class=\"e11-flex e11-space-x-3\">\n    <sdk-messaging-conversation-image [conversationImageData]=\"conversation.conversationImageData\"> </sdk-messaging-conversation-image>\n    <div class=\"e11-flex-1 e11-space-y-1\">\n      <div class=\"e11-flex e11-items-center e11-justify-between\">\n        <h6 class=\"e11-font-medium e11-m-0\" [ngClass]=\"{ 'e11-font-semibold e11-text-skin-primary-accent': conversation.latestIsUnread }\">\n          {{ conversation.shortName }}\n        </h6>\n        <p class=\"e11-text-xs e11-text-gray-500 e11-m-0 e11-font-extralight\">\n          {{\n            conversation.latestIsUnread\n              ? \"NEW\"\n              : conversation.latestMessage?.__createdAt?.toLocaleDateString() ?? conversation.__createdAt.toLocaleDateString()\n          }}\n        </p>\n      </div>\n      <p class=\"e11-text-xs e11-text-gray-500 e11-line-clamp-2 e11-m-0\">\n        <ui-message-markdown\n          *ngIf=\"conversation.latestMessage; else emptyMessage\"\n          [message]=\"conversation.latestMessage\"\n          [userId]=\"conversation.currentUserId\"\n        ></ui-message-markdown>\n        <ng-template #emptyMessage>\n          {{ \"No Messages\" | translate }}\n        </ng-template>\n      </p>\n    </div>\n  </div>\n</li>\n" }]
        }], ctorParameters: () => [], propDecorators: { conversation: [{
                type: Input
            }] } });

class ConversationNavItemComponent {
    constructor() {
        this.isSelected = false;
        this.darkMode = false;
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationNavItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationNavItemComponent, selector: "sdk-conversation-nav-item", inputs: { conversation: "conversation", isSelected: "isSelected", darkMode: "darkMode" }, ngImport: i0, template: "<li\n  class=\"e11-flex e11-items-center e11-relative e11-w-full e11-mb-2 e11-px-4 e11-text-sm e11-mr-1 e11-rounded-md e11-h-10 e11-transition e11-duration-200 hover:e11-text-skin-white hover:e11-bg-skin-grey/30 hover:e11-cursor-pointer\"\n  [ngClass]=\"{\n    'e11-bg-skin-grey/30 e11-text-skin-white': isSelected,\n    'e11-text-skin-light': !conversation.latestIsUnread && darkMode && !isSelected,\n    'e11-text-white': darkMode && conversation.latestIsUnread\n  }\"\n  [attr.title]=\"conversation.shortName.length > 14 ? conversation.shortName : undefined\"\n>\n  <e11-indicator *ngIf=\"conversation.latestIsUnread\" [size]=\"'xs'\" [color]=\"'white'\" [posAdjustX]=\"'6px'\" [posAdjustY]=\"'17px'\"></e11-indicator>\n  <e11-profile-pic\n    [imageUrl]=\"conversation.conversationImageData.imageUrl\"\n    [size]=\"'sm'\"\n    [type]=\"'circular'\"\n    [hasBorder]=\"true\"\n    [hasRing]=\"true\"\n    iconClass=\"e11-bg-skin-app-bg-dark\"\n    [textValue]=\"conversation.conversationImageData.textFallback\"\n  >\n  </e11-profile-pic>\n  <span\n    class=\"e11-whitespace-nowrap e11-truncate e11-ml-3\"\n    [ngClass]=\"{\n      'e11-font-primary-demibold e11-text-skin-white': conversation.latestIsUnread,\n    }\"\n  >\n    {{ conversation.shortName }}\n  </span>\n</li>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$6.E11ProfilePicComponent, selector: "e11-profile-pic", inputs: ["value", "style", "imageUrl", "imageFit", "size", "edit", "disabled", "type", "hasBorder", "hasRing", "icon", "iconPositionY", "iconPositionX", "textValue", "imageClass", "textClass", "iconClass", "loadingImageUrl"], outputs: ["editProfilePic"] }, { kind: "component", type: i3$6.E11IndicatorComponent, selector: "e11-indicator", inputs: ["color", "size", "classOverrides", "posAdjustY", "posAdjustX"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationNavItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-conversation-nav-item', template: "<li\n  class=\"e11-flex e11-items-center e11-relative e11-w-full e11-mb-2 e11-px-4 e11-text-sm e11-mr-1 e11-rounded-md e11-h-10 e11-transition e11-duration-200 hover:e11-text-skin-white hover:e11-bg-skin-grey/30 hover:e11-cursor-pointer\"\n  [ngClass]=\"{\n    'e11-bg-skin-grey/30 e11-text-skin-white': isSelected,\n    'e11-text-skin-light': !conversation.latestIsUnread && darkMode && !isSelected,\n    'e11-text-white': darkMode && conversation.latestIsUnread\n  }\"\n  [attr.title]=\"conversation.shortName.length > 14 ? conversation.shortName : undefined\"\n>\n  <e11-indicator *ngIf=\"conversation.latestIsUnread\" [size]=\"'xs'\" [color]=\"'white'\" [posAdjustX]=\"'6px'\" [posAdjustY]=\"'17px'\"></e11-indicator>\n  <e11-profile-pic\n    [imageUrl]=\"conversation.conversationImageData.imageUrl\"\n    [size]=\"'sm'\"\n    [type]=\"'circular'\"\n    [hasBorder]=\"true\"\n    [hasRing]=\"true\"\n    iconClass=\"e11-bg-skin-app-bg-dark\"\n    [textValue]=\"conversation.conversationImageData.textFallback\"\n  >\n  </e11-profile-pic>\n  <span\n    class=\"e11-whitespace-nowrap e11-truncate e11-ml-3\"\n    [ngClass]=\"{\n      'e11-font-primary-demibold e11-text-skin-white': conversation.latestIsUnread,\n    }\"\n  >\n    {{ conversation.shortName }}\n  </span>\n</li>\n" }]
        }], ctorParameters: () => [], propDecorators: { conversation: [{
                type: Input
            }], isSelected: [{
                type: Input
            }], darkMode: [{
                type: Input
            }] } });

class MessagingOperationService {
    constructor(messageStore, conversationStore, conversationConfigService, logger) {
        this.messageStore = messageStore;
        this.conversationStore = conversationStore;
        this.conversationConfigService = conversationConfigService;
        this.logger = logger;
    }
    /**
     * ! Only supports fixed membership conversations (direct messages) currently
     * @param conversationRequest
     */
    getOrStartConversationWithRoute(conversationRequest) {
        const modelWithDefaults = this.provideConversationDefaults(conversationRequest);
        this.messageStore.onGetOrStartConversationWithRoute(modelWithDefaults);
    }
    /**
     * Navigate to the conversation using the app's @onConversationClick handler in @ConversationConfigService
     * @param conversation
     */
    navigateToConversation(conversation) {
        this.conversationConfigService.onConversationClick(conversation);
    }
    /**
     * Navigate to the conversation using the app's @onConversationClick handler in @ConversationConfigService
     * TODO: consider using the global loader
     * @param conversationId
     */
    navigateToConversationFromId(conversationId) {
        this.conversationStore.getConversationsLoaded
            .pipe(filter$1(isTrue), switchMap$1((_) => this.conversationStore.getConversation(conversationId)), take$1(1), // Do NOT re-fire every time the conversation changes
        map$1((conversation) => throwIfNil(conversation, conversationMissingError(conversationId))) // Conversation SHOULD NOT be null because all conversations have loaded
        )
            .subscribe((conversation) => this.navigateToConversation(conversation));
    }
    provideConversationDefaults(conversationRequest) {
        return {
            membershipType: 'fixed',
            type: CONVERSATION_TYPES.DIRECT_MESSAGE,
            ...conversationRequest,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingOperationService, deps: [{ token: ConversationMessageStore }, { token: ConversationStore }, { token: ConversationConfigService }, { token: LOGGER_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingOperationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingOperationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ConversationMessageStore }, { type: ConversationStore }, { type: ConversationConfigService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }] });
const conversationMissingError = (conversationId) => e11Error({
    type: ERROR_TYPES.CONVERSATION_MISSING,
    title: 'Attempted to navigate to a conversation that could not be found. Please try again later.',
    message: `Cannot find conversation ${conversationId}`,
    additionalData: { conversationId },
});

class ConversationNavEmptyComponent {
    constructor() {
        this.darkMode = false;
        this.emptyStateSubtitle = 'This is where you get messages';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationNavEmptyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationNavEmptyComponent, selector: "sdk-conversation-nav-empty", inputs: { darkMode: "darkMode", emptyStateSubtitle: "emptyStateSubtitle" }, ngImport: i0, template: `
    <div class="e11-w-full">
      <div class="e11-flex e11-items-center e11-mb-2" [ngClass]="{ 'e11-text-skin-extra-light': darkMode }">
        <span class="material-icons-outlined e11-mr-2"> message </span>
        <span class="e11-font-medium">
          {{ 'Nothing yet' | translate }}
        </span>
      </div>
      <div class="e11-grow">
        <p class="e11-text-sm e11-mb-0" [ngClass]="{ 'e11-text-skin-extra-light': darkMode }">
          {{ emptyStateSubtitle | translate }}
        </p>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationNavEmptyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-conversation-nav-empty', template: `
    <div class="e11-w-full">
      <div class="e11-flex e11-items-center e11-mb-2" [ngClass]="{ 'e11-text-skin-extra-light': darkMode }">
        <span class="material-icons-outlined e11-mr-2"> message </span>
        <span class="e11-font-medium">
          {{ 'Nothing yet' | translate }}
        </span>
      </div>
      <div class="e11-grow">
        <p class="e11-text-sm e11-mb-0" [ngClass]="{ 'e11-text-skin-extra-light': darkMode }">
          {{ emptyStateSubtitle | translate }}
        </p>
      </div>
    </div>
  ` }]
        }], propDecorators: { darkMode: [{
                type: Input
            }], emptyStateSubtitle: [{
                type: Input
            }] } });

class ConversationNavComponent {
    constructor(conversationStore, messagingOperationService) {
        this.conversationStore = conversationStore;
        this.messagingOperationService = messagingOperationService;
        this.trackById = trackById;
        this.disabledChatInput = false;
        this.darkMode = false;
        this.emptyStateSubtitle = 'This is where you get messages';
        this.conversationsLoaded$ = this.conversationStore.getConversationsLoaded;
        this.currentConversationId$ = this.conversationStore.currentConversationId$;
    }
    ngOnInit() {
        const query = { limit: this.limit, types: this.type ? [this.type] : this.types, customFilter: this.conversationFilter };
        this.conversations$ = this.conversationStore.queryConversations(query);
        this.unreadCount$ = this.conversationStore.getUnreadConversationCountForQuery(query);
    }
    openConversation(conversation) {
        this.messagingOperationService.navigateToConversation(conversation);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationNavComponent, deps: [{ token: ConversationStore }, { token: MessagingOperationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationNavComponent, selector: "sdk-conversation-nav", inputs: { disabledChatInput: "disabledChatInput", type: "type", types: "types", darkMode: "darkMode", emptyStateSubtitle: "emptyStateSubtitle", limit: "limit", conversationFilter: "conversationFilter" }, ngImport: i0, template: `
    <ng-container *ngrxLet="conversationsLoaded$ as loaded">
      <ng-container *ngrxLet="currentConversationId$ as currentConversationId">
        <ng-container *ngrxLet="conversations$ as conversations">
          <ul role="list" class="e11-overflow-y-auto e11-max-h-[75vh]">
            <sdk-conversation-nav-item
              *ngFor="let conversation of conversations ?? []; trackBy: trackById"
              [conversation]="conversation"
              [isSelected]="conversation.id === currentConversationId"
              [darkMode]="darkMode"
              (click)="openConversation(conversation)"
            ></sdk-conversation-nav-item>
            <li *ngIf="loaded && conversations?.length === 0" class="e11-py-4 e11-px-4 e11-rounded-md">
              <sdk-conversation-nav-empty [darkMode]="darkMode" [emptyStateSubtitle]="emptyStateSubtitle"></sdk-conversation-nav-empty>
            </li>
            <li *ngIf="!loaded" class="e11-py-4 e11-px-4 e11-rounded-md">
              <e11-loader-dots [size]="'sm'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
            </li>
          </ul>
        </ng-container>
      </ng-container>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "directive", type: i3$3.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: ConversationNavItemComponent, selector: "sdk-conversation-nav-item", inputs: ["conversation", "isSelected", "darkMode"] }, { kind: "component", type: ConversationNavEmptyComponent, selector: "sdk-conversation-nav-empty", inputs: ["darkMode", "emptyStateSubtitle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationNavComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-conversation-nav',
                    template: `
    <ng-container *ngrxLet="conversationsLoaded$ as loaded">
      <ng-container *ngrxLet="currentConversationId$ as currentConversationId">
        <ng-container *ngrxLet="conversations$ as conversations">
          <ul role="list" class="e11-overflow-y-auto e11-max-h-[75vh]">
            <sdk-conversation-nav-item
              *ngFor="let conversation of conversations ?? []; trackBy: trackById"
              [conversation]="conversation"
              [isSelected]="conversation.id === currentConversationId"
              [darkMode]="darkMode"
              (click)="openConversation(conversation)"
            ></sdk-conversation-nav-item>
            <li *ngIf="loaded && conversations?.length === 0" class="e11-py-4 e11-px-4 e11-rounded-md">
              <sdk-conversation-nav-empty [darkMode]="darkMode" [emptyStateSubtitle]="emptyStateSubtitle"></sdk-conversation-nav-empty>
            </li>
            <li *ngIf="!loaded" class="e11-py-4 e11-px-4 e11-rounded-md">
              <e11-loader-dots [size]="'sm'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
            </li>
          </ul>
        </ng-container>
      </ng-container>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: ConversationStore }, { type: MessagingOperationService }], propDecorators: { disabledChatInput: [{
                type: Input
            }], type: [{
                type: Input
            }], types: [{
                type: Input
            }], darkMode: [{
                type: Input
            }], emptyStateSubtitle: [{
                type: Input
            }], limit: [{
                type: Input
            }], conversationFilter: [{
                type: Input
            }] } });

class UIMessagesEnvelopeComponent {
    constructor() {
        this.unreadCount = 0;
        this.disabledChatInput = false;
        this.UNREAD_LIMIT = UNREAD_CONVERSATIONS_LIMIT; // Displays 9+ if more unread messages than that
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIMessagesEnvelopeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UIMessagesEnvelopeComponent, selector: "ui-messages-envelope", inputs: { unreadCount: "unreadCount", disabledChatInput: "disabledChatInput" }, ngImport: i0, template: `
    <e11-icon-envelope></e11-icon-envelope>
    <e11-badge
      *ngIf="unreadCount > 0"
      [value]="unreadCount"
      [color]="'error'"
      [size]="'sm'"
      [limit]="UNREAD_LIMIT"
      [posAdjustX]="'-10px'"
      [containerClassOverrides]="''"
    ></e11-badge>
  `, isInline: true, styles: [""], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.E11BadgeComponent, selector: "e11-badge", inputs: ["color", "shape", "size", "inTag", "classOverrides", "class", "posAdjustY", "posAdjustX", "containerClassOverrides", "containerClass", "inline", "titleText", "titleTextPosition", "value", "limit"] }, { kind: "component", type: i3$7.E11IconEnvelopeComponent, selector: "e11-icon-envelope", inputs: ["classOverrides", "titleText", "titleTextPosition"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIMessagesEnvelopeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ui-messages-envelope', template: `
    <e11-icon-envelope></e11-icon-envelope>
    <e11-badge
      *ngIf="unreadCount > 0"
      [value]="unreadCount"
      [color]="'error'"
      [size]="'sm'"
      [limit]="UNREAD_LIMIT"
      [posAdjustX]="'-10px'"
      [containerClassOverrides]="''"
    ></e11-badge>
  ` }]
        }], propDecorators: { unreadCount: [{
                type: Input
            }], disabledChatInput: [{
                type: Input
            }] } });

class MessagesEnvelopeComponent {
    constructor(messagingStore, conversationMessageStore) {
        this.messagingStore = messagingStore;
        this.conversationMessageStore = conversationMessageStore;
        this.disabledChatInput = false;
        this.envelopeOpen = false;
        this.contextPlacement = ContextPlacement;
        this.headerTypeEnum = ConversationHeaderType;
        this.unreadCount$ = this.messagingStore.getUnreadConversationCount;
        this.conversations$ = this.messagingStore.getConversations;
        this.conversationsLoaded$ = this.messagingStore.getConversationsLoaded;
    }
    onClickEnvelope() {
        this.envelopeOpen = !this.envelopeOpen;
    }
    sendMessage(conversationId, message) {
        this.conversationMessageStore.onSendMessage({ conversationId, text: message.message, attachments: message.files, mentions: {} });
    }
    openConversation(conversation) {
        this.envelopeOpen = false;
        this.currentConversation = conversation;
        this.sideOverContainer.open();
    }
    closeConversation() {
        this.currentConversation = undefined;
        this.sideOverContainer.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagesEnvelopeComponent, deps: [{ token: ConversationStore }, { token: ConversationMessageStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: MessagesEnvelopeComponent, selector: "messages-envelope", inputs: { disabledChatInput: "disabledChatInput" }, viewQueries: [{ propertyName: "sideOverContainer", first: true, predicate: ["sideOverContainer"], descendants: true }], ngImport: i0, template: `
    <ng-container *ngrxLet="unreadCount$ as unreadCount">
      <div class="e11-ml-3 e11-relative">
        <div>
          <button
            #dropdownOpener
            (click)="onClickEnvelope()"
            type="button"
            class="e11-flex-shrink-0 e11-p-1 e11-text-gray-300 e11-rounded-full hover:e11-text-white hover:e11-bg-white hover:e11-bg-opacity-10 focus:e11-outline-none focus:e11-ring-2 focus:e11-ring-white"
          >
            <span class="e11-sr-only">{{ 'View Message' | translate }}</span>
            <ui-messages-envelope [disabledChatInput]="disabledChatInput" [unreadCount]="unreadCount"></ui-messages-envelope>
          </button>
        </div>
        <div
          [dropdownCloser]="dropdownOpener"
          (closeEventTriggered)="envelopeOpen = false"
          [ngClass]="{
            'e11-transition e11-ease-out e11-duration-200 e11-transform e11-opacity-0 e11-scale-95 e11-invisible': !envelopeOpen,
            'e11-transition e11-ease-in duration-75 e11-e11-transform e11-opacity-100 e11-scale-100': envelopeOpen
          }"
          class="e11-origin-top-right e11-absolute e11-right-0 e11-mt-2 e11-w-80 e11-rounded-md e11-shadow-lg e11-bg-white e11-ring-1 e11-ring-black e11-ring-opacity-5 focus:e11-outline-none focus:e11-ring-opacity-100 focus:e11-ring-gray-200"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="user-menu-button"
          tabindex="-1"
        >
          <ng-container *ngrxLet="conversationsLoaded$ as loaded">
            <ng-container *ngrxLet="conversations$ as conversations">
              <ul role="list" class="e11-overflow-y-auto e11-max-h-[75vh]">
                <sdk-messaging-conversation-line-item
                  *ngFor="let conversation of conversations ?? []"
                  [conversation]="conversation"
                  (click)="openConversation(conversation)"
                ></sdk-messaging-conversation-line-item>
                <li *ngIf="loaded && conversations?.length === 0" class="e11-py-4 e11-px-4 e11-rounded-md">
                  <div class="e11-flex e11-space-x-3">
                    <div class="e11-flex-1 e11-space-y-1">
                      <e11-icon-inbox [classOverrides]="'e11-m-auto'"></e11-icon-inbox>
                      <h3 class="e11-mt-2 e11-text-sm e11-font-medium e11-text-gray-900 e11-mb-0 e11-text-center">{{ 'Nothing yet' | translate }}</h3>
                      <p class="e11-mt-1 e11-text-sm e11-text-gray-500 e11-mb-0 e11-text-center">
                        {{ 'This is where you get direct messages' | translate }}
                      </p>
                    </div>
                  </div>
                </li>
                <li *ngIf="!loaded" class="e11-py-4 e11-px-4 e11-rounded-md">
                  <e11-loader-dots [size]="'sm'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
                </li>
              </ul>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <e11-side-over-container #sideOverContainer>
      <ng-template e11Template="content">
        <sdk-messaging-conversation
          *ngIf="currentConversation"
          [conversation]="currentConversation"
          [disabledChatInput]="disabledChatInput"
          [context]="contextPlacement.Sideover"
          [headerType]="headerTypeEnum.SideOver"
          (emitNewMessage)="sendMessage(currentConversation.id, $event)"
          (emitClose)="closeConversation()"
        ></sdk-messaging-conversation>
      </ng-template>
    </e11-side-over-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4$3.E11Template, selector: "[e11Template]", inputs: ["type", "e11Template"] }, { kind: "component", type: i5.E11SideOverContainerComponent, selector: "e11-side-over-container", inputs: ["containerClassOverrides", "size", "background", "sideOverPosition", "closeOnEscape", "closeOnClickOutside"], outputs: ["sideOverContainerClosed"] }, { kind: "component", type: i3$7.E11IconInboxComponent, selector: "e11-icon-inbox", inputs: ["classOverrides"] }, { kind: "component", type: i4.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "directive", type: i3$3.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "directive", type: i1$4.DropdownCloserDirective, selector: "[dropdownCloser]", inputs: ["dropdownCloser"], outputs: ["closeEventTriggered"] }, { kind: "component", type: ConversationComponent, selector: "sdk-messaging-conversation", inputs: ["conversationDisplayData", "conversation", "loadingConversation", "disabledChatInput", "context", "contextType", "headerType"], outputs: ["emitNewMessage", "emitClose"] }, { kind: "component", type: ConversationLineItemComponent, selector: "sdk-messaging-conversation-line-item", inputs: ["conversation"] }, { kind: "component", type: UIMessagesEnvelopeComponent, selector: "ui-messages-envelope", inputs: ["unreadCount", "disabledChatInput"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagesEnvelopeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'messages-envelope',
                    template: `
    <ng-container *ngrxLet="unreadCount$ as unreadCount">
      <div class="e11-ml-3 e11-relative">
        <div>
          <button
            #dropdownOpener
            (click)="onClickEnvelope()"
            type="button"
            class="e11-flex-shrink-0 e11-p-1 e11-text-gray-300 e11-rounded-full hover:e11-text-white hover:e11-bg-white hover:e11-bg-opacity-10 focus:e11-outline-none focus:e11-ring-2 focus:e11-ring-white"
          >
            <span class="e11-sr-only">{{ 'View Message' | translate }}</span>
            <ui-messages-envelope [disabledChatInput]="disabledChatInput" [unreadCount]="unreadCount"></ui-messages-envelope>
          </button>
        </div>
        <div
          [dropdownCloser]="dropdownOpener"
          (closeEventTriggered)="envelopeOpen = false"
          [ngClass]="{
            'e11-transition e11-ease-out e11-duration-200 e11-transform e11-opacity-0 e11-scale-95 e11-invisible': !envelopeOpen,
            'e11-transition e11-ease-in duration-75 e11-e11-transform e11-opacity-100 e11-scale-100': envelopeOpen
          }"
          class="e11-origin-top-right e11-absolute e11-right-0 e11-mt-2 e11-w-80 e11-rounded-md e11-shadow-lg e11-bg-white e11-ring-1 e11-ring-black e11-ring-opacity-5 focus:e11-outline-none focus:e11-ring-opacity-100 focus:e11-ring-gray-200"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="user-menu-button"
          tabindex="-1"
        >
          <ng-container *ngrxLet="conversationsLoaded$ as loaded">
            <ng-container *ngrxLet="conversations$ as conversations">
              <ul role="list" class="e11-overflow-y-auto e11-max-h-[75vh]">
                <sdk-messaging-conversation-line-item
                  *ngFor="let conversation of conversations ?? []"
                  [conversation]="conversation"
                  (click)="openConversation(conversation)"
                ></sdk-messaging-conversation-line-item>
                <li *ngIf="loaded && conversations?.length === 0" class="e11-py-4 e11-px-4 e11-rounded-md">
                  <div class="e11-flex e11-space-x-3">
                    <div class="e11-flex-1 e11-space-y-1">
                      <e11-icon-inbox [classOverrides]="'e11-m-auto'"></e11-icon-inbox>
                      <h3 class="e11-mt-2 e11-text-sm e11-font-medium e11-text-gray-900 e11-mb-0 e11-text-center">{{ 'Nothing yet' | translate }}</h3>
                      <p class="e11-mt-1 e11-text-sm e11-text-gray-500 e11-mb-0 e11-text-center">
                        {{ 'This is where you get direct messages' | translate }}
                      </p>
                    </div>
                  </div>
                </li>
                <li *ngIf="!loaded" class="e11-py-4 e11-px-4 e11-rounded-md">
                  <e11-loader-dots [size]="'sm'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
                </li>
              </ul>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <e11-side-over-container #sideOverContainer>
      <ng-template e11Template="content">
        <sdk-messaging-conversation
          *ngIf="currentConversation"
          [conversation]="currentConversation"
          [disabledChatInput]="disabledChatInput"
          [context]="contextPlacement.Sideover"
          [headerType]="headerTypeEnum.SideOver"
          (emitNewMessage)="sendMessage(currentConversation.id, $event)"
          (emitClose)="closeConversation()"
        ></sdk-messaging-conversation>
      </ng-template>
    </e11-side-over-container>
  `,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: () => [{ type: ConversationStore }, { type: ConversationMessageStore }], propDecorators: { disabledChatInput: [{
                type: Input
            }], sideOverContainer: [{
                type: ViewChild,
                args: ['sideOverContainer']
            }] } });

/**
 * Needs:
 * - Open a conversation (given the conversationId, or possibly the whole ConversationVM) - from a list of conversations we already have
 * - Open a conversation by recipients - another component for fixed members only
 * - Open a conversation by some deterministic ID(s) that don't hinge on recipients (e.g. the conversation for this job application - jobApplicationId)
 * - Display an "empty" mock conversation that doesn't exist yet
 *
 *
 * - Multiple components, each with DIFFERENT interfaces, all of which fetch the conversation and pass it down to a universal component
 *  - Pass in a conversation and pop open the messages list - we have the conversation so, simple
 *  - Pass in the deterministic ID, fetch the conversation, pass it down to universal component. Can we assume conversation exists? If not, pass in name & subtitle
 *  - Pass in the recipientIds & conversationKeys, fetch the conversation, pass it down to universal component. Must pass in
 *
 */
/**
 * @deprecated use sdk-messaging-direct-messages instead - the name is clearer - this wraps it for backward compatibility
 */
class MessagesListComponent {
    constructor() {
        this.participantInformation = {};
        this.conversationKeys = []; // ! only applies to DMs
        this.disabledChatInput = false;
        this.emitClose = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagesListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: MessagesListComponent, selector: "messages-list", inputs: { conversationName: "conversationName", conversationSubtitle: "conversationSubtitle", participantInformation: "participantInformation", recipientIds: "recipientIds", conversationKeys: "conversationKeys", disabledChatInput: "disabledChatInput" }, outputs: { emitClose: "emitClose" }, ngImport: i0, template: `
    <sdk-messaging-direct-messages
      [conversationDisplayData]="{conversationName, conversationSubtitle}"
      [recipientIds]="recipientIds"
      [conversationKeys]="conversationKeys"
      [disabledChatInput]="disabledChatInput"
      (emitClose)="emitClose.emit()"
    ></sdk-messaging-direct-messages>
  `, isInline: true, dependencies: [{ kind: "component", type: DirectMessagesComponent, selector: "sdk-messaging-direct-messages", inputs: ["conversationDisplayData", "recipientIds", "conversationKeys", "conversationType", "creationClientMetadata", "disabledChatInput", "context", "headerType"], outputs: ["emitClose"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagesListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'messages-list',
                    template: `
    <sdk-messaging-direct-messages
      [conversationDisplayData]="{conversationName, conversationSubtitle}"
      [recipientIds]="recipientIds"
      [conversationKeys]="conversationKeys"
      [disabledChatInput]="disabledChatInput"
      (emitClose)="emitClose.emit()"
    ></sdk-messaging-direct-messages>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { conversationName: [{
                type: Input
            }], conversationSubtitle: [{
                type: Input
            }], participantInformation: [{
                type: Input
            }], recipientIds: [{
                type: Input
            }], conversationKeys: [{
                type: Input
            }], disabledChatInput: [{
                type: Input
            }], emitClose: [{
                type: Output
            }] } });

const defaultOverlayConfig = { ...OVERLAY_DEFAULT_CONFIG };
class ConversationSideOverService {
    constructor() {
        this.config$ = new BehaviorSubject(null);
    }
    open(config) {
        const configToUse = { ...defaultOverlayConfig, ...config };
        this.config$.next(configToUse);
    }
    close() {
        this.config$.next(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationSideOverService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationSideOverService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationSideOverService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/**
 * Purpose: Need to be able to open the conversation sideover from anywhere in the app using a service.
 * Slap this somewhere high up in the app since it's a global component. e.g. app-component
 */
class ConversationSideOverComponent {
    constructor(conversationStore, conversationMessageStore, conversationSideOverService) {
        this.conversationStore = conversationStore;
        this.conversationMessageStore = conversationMessageStore;
        this.conversationSideOverService = conversationSideOverService;
        this.contextPlacement = ContextPlacement;
        this.headerTypeEnum = ConversationHeaderType;
        this.destroy$ = new Subject();
    }
    ngAfterViewInit() {
        this.conversationSideOverService.config$.pipe(takeUntil$1(this.destroy$)).subscribe((config) => {
            if (!config)
                this.sideOverContainer.close();
            else {
                this.conversation$ = this.conversationStore.getConversation(config.conversationId);
                this.sideOverContainer.open();
            }
        });
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    sendMessage(conversationId, message) {
        this.conversationMessageStore.onSendMessage({ conversationId, text: message.message, attachments: message.files, mentions: {} });
    }
    closeConversation() {
        this.conversationSideOverService.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationSideOverComponent, deps: [{ token: ConversationStore }, { token: ConversationMessageStore }, { token: ConversationSideOverService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationSideOverComponent, selector: "sdk-conversation-side-over", viewQueries: [{ propertyName: "sideOverContainer", first: true, predicate: ["sideOverContainer"], descendants: true }], ngImport: i0, template: `
    <e11-side-over-container #sideOverContainer>
      <ng-template e11Template="content" *ngrxLet="conversation$ as conversation">
        <sdk-messaging-conversation
          [conversation]="conversation ?? null"
          [loadingConversation]="!conversation"
          [context]="contextPlacement.Sideover"
          [headerType]="headerTypeEnum.SideOver"
          (emitNewMessage)="sendMessage(conversation!.id, $event)"
          (emitClose)="closeConversation()"
        ></sdk-messaging-conversation>
      </ng-template>
    </e11-side-over-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i4$3.E11Template, selector: "[e11Template]", inputs: ["type", "e11Template"] }, { kind: "component", type: i5.E11SideOverContainerComponent, selector: "e11-side-over-container", inputs: ["containerClassOverrides", "size", "background", "sideOverPosition", "closeOnEscape", "closeOnClickOutside"], outputs: ["sideOverContainerClosed"] }, { kind: "directive", type: i3$3.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: ConversationComponent, selector: "sdk-messaging-conversation", inputs: ["conversationDisplayData", "conversation", "loadingConversation", "disabledChatInput", "context", "contextType", "headerType"], outputs: ["emitNewMessage", "emitClose"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationSideOverComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-conversation-side-over',
                    template: `
    <e11-side-over-container #sideOverContainer>
      <ng-template e11Template="content" *ngrxLet="conversation$ as conversation">
        <sdk-messaging-conversation
          [conversation]="conversation ?? null"
          [loadingConversation]="!conversation"
          [context]="contextPlacement.Sideover"
          [headerType]="headerTypeEnum.SideOver"
          (emitNewMessage)="sendMessage(conversation!.id, $event)"
          (emitClose)="closeConversation()"
        ></sdk-messaging-conversation>
      </ng-template>
    </e11-side-over-container>
  `,
                }]
        }], ctorParameters: () => [{ type: ConversationStore }, { type: ConversationMessageStore }, { type: ConversationSideOverService }], propDecorators: { sideOverContainer: [{
                type: ViewChild,
                args: ['sideOverContainer']
            }] } });

/**
 * Fetches the conversation if it exists, creates a new conversation if it doesn't
 * TODO: Consider whether we want the conversationId passed in or search the set of conversations by the values in NewConversationModel
 */
class ConversationFetchCreateComponent {
    set conversationId(id) {
        this._conversationId = id;
        if (id)
            this.conversation$ = this.conversationStore.getConversation(id);
    }
    constructor(conversationStore, conversationMessageStore, conversationService, cd) {
        this.conversationStore = conversationStore;
        this.conversationMessageStore = conversationMessageStore;
        this.conversationService = conversationService;
        this.cd = cd;
        this.headerType = ConversationHeaderType.Full;
        this.disabledChatInput = false;
        this.newConversationId = new EventEmitter(); // allows user to store conversationId to retrieve it later
        this.ContextCommunicationType = ContextCommunicationType;
        this.ContextPlacement = ContextPlacement;
        this.conversationsLoaded$ = this.conversationStore.getConversationsLoaded;
        this.startingConversation = false;
    }
    ngAfterViewInit() {
        this.cd.detectChanges();
    }
    async sendMessage(message) {
        if (this._conversationId) {
            this.conversationMessageStore.onSendMessage({
                conversationId: this._conversationId,
                text: message.message,
                attachments: message.files,
                mentions: {},
            });
        }
        else {
            /**
             * TODO: What to do if user sends multiple messages at start? How to prevent issues.
             * Figure out how to search for matching conversations and send via that conversation instead
             */
            // this.conversation$ = this.conversationStore.getConversationMatchingKeys(this.newConversationModel)
            /**
             * Create conversation & emit the id
             */
            const newConversation = { ...this.newConversationModel, initialMessage: message.message, attachments: message.files };
            this.startingConversation = true;
            const conversation = await firstValueFrom(this.conversationService.startConversation(newConversation));
            this.startingConversation = false;
            this._conversationId = conversation.id;
            this.newConversationId.emit(conversation.id);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationFetchCreateComponent, deps: [{ token: ConversationStore }, { token: ConversationMessageStore }, { token: ConversationService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationFetchCreateComponent, selector: "sdk-conversation-fetch-create", inputs: { conversationDisplayData: "conversationDisplayData", newConversationModel: "newConversationModel", conversationId: "conversationId", headerType: "headerType", disabledChatInput: "disabledChatInput" }, outputs: { newConversationId: "newConversationId" }, ngImport: i0, template: `
    <ng-container *ngrxLet="conversation$ as conversation">
      <sdk-messaging-conversation
        [conversation]="conversation ?? null"
        [conversationDisplayData]="conversationDisplayData"
        [context]="ContextPlacement.View"
        [contextType]="ContextCommunicationType.Conversation"
        [disabledChatInput]="disabledChatInput"
        [headerType]="headerType"
        [loadingConversation]="!(conversationsLoaded$ | async) || startingConversation"
        (emitNewMessage)="sendMessage($event)"
      ></sdk-messaging-conversation>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i3$3.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: ConversationComponent, selector: "sdk-messaging-conversation", inputs: ["conversationDisplayData", "conversation", "loadingConversation", "disabledChatInput", "context", "contextType", "headerType"], outputs: ["emitNewMessage", "emitClose"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationFetchCreateComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-conversation-fetch-create',
                    template: `
    <ng-container *ngrxLet="conversation$ as conversation">
      <sdk-messaging-conversation
        [conversation]="conversation ?? null"
        [conversationDisplayData]="conversationDisplayData"
        [context]="ContextPlacement.View"
        [contextType]="ContextCommunicationType.Conversation"
        [disabledChatInput]="disabledChatInput"
        [headerType]="headerType"
        [loadingConversation]="!(conversationsLoaded$ | async) || startingConversation"
        (emitNewMessage)="sendMessage($event)"
      ></sdk-messaging-conversation>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: ConversationStore }, { type: ConversationMessageStore }, { type: ConversationService }, { type: i0.ChangeDetectorRef }], propDecorators: { conversationDisplayData: [{
                type: Input
            }], newConversationModel: [{
                type: Input
            }], conversationId: [{
                type: Input
            }], headerType: [{
                type: Input
            }], disabledChatInput: [{
                type: Input
            }], newConversationId: [{
                type: Output
            }] } });

class ConversationGroupItemComponent {
    constructor(messagingOperationService, logger, cd) {
        this.messagingOperationService = messagingOperationService;
        this.logger = logger;
        this.cd = cd;
        this.trackById = trackById;
        this.unreadCount = 0;
        this.selected = false;
        this.currentConversationId = null;
        this.darkMode = false;
    }
    ngOnChanges(changes) {
        const { groupItem, currentConversationId } = changes;
        if (groupItem) {
            const groupItemValue = groupItem.currentValue;
            this.groupName = groupItemValue.groupName;
            this.groupSubtitle = groupItemValue.groupSubtitle;
            this.conversations = groupItemValue.conversations;
            this.unreadCount = this.conversations.filter((conversation) => conversation.latestIsUnread).length;
            this.updateSelected();
        }
        // ? Do we want to update dropdown on selection change e.g. if (currentConversationId) this.updateSelected()
        this.cd.detectChanges();
    }
    openConversation(conversation) {
        this.messagingOperationService.navigateToConversation(conversation);
    }
    updateSelected() {
        this.selected = this.conversations.map((conversation) => conversation.id).includes(this.currentConversationId ?? '');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationGroupItemComponent, deps: [{ token: MessagingOperationService }, { token: i1.E11Logger }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationGroupItemComponent, selector: "sdk-conversation-group-item", inputs: { currentConversationId: "currentConversationId", groupItem: "groupItem", config: "config", darkMode: "darkMode" }, usesOnChanges: true, ngImport: i0, template: `
    <ng-container *ngIf="conversations.length === 1 && config?.unGroupSingleConversations">
      <sdk-conversation-nav-item
        [conversation]="conversations[0]"
        [isSelected]="conversations[0].id === currentConversationId"
        [darkMode]="darkMode"
        (click)="openConversation(conversations[0])"
      ></sdk-conversation-nav-item>
    </ng-container>
    <ng-container *ngIf="conversations.length !== 1 || !config?.unGroupSingleConversations">
      <e11-nav-expander [selected]="selected" [expanderContainerClassOverrides]="'e11-text-white hover:e11-bg-skin-grey/30'">
        <ng-template e11Template="expander">
          <div class="e11-relative e11-flex e11-items-center" [attr.title]="groupName">
            <e11-indicator *ngIf="unreadCount > 0" [size]="'xs'" [color]="'white'" [posAdjustX]="'-2px'" [posAdjustY]="'8px'"></e11-indicator>
            <div class="e11-grow e11-line-clamp-1 e11-px-2 e11-break-all" [ngClass]="{ 'e11-font-primary-demibold': unreadCount > 0 }">
              {{ groupName }}
            </div>
          </div>
          <div class="e11-line-clamp-1 e11-px-2 e11-break-all e11-text-xs e11-text-skin-grey" *ngIf="groupSubtitle">{{ groupSubtitle }}</div>
        </ng-template>
        <ng-template e11Template="content">
          <ul class="e11-w-full e11-rounded-b-md e11-mb-2">
            <sdk-conversation-nav-item
              *ngFor="let conversation of conversations ?? []; trackBy: trackById"
              [conversation]="conversation"
              [isSelected]="conversation.id === currentConversationId"
              (click)="openConversation(conversation)"
              [darkMode]="darkMode"
            ></sdk-conversation-nav-item>
          </ul>
        </ng-template>
      </e11-nav-expander>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4$3.E11Template, selector: "[e11Template]", inputs: ["type", "e11Template"] }, { kind: "component", type: i3$6.E11IndicatorComponent, selector: "e11-indicator", inputs: ["color", "size", "classOverrides", "posAdjustY", "posAdjustX"] }, { kind: "component", type: i6$3.E11NavExpanderComponent, selector: "e11-nav-expander", inputs: ["selected", "expanderContainerClassOverrides", "expanderContainerNgClass"], outputs: ["expanderClick"] }, { kind: "component", type: ConversationNavItemComponent, selector: "sdk-conversation-nav-item", inputs: ["conversation", "isSelected", "darkMode"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationGroupItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-conversation-group-item', template: `
    <ng-container *ngIf="conversations.length === 1 && config?.unGroupSingleConversations">
      <sdk-conversation-nav-item
        [conversation]="conversations[0]"
        [isSelected]="conversations[0].id === currentConversationId"
        [darkMode]="darkMode"
        (click)="openConversation(conversations[0])"
      ></sdk-conversation-nav-item>
    </ng-container>
    <ng-container *ngIf="conversations.length !== 1 || !config?.unGroupSingleConversations">
      <e11-nav-expander [selected]="selected" [expanderContainerClassOverrides]="'e11-text-white hover:e11-bg-skin-grey/30'">
        <ng-template e11Template="expander">
          <div class="e11-relative e11-flex e11-items-center" [attr.title]="groupName">
            <e11-indicator *ngIf="unreadCount > 0" [size]="'xs'" [color]="'white'" [posAdjustX]="'-2px'" [posAdjustY]="'8px'"></e11-indicator>
            <div class="e11-grow e11-line-clamp-1 e11-px-2 e11-break-all" [ngClass]="{ 'e11-font-primary-demibold': unreadCount > 0 }">
              {{ groupName }}
            </div>
          </div>
          <div class="e11-line-clamp-1 e11-px-2 e11-break-all e11-text-xs e11-text-skin-grey" *ngIf="groupSubtitle">{{ groupSubtitle }}</div>
        </ng-template>
        <ng-template e11Template="content">
          <ul class="e11-w-full e11-rounded-b-md e11-mb-2">
            <sdk-conversation-nav-item
              *ngFor="let conversation of conversations ?? []; trackBy: trackById"
              [conversation]="conversation"
              [isSelected]="conversation.id === currentConversationId"
              (click)="openConversation(conversation)"
              [darkMode]="darkMode"
            ></sdk-conversation-nav-item>
          </ul>
        </ng-template>
      </e11-nav-expander>
    </ng-container>
  ` }]
        }], ctorParameters: () => [{ type: MessagingOperationService }, { type: i1.E11Logger }, { type: i0.ChangeDetectorRef }], propDecorators: { currentConversationId: [{
                type: Input
            }], groupItem: [{
                type: Input
            }], config: [{
                type: Input
            }], darkMode: [{
                type: Input
            }] } });

/**
 * Shortcoming - what you group by and what you display might not want to be the same thing - e.g. grouping by a non-unique display name might result in inaccurate groupings
 * ? Styling may need to be removed from list and brought into the parent
 */
class ConversationGroupNavComponent {
    constructor(messagingStore, messagingOperationService) {
        this.messagingStore = messagingStore;
        this.messagingOperationService = messagingOperationService;
        this.darkMode = false;
        this.emptyStateSubtitle = 'This is where you get messages';
        this.conversationsLoaded$ = this.messagingStore.getConversationsLoaded;
        this.currentConversationId$ = this.messagingStore.currentConversationId$;
    }
    ngOnInit() {
        this.conversationGroups$ = this.messagingStore.queryConversationsGrouped({
            groupFn: this.groupFn,
            groupNameFn: this.groupNameFn,
            groupSubtitleFn: this.groupSubtitleFn,
            types: this.types,
            customFilter: this.conversationFilter,
        });
    }
    openConversation(conversation) {
        this.messagingOperationService.navigateToConversation(conversation);
    }
    trackBy(_index, groupItem) {
        return groupItem.id;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationGroupNavComponent, deps: [{ token: ConversationStore }, { token: MessagingOperationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConversationGroupNavComponent, selector: "sdk-conversation-group-nav", inputs: { groupFn: "groupFn", groupNameFn: "groupNameFn", groupSubtitleFn: "groupSubtitleFn", types: "types", darkMode: "darkMode", emptyStateSubtitle: "emptyStateSubtitle", conversationFilter: "conversationFilter", config: "config" }, ngImport: i0, template: `
    <ng-container *ngrxLet="conversationsLoaded$ as loaded">
      <ng-container *ngrxLet="conversationGroups$ as conversationGroups">
        <ul role="list" class="e11-overflow-y-auto e11-max-h-[75vh]" *ngrxLet="currentConversationId$ as currentConversationId">
          <sdk-conversation-group-item
            *ngFor="let groupItem of conversationGroups ?? []; trackBy: trackBy"
            [config]="config"
            [groupItem]="groupItem"
            [darkMode]="darkMode"
            [currentConversationId]="currentConversationId"
          ></sdk-conversation-group-item>
          <li *ngIf="loaded && conversationGroups?.length === 0" class="e11-py-4 e11-px-4 e11-rounded-md">
            <sdk-conversation-nav-empty [darkMode]="darkMode" [emptyStateSubtitle]="emptyStateSubtitle"></sdk-conversation-nav-empty>
          </li>
          <li *ngIf="!loaded" class="e11-py-4 e11-px-4 e11-rounded-md">
            <e11-loader-dots [size]="'sm'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
          </li>
        </ul>
      </ng-container>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "directive", type: i3$3.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: ConversationNavEmptyComponent, selector: "sdk-conversation-nav-empty", inputs: ["darkMode", "emptyStateSubtitle"] }, { kind: "component", type: ConversationGroupItemComponent, selector: "sdk-conversation-group-item", inputs: ["currentConversationId", "groupItem", "config", "darkMode"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationGroupNavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-conversation-group-nav', template: `
    <ng-container *ngrxLet="conversationsLoaded$ as loaded">
      <ng-container *ngrxLet="conversationGroups$ as conversationGroups">
        <ul role="list" class="e11-overflow-y-auto e11-max-h-[75vh]" *ngrxLet="currentConversationId$ as currentConversationId">
          <sdk-conversation-group-item
            *ngFor="let groupItem of conversationGroups ?? []; trackBy: trackBy"
            [config]="config"
            [groupItem]="groupItem"
            [darkMode]="darkMode"
            [currentConversationId]="currentConversationId"
          ></sdk-conversation-group-item>
          <li *ngIf="loaded && conversationGroups?.length === 0" class="e11-py-4 e11-px-4 e11-rounded-md">
            <sdk-conversation-nav-empty [darkMode]="darkMode" [emptyStateSubtitle]="emptyStateSubtitle"></sdk-conversation-nav-empty>
          </li>
          <li *ngIf="!loaded" class="e11-py-4 e11-px-4 e11-rounded-md">
            <e11-loader-dots [size]="'sm'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
          </li>
        </ul>
      </ng-container>
    </ng-container>
  ` }]
        }], ctorParameters: () => [{ type: ConversationStore }, { type: MessagingOperationService }], propDecorators: { groupFn: [{
                type: Input
            }], groupNameFn: [{
                type: Input
            }], groupSubtitleFn: [{
                type: Input
            }], types: [{
                type: Input
            }], darkMode: [{
                type: Input
            }], emptyStateSubtitle: [{
                type: Input
            }], conversationFilter: [{
                type: Input
            }], config: [{
                type: Input
            }] } });

// ! Only add to declare exports if it's needed externally
const DeclareExportComponents = [
    MessagesEnvelopeComponent,
    MessagesListComponent,
    ConversationComponent,
    DirectMessagesComponent,
    ConversationCreateComponent,
    ConversationNavComponent,
    ConversationFetchComponent,
    ConversationSideOverComponent,
    ConversationFetchCreateComponent,
    ConversationGroupNavComponent,
    ConversationLineItemComponent,
];
class ConversationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: ConversationModule, declarations: [MessagesEnvelopeComponent,
            MessagesListComponent,
            ConversationComponent,
            DirectMessagesComponent,
            ConversationCreateComponent,
            ConversationNavComponent,
            ConversationFetchComponent,
            ConversationSideOverComponent,
            ConversationFetchCreateComponent,
            ConversationGroupNavComponent,
            ConversationLineItemComponent, ConversationNavItemComponent,
            UIMessagesEnvelopeComponent,
            ConversationNavEmptyComponent,
            ConversationGroupItemComponent,
            AutocompleteFnPipe], imports: [CommonModule, SharedModule, MessageModule], exports: [MessagesEnvelopeComponent,
            MessagesListComponent,
            ConversationComponent,
            DirectMessagesComponent,
            ConversationCreateComponent,
            ConversationNavComponent,
            ConversationFetchComponent,
            ConversationSideOverComponent,
            ConversationFetchCreateComponent,
            ConversationGroupNavComponent,
            ConversationLineItemComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationModule, imports: [CommonModule, SharedModule, MessageModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ...DeclareExportComponents,
                        ConversationNavItemComponent,
                        UIMessagesEnvelopeComponent,
                        ConversationNavEmptyComponent,
                        ConversationGroupItemComponent,
                        AutocompleteFnPipe,
                    ],
                    imports: [CommonModule, SharedModule, MessageModule],
                    exports: [...DeclareExportComponents],
                }]
        }] });

// Default config for direct messages the messaging SDK provides out of the box
class DirectMessageConversationConfigProvider extends BaseConversationConfigProvider {
    constructor() {
        super(...arguments);
        this.conversationType = CONVERSATION_TYPES.DIRECT_MESSAGE;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DirectMessageConversationConfigProvider, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DirectMessageConversationConfigProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DirectMessageConversationConfigProvider, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

const providers = [ConversationRepository, MessageRepository];
const ImportExportModules = [MessageModule, ConversationModule, MarkdownModule];
const DECLARE_EXPORT_COMPONENTS = [MessagingContainerComponent, ConversationContainerComponent, NewConversationContainerComponent];
class MessagingModule {
    static { this.defaultConfiguration = {
        conversationCustomDataProvider: BaseConversationCustomDataProvider,
        conversationConfigProviders: [DirectMessageConversationConfigProvider],
        config: {
            provide: MessagingConfigurationProvider,
            useValue: DefaultLibConfiguration,
        },
    }; }
    static forRoot(config) {
        const configToUse = { ...this.defaultConfiguration, ...config };
        return {
            ngModule: MessagingModule,
            providers: [
                ConversationService,
                VoiceToSpeechService,
                configToUse.conversationConfigProviders.map(transform),
                configToUse.config || {
                    provide: MessagingConfigurationProvider,
                    useValue: DefaultLibConfiguration,
                },
                {
                    provide: CONVERSATION_CUSTOM_DATA_HANDLER,
                    useClass: configToUse.conversationCustomDataProvider,
                },
                {
                    provide: CacheRepository,
                    useValue: configToUse.cacheDBName ? cacheRepository(configToUse.cacheDBName) : undefined,
                },
            ],
        };
    }
    constructor(cacheRepository) {
        cacheRepository?.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingModule, deps: [{ token: i1$7.CacheRepository, optional: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: MessagingModule, declarations: [MessagingContainerComponent, ConversationContainerComponent, NewConversationContainerComponent], imports: [MessageModule, ConversationModule, MarkdownModule, SharedModule, CommonModule, RouterModule, MessagingRoutingModule], exports: [MessageModule, ConversationModule, MarkdownModule, MessagingContainerComponent, ConversationContainerComponent, NewConversationContainerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingModule, providers: [...providers], imports: [ImportExportModules, SharedModule, CommonModule, RouterModule, MessagingRoutingModule, MessageModule, ConversationModule, MarkdownModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MessagingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...DECLARE_EXPORT_COMPONENTS],
                    imports: [...ImportExportModules, SharedModule, CommonModule, RouterModule, MessagingRoutingModule],
                    providers: [...providers],
                    exports: [...ImportExportModules, ...DECLARE_EXPORT_COMPONENTS],
                }]
        }], ctorParameters: () => [{ type: i1$7.CacheRepository, decorators: [{
                    type: Optional
                }] }] });
const transform = (conversationConfigProvider) => ({
    multi: true,
    provide: APP_CONVERSATION_CONFIG_PROVIDER_TOKEN,
    useClass: conversationConfigProvider,
});
const cacheRepository = (name) => new (class extends CacheRepository {
    ngOnDestroy() {
        this.tearDown();
    }
})(name);

/**
 * Generated bundle index. Do not edit.
 */

export { APP_CONVERSATION_CONFIG_PROVIDER_TOKEN, BaseConversationConfigProvider, BaseConversationCustomDataProvider, BaseMessageStore, COLLECTIONS, CONVERSATION_CUSTOM_DATA_HANDLER, CONVERSATION_DROPDOWN_COUNT, CONVERSATION_NAV_COUNT, CONVERSATION_TYPES, CommunitiesMainPage, CommunitySettingsPage, ContextCommunicationType, ContextPlacement, ConversationComponent, ConversationContainerComponent, ConversationCreateComponent, ConversationFetchComponent, ConversationFetchCreateComponent, ConversationGroupNavComponent, ConversationHeaderType, ConversationImageComponent, ConversationLineItemComponent, ConversationMessageStore, ConversationModule, ConversationNavComponent, ConversationRepository, ConversationService, ConversationSideOverComponent, ConversationSideOverService, ConversationStore, ConversationViewModelService, DEFAULT_CONVERSATION_TYPE, DEFAULT_MESSAGE_CONFIG, DEFAULT_MESSAGE_PAGE_SIZE, DEFAULT_MESSAGE_TYPE, DefaultLibConfiguration, DirectMessageConversationConfigProvider, DirectMessagesComponent, ERROR_TYPES, MESSAGING_CONFIG, MESSAGING_EDITOR_CONFIG, MESSAGING_NOTIFICATION_IDS, MessageAvatarClickHandlerDirective, MessageConfiguration, MessageModule, MessageRepository, MessageStatus, MessageType, MessagesEnvelopeComponent, MessagesListComponent, MessagingConfigurationProvider, MessagingContainerComponent, MessagingModule, MessagingNavigationService, MessagingOperationService, NewConversationContainerComponent, PENDING_MESSAGE_ID, ParticipantNamesPipe, REACTION_HOVER_LIMIT, REACTION_PAGE_SIZE, UIMessageMarkdownComponent, UIMessagesComponent, UIMessagesEnvelopeComponent, UIMessagingAvatarComponent, UNREAD_CONVERSATIONS_LIMIT, UiMessagesParticipantsComponent, UiMessagesRecentMessageDateComponent, VoiceToSpeechService, buildMessageVM, buildPendingMessage, defaultConversationTypeConfig, generateConversationId, getMentionsFromText, getSystemParticipantFallback, getUnknownParticipantFallback, getViewMessagesFromData, isRetryableError, mapMentions, messageReactionOptions, openConversationFilter, unreadConversationFilter };
